import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string | Date; output: string | Date; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Access = {
  __typename?: 'Access';
  _count?: Maybe<AccessCount>;
  address: Address;
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  carrierProduct: CarrierProduct;
  carrierProductId: Scalars['Int']['output'];
  dialups: Array<AccessDialup>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incidents: Array<Incident>;
  ip: Scalars['String']['output'];
  lineDiagnoses: Array<LineDiagnosis>;
  lineResets: Array<LineReset>;
  online: Scalars['Boolean']['output'];
  orderAccess: OrderAccess;
  orderAccessId: Scalars['Int']['output'];
  password: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  traffics: Array<AccessTraffic>;
  username: Scalars['String']['output'];
  vlan?: Maybe<Scalars['Int']['output']>;
};


export type AccessDialupsArgs = {
  cursor?: InputMaybe<AccessDialupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessDialupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessDialupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessDialupWhereInput>;
};


export type AccessIncidentsArgs = {
  cursor?: InputMaybe<IncidentWhereUniqueInput>;
  distinct?: InputMaybe<Array<IncidentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IncidentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IncidentWhereInput>;
};


export type AccessLineDiagnosesArgs = {
  cursor?: InputMaybe<LineDiagnosisWhereUniqueInput>;
  distinct?: InputMaybe<Array<LineDiagnosisScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LineDiagnosisOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LineDiagnosisWhereInput>;
};


export type AccessLineResetsArgs = {
  cursor?: InputMaybe<LineResetWhereUniqueInput>;
  distinct?: InputMaybe<Array<LineResetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LineResetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LineResetWhereInput>;
};


export type AccessTrafficsArgs = {
  cursor?: InputMaybe<AccessTrafficWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessTrafficScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessTrafficOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessTrafficWhereInput>;
};

export type AccessCount = {
  __typename?: 'AccessCount';
  dialups: Scalars['Int']['output'];
  incidents: Scalars['Int']['output'];
  lineDiagnoses: Scalars['Int']['output'];
  lineResets: Scalars['Int']['output'];
  traffics: Scalars['Int']['output'];
};


export type AccessCountDialupsArgs = {
  where?: InputMaybe<AccessDialupWhereInput>;
};


export type AccessCountIncidentsArgs = {
  where?: InputMaybe<IncidentWhereInput>;
};


export type AccessCountLineDiagnosesArgs = {
  where?: InputMaybe<LineDiagnosisWhereInput>;
};


export type AccessCountLineResetsArgs = {
  where?: InputMaybe<LineResetWhereInput>;
};


export type AccessCountTrafficsArgs = {
  where?: InputMaybe<AccessTrafficWhereInput>;
};

export type AccessCreateManyCarrierProductInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip: Scalars['String']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderAccessId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateManyCarrierProductInputEnvelope = {
  data: Array<AccessCreateManyCarrierProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccessCreateManyOrderAccessInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProductId: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip: Scalars['String']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateManyOrderAccessInputEnvelope = {
  data: Array<AccessCreateManyOrderAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccessCreateNestedManyWithoutCarrierProductInput = {
  connect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<AccessCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<AccessCreateManyCarrierProductInputEnvelope>;
};

export type AccessCreateNestedManyWithoutOrderAccessInput = {
  connect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessCreateOrConnectWithoutOrderAccessInput>>;
  create?: InputMaybe<Array<AccessCreateWithoutOrderAccessInput>>;
  createMany?: InputMaybe<AccessCreateManyOrderAccessInputEnvelope>;
};

export type AccessCreateNestedOneWithoutIncidentsInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<AccessCreateWithoutIncidentsInput>;
};

export type AccessCreateNestedOneWithoutLineDiagnosesInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutLineDiagnosesInput>;
  create?: InputMaybe<AccessCreateWithoutLineDiagnosesInput>;
};

export type AccessCreateNestedOneWithoutLineResetsInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutLineResetsInput>;
  create?: InputMaybe<AccessCreateWithoutLineResetsInput>;
};

export type AccessCreateOrConnectWithoutCarrierProductInput = {
  create: AccessCreateWithoutCarrierProductInput;
  where: AccessWhereUniqueInput;
};

export type AccessCreateOrConnectWithoutIncidentsInput = {
  create: AccessCreateWithoutIncidentsInput;
  where: AccessWhereUniqueInput;
};

export type AccessCreateOrConnectWithoutLineDiagnosesInput = {
  create: AccessCreateWithoutLineDiagnosesInput;
  where: AccessWhereUniqueInput;
};

export type AccessCreateOrConnectWithoutLineResetsInput = {
  create: AccessCreateWithoutLineResetsInput;
  where: AccessWhereUniqueInput;
};

export type AccessCreateOrConnectWithoutOrderAccessInput = {
  create: AccessCreateWithoutOrderAccessInput;
  where: AccessWhereUniqueInput;
};

export type AccessCreateWithoutCarrierProductInput = {
  address: AddressCreateNestedOneWithoutAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  dialups?: InputMaybe<AccessDialupCreateNestedManyWithoutAccessInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutAccessInput>;
  ip: Scalars['String']['input'];
  lineDiagnoses?: InputMaybe<LineDiagnosisCreateNestedManyWithoutAccessInput>;
  lineResets?: InputMaybe<LineResetCreateNestedManyWithoutAccessInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderAccess: OrderAccessCreateNestedOneWithoutAccessesInput;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  traffics?: InputMaybe<AccessTrafficCreateNestedManyWithoutAccessInput>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateWithoutIncidentsInput = {
  address: AddressCreateNestedOneWithoutAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProduct: CarrierProductCreateNestedOneWithoutAccessesInput;
  dialups?: InputMaybe<AccessDialupCreateNestedManyWithoutAccessInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  ip: Scalars['String']['input'];
  lineDiagnoses?: InputMaybe<LineDiagnosisCreateNestedManyWithoutAccessInput>;
  lineResets?: InputMaybe<LineResetCreateNestedManyWithoutAccessInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderAccess: OrderAccessCreateNestedOneWithoutAccessesInput;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  traffics?: InputMaybe<AccessTrafficCreateNestedManyWithoutAccessInput>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateWithoutLineDiagnosesInput = {
  address: AddressCreateNestedOneWithoutAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProduct: CarrierProductCreateNestedOneWithoutAccessesInput;
  dialups?: InputMaybe<AccessDialupCreateNestedManyWithoutAccessInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutAccessInput>;
  ip: Scalars['String']['input'];
  lineResets?: InputMaybe<LineResetCreateNestedManyWithoutAccessInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderAccess: OrderAccessCreateNestedOneWithoutAccessesInput;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  traffics?: InputMaybe<AccessTrafficCreateNestedManyWithoutAccessInput>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateWithoutLineResetsInput = {
  address: AddressCreateNestedOneWithoutAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProduct: CarrierProductCreateNestedOneWithoutAccessesInput;
  dialups?: InputMaybe<AccessDialupCreateNestedManyWithoutAccessInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutAccessInput>;
  ip: Scalars['String']['input'];
  lineDiagnoses?: InputMaybe<LineDiagnosisCreateNestedManyWithoutAccessInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderAccess: OrderAccessCreateNestedOneWithoutAccessesInput;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  traffics?: InputMaybe<AccessTrafficCreateNestedManyWithoutAccessInput>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessCreateWithoutOrderAccessInput = {
  address: AddressCreateNestedOneWithoutAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProduct: CarrierProductCreateNestedOneWithoutAccessesInput;
  dialups?: InputMaybe<AccessDialupCreateNestedManyWithoutAccessInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutAccessInput>;
  ip: Scalars['String']['input'];
  lineDiagnoses?: InputMaybe<LineDiagnosisCreateNestedManyWithoutAccessInput>;
  lineResets?: InputMaybe<LineResetCreateNestedManyWithoutAccessInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  traffics?: InputMaybe<AccessTrafficCreateNestedManyWithoutAccessInput>;
  username: Scalars['String']['input'];
  vlan?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessDialup = {
  __typename?: 'AccessDialup';
  accessId: Scalars['Int']['output'];
  date: Scalars['DateTimeISO']['output'];
  lns: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccessDialupAccessIdDateCompoundUniqueInput = {
  accessId: Scalars['Int']['input'];
  date: Scalars['DateTimeISO']['input'];
};

export type AccessDialupCreateManyAccessInput = {
  date: Scalars['DateTimeISO']['input'];
  lns: Scalars['Int']['input'];
  success: Scalars['Boolean']['input'];
};

export type AccessDialupCreateManyAccessInputEnvelope = {
  data: Array<AccessDialupCreateManyAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccessDialupCreateNestedManyWithoutAccessInput = {
  connect?: InputMaybe<Array<AccessDialupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessDialupCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<AccessDialupCreateWithoutAccessInput>>;
  createMany?: InputMaybe<AccessDialupCreateManyAccessInputEnvelope>;
};

export type AccessDialupCreateOrConnectWithoutAccessInput = {
  create: AccessDialupCreateWithoutAccessInput;
  where: AccessDialupWhereUniqueInput;
};

export type AccessDialupCreateWithoutAccessInput = {
  date: Scalars['DateTimeISO']['input'];
  lns: Scalars['Int']['input'];
  success: Scalars['Boolean']['input'];
};

export type AccessDialupListRelationFilter = {
  every?: InputMaybe<AccessDialupWhereInput>;
  none?: InputMaybe<AccessDialupWhereInput>;
  some?: InputMaybe<AccessDialupWhereInput>;
};

export type AccessDialupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessDialupOrderByWithRelationInput = {
  access?: InputMaybe<AccessOrderByWithRelationInput>;
  accessId?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  lns?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export enum AccessDialupScalarFieldEnum {
  AccessId = 'accessId',
  Date = 'date',
  Lns = 'lns',
  Success = 'success'
}

export type AccessDialupScalarWhereInput = {
  AND?: InputMaybe<Array<AccessDialupScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccessDialupScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessDialupScalarWhereInput>>;
  accessId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  lns?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type AccessDialupUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  lns?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AccessDialupUpdateManyWithWhereWithoutAccessInput = {
  data: AccessDialupUpdateManyMutationInput;
  where: AccessDialupScalarWhereInput;
};

export type AccessDialupUpdateManyWithoutAccessNestedInput = {
  connect?: InputMaybe<Array<AccessDialupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessDialupCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<AccessDialupCreateWithoutAccessInput>>;
  createMany?: InputMaybe<AccessDialupCreateManyAccessInputEnvelope>;
  delete?: InputMaybe<Array<AccessDialupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessDialupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessDialupWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessDialupWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessDialupUpdateWithWhereUniqueWithoutAccessInput>>;
  updateMany?: InputMaybe<Array<AccessDialupUpdateManyWithWhereWithoutAccessInput>>;
  upsert?: InputMaybe<Array<AccessDialupUpsertWithWhereUniqueWithoutAccessInput>>;
};

export type AccessDialupUpdateWithWhereUniqueWithoutAccessInput = {
  data: AccessDialupUpdateWithoutAccessInput;
  where: AccessDialupWhereUniqueInput;
};

export type AccessDialupUpdateWithoutAccessInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  lns?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AccessDialupUpsertWithWhereUniqueWithoutAccessInput = {
  create: AccessDialupCreateWithoutAccessInput;
  update: AccessDialupUpdateWithoutAccessInput;
  where: AccessDialupWhereUniqueInput;
};

export type AccessDialupWhereInput = {
  AND?: InputMaybe<Array<AccessDialupWhereInput>>;
  NOT?: InputMaybe<Array<AccessDialupWhereInput>>;
  OR?: InputMaybe<Array<AccessDialupWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  lns?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type AccessDialupWhereUniqueInput = {
  AND?: InputMaybe<Array<AccessDialupWhereInput>>;
  NOT?: InputMaybe<Array<AccessDialupWhereInput>>;
  OR?: InputMaybe<Array<AccessDialupWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  accessId_date?: InputMaybe<AccessDialupAccessIdDateCompoundUniqueInput>;
  date?: InputMaybe<DateTimeFilter>;
  lns?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type AccessListRelationFilter = {
  every?: InputMaybe<AccessWhereInput>;
  none?: InputMaybe<AccessWhereInput>;
  some?: InputMaybe<AccessWhereInput>;
};

export type AccessNullableRelationFilter = {
  is?: InputMaybe<AccessWhereInput>;
  isNot?: InputMaybe<AccessWhereInput>;
};

export type AccessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  carrierProduct?: InputMaybe<CarrierProductOrderByWithRelationInput>;
  carrierProductId?: InputMaybe<SortOrder>;
  dialups?: InputMaybe<AccessDialupOrderByRelationAggregateInput>;
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  incidents?: InputMaybe<IncidentOrderByRelationAggregateInput>;
  ip?: InputMaybe<SortOrder>;
  lineDiagnoses?: InputMaybe<LineDiagnosisOrderByRelationAggregateInput>;
  lineResets?: InputMaybe<LineResetOrderByRelationAggregateInput>;
  online?: InputMaybe<SortOrder>;
  orderAccess?: InputMaybe<OrderAccessOrderByWithRelationInput>;
  orderAccessId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  route?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrderInput>;
  traffics?: InputMaybe<AccessTrafficOrderByRelationAggregateInput>;
  username?: InputMaybe<SortOrder>;
  vlan?: InputMaybe<SortOrderInput>;
};

export type AccessOrderCompleteType = {
  customerContactEMail?: InputMaybe<Scalars['String']['input']>;
  customerContactFirstname?: InputMaybe<Scalars['String']['input']>;
  customerContactLastname?: InputMaybe<Scalars['String']['input']>;
  customerContactPhone?: InputMaybe<Scalars['String']['input']>;
  customerContactSalutation?: InputMaybe<Scalars['String']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEMail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZIP?: InputMaybe<Scalars['String']['input']>;
  orderAccessId: Scalars['Float']['input'];
  orderType: Scalars['String']['input'];
};

export type AccessRelationFilter = {
  is?: InputMaybe<AccessWhereInput>;
  isNot?: InputMaybe<AccessWhereInput>;
};

export enum AccessScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  CarrierProductId = 'carrierProductId',
  ExternalId = 'externalId',
  Id = 'id',
  Ip = 'ip',
  Online = 'online',
  OrderAccessId = 'orderAccessId',
  Password = 'password',
  Route = 'route',
  StartDate = 'startDate',
  Username = 'username',
  Vlan = 'vlan'
}

export type AccessScalarWhereInput = {
  AND?: InputMaybe<Array<AccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccessScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessScalarWhereInput>>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ip?: InputMaybe<StringFilter>;
  online?: InputMaybe<BoolFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
  password?: InputMaybe<StringFilter>;
  route?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  username?: InputMaybe<StringFilter>;
  vlan?: InputMaybe<IntNullableFilter>;
};

export type AccessTraffic = {
  __typename?: 'AccessTraffic';
  accessId: Scalars['Int']['output'];
  date: Scalars['DateTimeISO']['output'];
  kbytesIn: Scalars['BigInt']['output'];
  kbytesOut: Scalars['BigInt']['output'];
};

export type AccessTrafficAccessIdDateCompoundUniqueInput = {
  accessId: Scalars['Int']['input'];
  date: Scalars['DateTimeISO']['input'];
};

export type AccessTrafficCreateManyAccessInput = {
  date: Scalars['DateTimeISO']['input'];
  kbytesIn: Scalars['BigInt']['input'];
  kbytesOut: Scalars['BigInt']['input'];
};

export type AccessTrafficCreateManyAccessInputEnvelope = {
  data: Array<AccessTrafficCreateManyAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccessTrafficCreateNestedManyWithoutAccessInput = {
  connect?: InputMaybe<Array<AccessTrafficWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessTrafficCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<AccessTrafficCreateWithoutAccessInput>>;
  createMany?: InputMaybe<AccessTrafficCreateManyAccessInputEnvelope>;
};

export type AccessTrafficCreateOrConnectWithoutAccessInput = {
  create: AccessTrafficCreateWithoutAccessInput;
  where: AccessTrafficWhereUniqueInput;
};

export type AccessTrafficCreateWithoutAccessInput = {
  date: Scalars['DateTimeISO']['input'];
  kbytesIn: Scalars['BigInt']['input'];
  kbytesOut: Scalars['BigInt']['input'];
};

export type AccessTrafficListRelationFilter = {
  every?: InputMaybe<AccessTrafficWhereInput>;
  none?: InputMaybe<AccessTrafficWhereInput>;
  some?: InputMaybe<AccessTrafficWhereInput>;
};

export type AccessTrafficOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessTrafficOrderByWithRelationInput = {
  access?: InputMaybe<AccessOrderByWithRelationInput>;
  accessId?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  kbytesIn?: InputMaybe<SortOrder>;
  kbytesOut?: InputMaybe<SortOrder>;
};

export enum AccessTrafficScalarFieldEnum {
  AccessId = 'accessId',
  Date = 'date',
  KbytesIn = 'kbytesIn',
  KbytesOut = 'kbytesOut'
}

export type AccessTrafficScalarWhereInput = {
  AND?: InputMaybe<Array<AccessTrafficScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccessTrafficScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessTrafficScalarWhereInput>>;
  accessId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  kbytesIn?: InputMaybe<BigIntFilter>;
  kbytesOut?: InputMaybe<BigIntFilter>;
};

export type AccessTrafficUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  kbytesIn?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  kbytesOut?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type AccessTrafficUpdateManyWithWhereWithoutAccessInput = {
  data: AccessTrafficUpdateManyMutationInput;
  where: AccessTrafficScalarWhereInput;
};

export type AccessTrafficUpdateManyWithoutAccessNestedInput = {
  connect?: InputMaybe<Array<AccessTrafficWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessTrafficCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<AccessTrafficCreateWithoutAccessInput>>;
  createMany?: InputMaybe<AccessTrafficCreateManyAccessInputEnvelope>;
  delete?: InputMaybe<Array<AccessTrafficWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessTrafficScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessTrafficWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessTrafficWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessTrafficUpdateWithWhereUniqueWithoutAccessInput>>;
  updateMany?: InputMaybe<Array<AccessTrafficUpdateManyWithWhereWithoutAccessInput>>;
  upsert?: InputMaybe<Array<AccessTrafficUpsertWithWhereUniqueWithoutAccessInput>>;
};

export type AccessTrafficUpdateWithWhereUniqueWithoutAccessInput = {
  data: AccessTrafficUpdateWithoutAccessInput;
  where: AccessTrafficWhereUniqueInput;
};

export type AccessTrafficUpdateWithoutAccessInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  kbytesIn?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  kbytesOut?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type AccessTrafficUpsertWithWhereUniqueWithoutAccessInput = {
  create: AccessTrafficCreateWithoutAccessInput;
  update: AccessTrafficUpdateWithoutAccessInput;
  where: AccessTrafficWhereUniqueInput;
};

export type AccessTrafficWhereInput = {
  AND?: InputMaybe<Array<AccessTrafficWhereInput>>;
  NOT?: InputMaybe<Array<AccessTrafficWhereInput>>;
  OR?: InputMaybe<Array<AccessTrafficWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  kbytesIn?: InputMaybe<BigIntFilter>;
  kbytesOut?: InputMaybe<BigIntFilter>;
};

export type AccessTrafficWhereUniqueInput = {
  AND?: InputMaybe<Array<AccessTrafficWhereInput>>;
  NOT?: InputMaybe<Array<AccessTrafficWhereInput>>;
  OR?: InputMaybe<Array<AccessTrafficWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  accessId_date?: InputMaybe<AccessTrafficAccessIdDateCompoundUniqueInput>;
  date?: InputMaybe<DateTimeFilter>;
  kbytesIn?: InputMaybe<BigIntFilter>;
  kbytesOut?: InputMaybe<BigIntFilter>;
};

export type AccessUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpdateManyWithWhereWithoutCarrierProductInput = {
  data: AccessUpdateManyMutationInput;
  where: AccessScalarWhereInput;
};

export type AccessUpdateManyWithWhereWithoutOrderAccessInput = {
  data: AccessUpdateManyMutationInput;
  where: AccessScalarWhereInput;
};

export type AccessUpdateManyWithoutCarrierProductNestedInput = {
  connect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<AccessCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<AccessCreateManyCarrierProductInputEnvelope>;
  delete?: InputMaybe<Array<AccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessUpdateWithWhereUniqueWithoutCarrierProductInput>>;
  updateMany?: InputMaybe<Array<AccessUpdateManyWithWhereWithoutCarrierProductInput>>;
  upsert?: InputMaybe<Array<AccessUpsertWithWhereUniqueWithoutCarrierProductInput>>;
};

export type AccessUpdateManyWithoutOrderAccessNestedInput = {
  connect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessCreateOrConnectWithoutOrderAccessInput>>;
  create?: InputMaybe<Array<AccessCreateWithoutOrderAccessInput>>;
  createMany?: InputMaybe<AccessCreateManyOrderAccessInputEnvelope>;
  delete?: InputMaybe<Array<AccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessUpdateWithWhereUniqueWithoutOrderAccessInput>>;
  updateMany?: InputMaybe<Array<AccessUpdateManyWithWhereWithoutOrderAccessInput>>;
  upsert?: InputMaybe<Array<AccessUpsertWithWhereUniqueWithoutOrderAccessInput>>;
};

export type AccessUpdateOneRequiredWithoutLineDiagnosesNestedInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutLineDiagnosesInput>;
  create?: InputMaybe<AccessCreateWithoutLineDiagnosesInput>;
  update?: InputMaybe<AccessUpdateToOneWithWhereWithoutLineDiagnosesInput>;
  upsert?: InputMaybe<AccessUpsertWithoutLineDiagnosesInput>;
};

export type AccessUpdateOneRequiredWithoutLineResetsNestedInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutLineResetsInput>;
  create?: InputMaybe<AccessCreateWithoutLineResetsInput>;
  update?: InputMaybe<AccessUpdateToOneWithWhereWithoutLineResetsInput>;
  upsert?: InputMaybe<AccessUpsertWithoutLineResetsInput>;
};

export type AccessUpdateOneWithoutIncidentsNestedInput = {
  connect?: InputMaybe<AccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<AccessCreateWithoutIncidentsInput>;
  delete?: InputMaybe<AccessWhereInput>;
  disconnect?: InputMaybe<AccessWhereInput>;
  update?: InputMaybe<AccessUpdateToOneWithWhereWithoutIncidentsInput>;
  upsert?: InputMaybe<AccessUpsertWithoutIncidentsInput>;
};

export type AccessUpdateToOneWithWhereWithoutIncidentsInput = {
  data: AccessUpdateWithoutIncidentsInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessUpdateToOneWithWhereWithoutLineDiagnosesInput = {
  data: AccessUpdateWithoutLineDiagnosesInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessUpdateToOneWithWhereWithoutLineResetsInput = {
  data: AccessUpdateWithoutLineResetsInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessUpdateWithWhereUniqueWithoutCarrierProductInput = {
  data: AccessUpdateWithoutCarrierProductInput;
  where: AccessWhereUniqueInput;
};

export type AccessUpdateWithWhereUniqueWithoutOrderAccessInput = {
  data: AccessUpdateWithoutOrderAccessInput;
  where: AccessWhereUniqueInput;
};

export type AccessUpdateWithoutCarrierProductInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dialups?: InputMaybe<AccessDialupUpdateManyWithoutAccessNestedInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutAccessNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineDiagnoses?: InputMaybe<LineDiagnosisUpdateManyWithoutAccessNestedInput>;
  lineResets?: InputMaybe<LineResetUpdateManyWithoutAccessNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderAccess?: InputMaybe<OrderAccessUpdateOneRequiredWithoutAccessesNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  traffics?: InputMaybe<AccessTrafficUpdateManyWithoutAccessNestedInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpdateWithoutIncidentsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutAccessesNestedInput>;
  dialups?: InputMaybe<AccessDialupUpdateManyWithoutAccessNestedInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineDiagnoses?: InputMaybe<LineDiagnosisUpdateManyWithoutAccessNestedInput>;
  lineResets?: InputMaybe<LineResetUpdateManyWithoutAccessNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderAccess?: InputMaybe<OrderAccessUpdateOneRequiredWithoutAccessesNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  traffics?: InputMaybe<AccessTrafficUpdateManyWithoutAccessNestedInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpdateWithoutLineDiagnosesInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutAccessesNestedInput>;
  dialups?: InputMaybe<AccessDialupUpdateManyWithoutAccessNestedInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutAccessNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineResets?: InputMaybe<LineResetUpdateManyWithoutAccessNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderAccess?: InputMaybe<OrderAccessUpdateOneRequiredWithoutAccessesNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  traffics?: InputMaybe<AccessTrafficUpdateManyWithoutAccessNestedInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpdateWithoutLineResetsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutAccessesNestedInput>;
  dialups?: InputMaybe<AccessDialupUpdateManyWithoutAccessNestedInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutAccessNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineDiagnoses?: InputMaybe<LineDiagnosisUpdateManyWithoutAccessNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderAccess?: InputMaybe<OrderAccessUpdateOneRequiredWithoutAccessesNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  traffics?: InputMaybe<AccessTrafficUpdateManyWithoutAccessNestedInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpdateWithoutOrderAccessInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutAccessesNestedInput>;
  dialups?: InputMaybe<AccessDialupUpdateManyWithoutAccessNestedInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutAccessNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineDiagnoses?: InputMaybe<LineDiagnosisUpdateManyWithoutAccessNestedInput>;
  lineResets?: InputMaybe<LineResetUpdateManyWithoutAccessNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  route?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  traffics?: InputMaybe<AccessTrafficUpdateManyWithoutAccessNestedInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vlan?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AccessUpsertWithWhereUniqueWithoutCarrierProductInput = {
  create: AccessCreateWithoutCarrierProductInput;
  update: AccessUpdateWithoutCarrierProductInput;
  where: AccessWhereUniqueInput;
};

export type AccessUpsertWithWhereUniqueWithoutOrderAccessInput = {
  create: AccessCreateWithoutOrderAccessInput;
  update: AccessUpdateWithoutOrderAccessInput;
  where: AccessWhereUniqueInput;
};

export type AccessUpsertWithoutIncidentsInput = {
  create: AccessCreateWithoutIncidentsInput;
  update: AccessUpdateWithoutIncidentsInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessUpsertWithoutLineDiagnosesInput = {
  create: AccessCreateWithoutLineDiagnosesInput;
  update: AccessUpdateWithoutLineDiagnosesInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessUpsertWithoutLineResetsInput = {
  create: AccessCreateWithoutLineResetsInput;
  update: AccessUpdateWithoutLineResetsInput;
  where?: InputMaybe<AccessWhereInput>;
};

export type AccessWhereInput = {
  AND?: InputMaybe<Array<AccessWhereInput>>;
  NOT?: InputMaybe<Array<AccessWhereInput>>;
  OR?: InputMaybe<Array<AccessWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  dialups?: InputMaybe<AccessDialupListRelationFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  ip?: InputMaybe<StringFilter>;
  lineDiagnoses?: InputMaybe<LineDiagnosisListRelationFilter>;
  lineResets?: InputMaybe<LineResetListRelationFilter>;
  online?: InputMaybe<BoolFilter>;
  orderAccess?: InputMaybe<OrderAccessRelationFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
  password?: InputMaybe<StringFilter>;
  route?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  traffics?: InputMaybe<AccessTrafficListRelationFilter>;
  username?: InputMaybe<StringFilter>;
  vlan?: InputMaybe<IntNullableFilter>;
};

export type AccessWhereUniqueInput = {
  AND?: InputMaybe<Array<AccessWhereInput>>;
  NOT?: InputMaybe<Array<AccessWhereInput>>;
  OR?: InputMaybe<Array<AccessWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  dialups?: InputMaybe<AccessDialupListRelationFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  ip?: InputMaybe<StringFilter>;
  lineDiagnoses?: InputMaybe<LineDiagnosisListRelationFilter>;
  lineResets?: InputMaybe<LineResetListRelationFilter>;
  online?: InputMaybe<BoolFilter>;
  orderAccess?: InputMaybe<OrderAccessRelationFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
  password?: InputMaybe<StringFilter>;
  route?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  traffics?: InputMaybe<AccessTrafficListRelationFilter>;
  username?: InputMaybe<StringFilter>;
  vlan?: InputMaybe<IntNullableFilter>;
};

export type Address = {
  __typename?: 'Address';
  _count?: Maybe<AddressCount>;
  accesses: Array<Access>;
  addressSuffix?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  contactPerson: Scalars['String']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  ethernets: Array<Ethernet>;
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isBilling: Scalars['Boolean']['output'];
  ntr?: Maybe<Scalars['String']['output']>;
  orderAccesses: Array<OrderAccess>;
  orderEthernets: Array<OrderEthernet>;
  orderTrunks: Array<OrderTrunk>;
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  subscriberId?: Maybe<Scalars['Int']['output']>;
  trunks: Array<Trunk>;
};


export type AddressAccessesArgs = {
  cursor?: InputMaybe<AccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessWhereInput>;
};


export type AddressEthernetsArgs = {
  cursor?: InputMaybe<EthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<EthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EthernetWhereInput>;
};


export type AddressOrderAccessesArgs = {
  cursor?: InputMaybe<OrderAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type AddressOrderEthernetsArgs = {
  cursor?: InputMaybe<OrderEthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderEthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderEthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type AddressOrderTrunksArgs = {
  cursor?: InputMaybe<OrderTrunkWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderTrunkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderTrunkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type AddressTrunksArgs = {
  cursor?: InputMaybe<TrunkWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrunkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrunkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrunkWhereInput>;
};

export type AddressCount = {
  __typename?: 'AddressCount';
  accesses: Scalars['Int']['output'];
  ethernets: Scalars['Int']['output'];
  orderAccesses: Scalars['Int']['output'];
  orderEthernets: Scalars['Int']['output'];
  orderTrunks: Scalars['Int']['output'];
  trunks: Scalars['Int']['output'];
};


export type AddressCountAccessesArgs = {
  where?: InputMaybe<AccessWhereInput>;
};


export type AddressCountEthernetsArgs = {
  where?: InputMaybe<EthernetWhereInput>;
};


export type AddressCountOrderAccessesArgs = {
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type AddressCountOrderEthernetsArgs = {
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type AddressCountOrderTrunksArgs = {
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type AddressCountTrunksArgs = {
  where?: InputMaybe<TrunkWhereInput>;
};

export type AddressCreateInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateManyCustomerInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateManyCustomerInputEnvelope = {
  data: Array<AddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
};

export type AddressCreateNestedOneWithoutAccessesInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<AddressCreateWithoutAccessesInput>;
};

export type AddressCreateNestedOneWithoutEthernetsInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutEthernetsInput>;
  create?: InputMaybe<AddressCreateWithoutEthernetsInput>;
};

export type AddressCreateNestedOneWithoutOrderAccessesInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderAccessesInput>;
  create?: InputMaybe<AddressCreateWithoutOrderAccessesInput>;
};

export type AddressCreateNestedOneWithoutOrderEthernetsInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderEthernetsInput>;
  create?: InputMaybe<AddressCreateWithoutOrderEthernetsInput>;
};

export type AddressCreateNestedOneWithoutOrderTrunksInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderTrunksInput>;
  create?: InputMaybe<AddressCreateWithoutOrderTrunksInput>;
};

export type AddressCreateNestedOneWithoutTrunksInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutTrunksInput>;
  create?: InputMaybe<AddressCreateWithoutTrunksInput>;
};

export type AddressCreateOrConnectWithoutAccessesInput = {
  create: AddressCreateWithoutAccessesInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutEthernetsInput = {
  create: AddressCreateWithoutEthernetsInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutOrderAccessesInput = {
  create: AddressCreateWithoutOrderAccessesInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutOrderEthernetsInput = {
  create: AddressCreateWithoutOrderEthernetsInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutOrderTrunksInput = {
  create: AddressCreateWithoutOrderTrunksInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutTrunksInput = {
  create: AddressCreateWithoutTrunksInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutAccessesInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutCustomerInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutEthernetsInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutOrderAccessesInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutOrderEthernetsInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutOrderTrunksInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressCreateWithoutTrunksInput = {
  addressSuffix?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  email: Scalars['String']['input'];
  houseNumber: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ntr?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  subscriberId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  addressSuffix?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrder>;
  contactPerson?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isBilling?: InputMaybe<SortOrder>;
  ntr?: InputMaybe<SortOrderInput>;
  phone?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  subscriberId?: InputMaybe<SortOrderInput>;
};

export type AddressRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export enum AddressScalarFieldEnum {
  AddressSuffix = 'addressSuffix',
  City = 'city',
  ContactPerson = 'contactPerson',
  CustomerId = 'customerId',
  Email = 'email',
  HouseNumber = 'houseNumber',
  Id = 'id',
  IsBilling = 'isBilling',
  Ntr = 'ntr',
  Phone = 'phone',
  PostalCode = 'postalCode',
  Street = 'street',
  SubscriberId = 'subscriberId'
}

export type AddressScalarWhereInput = {
  AND?: InputMaybe<Array<AddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereInput>>;
  addressSuffix?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  contactPerson?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  houseNumber?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isBilling?: InputMaybe<BoolFilter>;
  ntr?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  subscriberId?: InputMaybe<IntNullableFilter>;
};

export type AddressStreetHouseNumberAddressSuffixPostalCodeCityContactPersonCustomerIdCompoundUniqueInput = {
  addressSuffix: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  houseNumber: Scalars['Int']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type AddressUpdateManyMutationInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateManyWithWhereWithoutCustomerInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type AddressUpdateOneRequiredWithoutAccessesNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<AddressCreateWithoutAccessesInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutAccessesInput>;
  upsert?: InputMaybe<AddressUpsertWithoutAccessesInput>;
};

export type AddressUpdateOneRequiredWithoutEthernetsNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutEthernetsInput>;
  create?: InputMaybe<AddressCreateWithoutEthernetsInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutEthernetsInput>;
  upsert?: InputMaybe<AddressUpsertWithoutEthernetsInput>;
};

export type AddressUpdateOneRequiredWithoutOrderAccessesNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderAccessesInput>;
  create?: InputMaybe<AddressCreateWithoutOrderAccessesInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutOrderAccessesInput>;
  upsert?: InputMaybe<AddressUpsertWithoutOrderAccessesInput>;
};

export type AddressUpdateOneRequiredWithoutOrderEthernetsNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderEthernetsInput>;
  create?: InputMaybe<AddressCreateWithoutOrderEthernetsInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutOrderEthernetsInput>;
  upsert?: InputMaybe<AddressUpsertWithoutOrderEthernetsInput>;
};

export type AddressUpdateOneRequiredWithoutOrderTrunksNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderTrunksInput>;
  create?: InputMaybe<AddressCreateWithoutOrderTrunksInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutOrderTrunksInput>;
  upsert?: InputMaybe<AddressUpsertWithoutOrderTrunksInput>;
};

export type AddressUpdateOneRequiredWithoutTrunksNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutTrunksInput>;
  create?: InputMaybe<AddressCreateWithoutTrunksInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutTrunksInput>;
  upsert?: InputMaybe<AddressUpsertWithoutTrunksInput>;
};

export type AddressUpdateToOneWithWhereWithoutAccessesInput = {
  data: AddressUpdateWithoutAccessesInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutEthernetsInput = {
  data: AddressUpdateWithoutEthernetsInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutOrderAccessesInput = {
  data: AddressUpdateWithoutOrderAccessesInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutOrderEthernetsInput = {
  data: AddressUpdateWithoutOrderEthernetsInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutOrderTrunksInput = {
  data: AddressUpdateWithoutOrderTrunksInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutTrunksInput = {
  data: AddressUpdateWithoutTrunksInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithoutAccessesInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutCustomerInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutEthernetsInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutOrderAccessesInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutOrderEthernetsInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutOrderTrunksInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutTrunksInput = {
  addressSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactPerson?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  houseNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  isBilling?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ntr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  subscriberId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  update: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithoutAccessesInput = {
  create: AddressCreateWithoutAccessesInput;
  update: AddressUpdateWithoutAccessesInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutEthernetsInput = {
  create: AddressCreateWithoutEthernetsInput;
  update: AddressUpdateWithoutEthernetsInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutOrderAccessesInput = {
  create: AddressCreateWithoutOrderAccessesInput;
  update: AddressUpdateWithoutOrderAccessesInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutOrderEthernetsInput = {
  create: AddressCreateWithoutOrderEthernetsInput;
  update: AddressUpdateWithoutOrderEthernetsInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutOrderTrunksInput = {
  create: AddressCreateWithoutOrderTrunksInput;
  update: AddressUpdateWithoutOrderTrunksInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutTrunksInput = {
  create: AddressCreateWithoutTrunksInput;
  update: AddressUpdateWithoutTrunksInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  addressSuffix?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  contactPerson?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  houseNumber?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isBilling?: InputMaybe<BoolFilter>;
  ntr?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  subscriberId?: InputMaybe<IntNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  addressSuffix?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  contactPerson?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  houseNumber?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isBilling?: InputMaybe<BoolFilter>;
  ntr?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  street_houseNumber_addressSuffix_postalCode_city_contactPerson_customerId?: InputMaybe<AddressStreetHouseNumberAddressSuffixPostalCodeCityContactPersonCustomerIdCompoundUniqueInput>;
  subscriberId?: InputMaybe<IntNullableFilter>;
};

export type AppProvisioning = {
  __typename?: 'AppProvisioning';
  _count?: Maybe<AppProvisioningCount>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AppProvisioningCount = {
  __typename?: 'AppProvisioningCount';
  customers: Scalars['Int']['output'];
};


export type AppProvisioningCountCustomersArgs = {
  where?: InputMaybe<CustomerWhereInput>;
};

export type AppProvisioningCreateNestedOneWithoutCustomersInput = {
  connect?: InputMaybe<AppProvisioningWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AppProvisioningCreateOrConnectWithoutCustomersInput>;
  create?: InputMaybe<AppProvisioningCreateWithoutCustomersInput>;
};

export type AppProvisioningCreateOrConnectWithoutCustomersInput = {
  create: AppProvisioningCreateWithoutCustomersInput;
  where: AppProvisioningWhereUniqueInput;
};

export type AppProvisioningCreateWithoutCustomersInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type AppProvisioningNullableRelationFilter = {
  is?: InputMaybe<AppProvisioningWhereInput>;
  isNot?: InputMaybe<AppProvisioningWhereInput>;
};

export type AppProvisioningOrderByWithRelationInput = {
  customers?: InputMaybe<CustomerOrderByRelationAggregateInput>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type AppProvisioningUpdateOneWithoutCustomersNestedInput = {
  connect?: InputMaybe<AppProvisioningWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AppProvisioningCreateOrConnectWithoutCustomersInput>;
  create?: InputMaybe<AppProvisioningCreateWithoutCustomersInput>;
  delete?: InputMaybe<AppProvisioningWhereInput>;
  disconnect?: InputMaybe<AppProvisioningWhereInput>;
  update?: InputMaybe<AppProvisioningUpdateToOneWithWhereWithoutCustomersInput>;
  upsert?: InputMaybe<AppProvisioningUpsertWithoutCustomersInput>;
};

export type AppProvisioningUpdateToOneWithWhereWithoutCustomersInput = {
  data: AppProvisioningUpdateWithoutCustomersInput;
  where?: InputMaybe<AppProvisioningWhereInput>;
};

export type AppProvisioningUpdateWithoutCustomersInput = {
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AppProvisioningUpsertWithoutCustomersInput = {
  create: AppProvisioningCreateWithoutCustomersInput;
  update: AppProvisioningUpdateWithoutCustomersInput;
  where?: InputMaybe<AppProvisioningWhereInput>;
};

export type AppProvisioningWhereInput = {
  AND?: InputMaybe<Array<AppProvisioningWhereInput>>;
  NOT?: InputMaybe<Array<AppProvisioningWhereInput>>;
  OR?: InputMaybe<Array<AppProvisioningWhereInput>>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type AppProvisioningWhereUniqueInput = {
  AND?: InputMaybe<Array<AppProvisioningWhereInput>>;
  NOT?: InputMaybe<Array<AppProvisioningWhereInput>>;
  OR?: InputMaybe<Array<AppProvisioningWhereInput>>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
};

/** Authentication data */
export type AuthenticationInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthenticationResponse = {
  __typename?: 'AuthenticationResponse';
  jwt?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autocomplete */
export type AutocompleteType = {
  __typename?: 'AutocompleteType';
  description: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
};

export type Availability = {
  __typename?: 'Availability';
  _count?: Maybe<AvailabilityCount>;
  availabilityCarrier: Array<AvailabilityCarrier>;
  city: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  hno: Scalars['Int']['output'];
  hnoSuffix?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};


export type AvailabilityAvailabilityCarrierArgs = {
  cursor?: InputMaybe<AvailabilityCarrierWhereUniqueInput>;
  distinct?: InputMaybe<Array<AvailabilityCarrierScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AvailabilityCarrierOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityCarrier = {
  __typename?: 'AvailabilityCarrier';
  _count?: Maybe<AvailabilityCarrierCount>;
  availability: Availability;
  availabilityId: Scalars['Int']['output'];
  availabilityProducts: Array<AvailabilityProduct>;
  availabilityReplicate?: Maybe<AvailabilityReplicate>;
  availabilityReplicateId?: Maybe<Scalars['Int']['output']>;
  carrier: Carrier;
  carrierId: Scalars['Int']['output'];
  connectionType: ConnectionType;
  id: Scalars['Int']['output'];
  maxDownstream?: Maybe<Scalars['Float']['output']>;
  maxUpstream?: Maybe<Scalars['Float']['output']>;
  setupDuration?: Maybe<Scalars['Int']['output']>;
};


export type AvailabilityCarrierAvailabilityProductsArgs = {
  cursor?: InputMaybe<AvailabilityProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<AvailabilityProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AvailabilityProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvailabilityProductWhereInput>;
};


export type AvailabilityCarrierAvailabilityReplicateArgs = {
  where?: InputMaybe<AvailabilityReplicateWhereInput>;
};

export type AvailabilityCarrierCount = {
  __typename?: 'AvailabilityCarrierCount';
  availabilityProducts: Scalars['Int']['output'];
};


export type AvailabilityCarrierCountAvailabilityProductsArgs = {
  where?: InputMaybe<AvailabilityProductWhereInput>;
};

export type AvailabilityCarrierCreateManyAvailabilityInput = {
  availabilityReplicateId?: InputMaybe<Scalars['Int']['input']>;
  carrierId: Scalars['Int']['input'];
  connectionType: ConnectionType;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateManyAvailabilityInputEnvelope = {
  data: Array<AvailabilityCarrierCreateManyAvailabilityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityCarrierCreateManyAvailabilityReplicateInput = {
  availabilityId: Scalars['Int']['input'];
  carrierId: Scalars['Int']['input'];
  connectionType: ConnectionType;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateManyAvailabilityReplicateInputEnvelope = {
  data: Array<AvailabilityCarrierCreateManyAvailabilityReplicateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityCarrierCreateManyCarrierInput = {
  availabilityId: Scalars['Int']['input'];
  availabilityReplicateId?: InputMaybe<Scalars['Int']['input']>;
  connectionType: ConnectionType;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateManyCarrierInputEnvelope = {
  data: Array<AvailabilityCarrierCreateManyCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityCarrierCreateNestedManyWithoutAvailabilityInput = {
  connect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityCarrierCreateOrConnectWithoutAvailabilityInput>>;
  create?: InputMaybe<Array<AvailabilityCarrierCreateWithoutAvailabilityInput>>;
  createMany?: InputMaybe<AvailabilityCarrierCreateManyAvailabilityInputEnvelope>;
};

export type AvailabilityCarrierCreateNestedManyWithoutAvailabilityReplicateInput = {
  connect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityCarrierCreateOrConnectWithoutAvailabilityReplicateInput>>;
  create?: InputMaybe<Array<AvailabilityCarrierCreateWithoutAvailabilityReplicateInput>>;
  createMany?: InputMaybe<AvailabilityCarrierCreateManyAvailabilityReplicateInputEnvelope>;
};

export type AvailabilityCarrierCreateNestedManyWithoutCarrierInput = {
  connect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityCarrierCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityCarrierCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<AvailabilityCarrierCreateManyCarrierInputEnvelope>;
};

export type AvailabilityCarrierCreateNestedOneWithoutAvailabilityProductsInput = {
  connect?: InputMaybe<AvailabilityCarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityCarrierCreateOrConnectWithoutAvailabilityProductsInput>;
  create?: InputMaybe<AvailabilityCarrierCreateWithoutAvailabilityProductsInput>;
};

export type AvailabilityCarrierCreateOrConnectWithoutAvailabilityInput = {
  create: AvailabilityCarrierCreateWithoutAvailabilityInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierCreateOrConnectWithoutAvailabilityProductsInput = {
  create: AvailabilityCarrierCreateWithoutAvailabilityProductsInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierCreateOrConnectWithoutAvailabilityReplicateInput = {
  create: AvailabilityCarrierCreateWithoutAvailabilityReplicateInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierCreateOrConnectWithoutCarrierInput = {
  create: AvailabilityCarrierCreateWithoutCarrierInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierCreateWithoutAvailabilityInput = {
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutAvailabilityCarrierInput>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateCreateNestedOneWithoutAvailabilityCarrierInput>;
  carrier: CarrierCreateNestedOneWithoutAvailabilityCarrierInput;
  connectionType: ConnectionType;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateWithoutAvailabilityProductsInput = {
  availability: AvailabilityCreateNestedOneWithoutAvailabilityCarrierInput;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateCreateNestedOneWithoutAvailabilityCarrierInput>;
  carrier: CarrierCreateNestedOneWithoutAvailabilityCarrierInput;
  connectionType: ConnectionType;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateWithoutAvailabilityReplicateInput = {
  availability: AvailabilityCreateNestedOneWithoutAvailabilityCarrierInput;
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutAvailabilityCarrierInput>;
  carrier: CarrierCreateNestedOneWithoutAvailabilityCarrierInput;
  connectionType: ConnectionType;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierCreateWithoutCarrierInput = {
  availability: AvailabilityCreateNestedOneWithoutAvailabilityCarrierInput;
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutAvailabilityCarrierInput>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateCreateNestedOneWithoutAvailabilityCarrierInput>;
  connectionType: ConnectionType;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityCarrierListRelationFilter = {
  every?: InputMaybe<AvailabilityCarrierWhereInput>;
  none?: InputMaybe<AvailabilityCarrierWhereInput>;
  some?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityCarrierOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AvailabilityCarrierOrderByWithRelationInput = {
  availability?: InputMaybe<AvailabilityOrderByWithRelationInput>;
  availabilityId?: InputMaybe<SortOrder>;
  availabilityProducts?: InputMaybe<AvailabilityProductOrderByRelationAggregateInput>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateOrderByWithRelationInput>;
  availabilityReplicateId?: InputMaybe<SortOrderInput>;
  carrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  carrierId?: InputMaybe<SortOrder>;
  connectionType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxDownstream?: InputMaybe<SortOrderInput>;
  maxUpstream?: InputMaybe<SortOrderInput>;
  setupDuration?: InputMaybe<SortOrderInput>;
};

export type AvailabilityCarrierRelationFilter = {
  is?: InputMaybe<AvailabilityCarrierWhereInput>;
  isNot?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export enum AvailabilityCarrierScalarFieldEnum {
  AvailabilityId = 'availabilityId',
  AvailabilityReplicateId = 'availabilityReplicateId',
  CarrierId = 'carrierId',
  ConnectionType = 'connectionType',
  Id = 'id',
  MaxDownstream = 'maxDownstream',
  MaxUpstream = 'maxUpstream',
  SetupDuration = 'setupDuration'
}

export type AvailabilityCarrierScalarWhereInput = {
  AND?: InputMaybe<Array<AvailabilityCarrierScalarWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityCarrierScalarWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityCarrierScalarWhereInput>>;
  availabilityId?: InputMaybe<IntFilter>;
  availabilityReplicateId?: InputMaybe<IntNullableFilter>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeFilter>;
  id?: InputMaybe<IntFilter>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
};

export type AvailabilityCarrierUpdateManyMutationInput = {
  connectionType?: InputMaybe<EnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AvailabilityCarrierUpdateManyWithWhereWithoutAvailabilityReplicateInput = {
  data: AvailabilityCarrierUpdateManyMutationInput;
  where: AvailabilityCarrierScalarWhereInput;
};

export type AvailabilityCarrierUpdateManyWithWhereWithoutCarrierInput = {
  data: AvailabilityCarrierUpdateManyMutationInput;
  where: AvailabilityCarrierScalarWhereInput;
};

export type AvailabilityCarrierUpdateManyWithoutAvailabilityReplicateNestedInput = {
  connect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityCarrierCreateOrConnectWithoutAvailabilityReplicateInput>>;
  create?: InputMaybe<Array<AvailabilityCarrierCreateWithoutAvailabilityReplicateInput>>;
  createMany?: InputMaybe<AvailabilityCarrierCreateManyAvailabilityReplicateInputEnvelope>;
  delete?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AvailabilityCarrierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  set?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  update?: InputMaybe<Array<AvailabilityCarrierUpdateWithWhereUniqueWithoutAvailabilityReplicateInput>>;
  updateMany?: InputMaybe<Array<AvailabilityCarrierUpdateManyWithWhereWithoutAvailabilityReplicateInput>>;
  upsert?: InputMaybe<Array<AvailabilityCarrierUpsertWithWhereUniqueWithoutAvailabilityReplicateInput>>;
};

export type AvailabilityCarrierUpdateManyWithoutCarrierNestedInput = {
  connect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityCarrierCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityCarrierCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<AvailabilityCarrierCreateManyCarrierInputEnvelope>;
  delete?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AvailabilityCarrierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  set?: InputMaybe<Array<AvailabilityCarrierWhereUniqueInput>>;
  update?: InputMaybe<Array<AvailabilityCarrierUpdateWithWhereUniqueWithoutCarrierInput>>;
  updateMany?: InputMaybe<Array<AvailabilityCarrierUpdateManyWithWhereWithoutCarrierInput>>;
  upsert?: InputMaybe<Array<AvailabilityCarrierUpsertWithWhereUniqueWithoutCarrierInput>>;
};

export type AvailabilityCarrierUpdateOneRequiredWithoutAvailabilityProductsNestedInput = {
  connect?: InputMaybe<AvailabilityCarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityCarrierCreateOrConnectWithoutAvailabilityProductsInput>;
  create?: InputMaybe<AvailabilityCarrierCreateWithoutAvailabilityProductsInput>;
  update?: InputMaybe<AvailabilityCarrierUpdateToOneWithWhereWithoutAvailabilityProductsInput>;
  upsert?: InputMaybe<AvailabilityCarrierUpsertWithoutAvailabilityProductsInput>;
};

export type AvailabilityCarrierUpdateToOneWithWhereWithoutAvailabilityProductsInput = {
  data: AvailabilityCarrierUpdateWithoutAvailabilityProductsInput;
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityCarrierUpdateWithWhereUniqueWithoutAvailabilityReplicateInput = {
  data: AvailabilityCarrierUpdateWithoutAvailabilityReplicateInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierUpdateWithWhereUniqueWithoutCarrierInput = {
  data: AvailabilityCarrierUpdateWithoutCarrierInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierUpdateWithoutAvailabilityProductsInput = {
  availability?: InputMaybe<AvailabilityUpdateOneRequiredWithoutAvailabilityCarrierNestedInput>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateUpdateOneWithoutAvailabilityCarrierNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutAvailabilityCarrierNestedInput>;
  connectionType?: InputMaybe<EnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AvailabilityCarrierUpdateWithoutAvailabilityReplicateInput = {
  availability?: InputMaybe<AvailabilityUpdateOneRequiredWithoutAvailabilityCarrierNestedInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutAvailabilityCarrierNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutAvailabilityCarrierNestedInput>;
  connectionType?: InputMaybe<EnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AvailabilityCarrierUpdateWithoutCarrierInput = {
  availability?: InputMaybe<AvailabilityUpdateOneRequiredWithoutAvailabilityCarrierNestedInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutAvailabilityCarrierNestedInput>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateUpdateOneWithoutAvailabilityCarrierNestedInput>;
  connectionType?: InputMaybe<EnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AvailabilityCarrierUpsertWithWhereUniqueWithoutAvailabilityReplicateInput = {
  create: AvailabilityCarrierCreateWithoutAvailabilityReplicateInput;
  update: AvailabilityCarrierUpdateWithoutAvailabilityReplicateInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierUpsertWithWhereUniqueWithoutCarrierInput = {
  create: AvailabilityCarrierCreateWithoutCarrierInput;
  update: AvailabilityCarrierUpdateWithoutCarrierInput;
  where: AvailabilityCarrierWhereUniqueInput;
};

export type AvailabilityCarrierUpsertWithoutAvailabilityProductsInput = {
  create: AvailabilityCarrierCreateWithoutAvailabilityProductsInput;
  update: AvailabilityCarrierUpdateWithoutAvailabilityProductsInput;
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityCarrierWhereInput = {
  AND?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  availability?: InputMaybe<AvailabilityRelationFilter>;
  availabilityId?: InputMaybe<IntFilter>;
  availabilityProducts?: InputMaybe<AvailabilityProductListRelationFilter>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateNullableRelationFilter>;
  availabilityReplicateId?: InputMaybe<IntNullableFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeFilter>;
  id?: InputMaybe<IntFilter>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
};

export type AvailabilityCarrierWhereUniqueInput = {
  AND?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityCarrierWhereInput>>;
  availability?: InputMaybe<AvailabilityRelationFilter>;
  availabilityId?: InputMaybe<IntFilter>;
  availabilityProducts?: InputMaybe<AvailabilityProductListRelationFilter>;
  availabilityReplicate?: InputMaybe<AvailabilityReplicateNullableRelationFilter>;
  availabilityReplicateId?: InputMaybe<IntNullableFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
};

export type AvailabilityCount = {
  __typename?: 'AvailabilityCount';
  availabilityCarrier: Scalars['Int']['output'];
};


export type AvailabilityCountAvailabilityCarrierArgs = {
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityCreateInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierCreateNestedManyWithoutAvailabilityInput>;
  city: Scalars['String']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AvailabilityCreateNestedOneWithoutAvailabilityCarrierInput = {
  connect?: InputMaybe<AvailabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<AvailabilityCreateWithoutAvailabilityCarrierInput>;
};

export type AvailabilityCreateOrConnectWithoutAvailabilityCarrierInput = {
  create: AvailabilityCreateWithoutAvailabilityCarrierInput;
  where: AvailabilityWhereUniqueInput;
};

export type AvailabilityCreateWithoutAvailabilityCarrierInput = {
  city: Scalars['String']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AvailabilityListRelationFilter = {
  every?: InputMaybe<AvailabilityWhereInput>;
  none?: InputMaybe<AvailabilityWhereInput>;
  some?: InputMaybe<AvailabilityWhereInput>;
};

export type AvailabilityOrderByWithRelationInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrder>;
  completed?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  hno?: InputMaybe<SortOrder>;
  hnoSuffix?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export type AvailabilityProduct = {
  __typename?: 'AvailabilityProduct';
  availabilityCarrier: AvailabilityCarrier;
  availabilityCarrierId: Scalars['Int']['output'];
  available: Scalars['Boolean']['output'];
  carrierProduct: CarrierProduct;
  carrierProductId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type AvailabilityProductCreateManyAvailabilityCarrierInput = {
  available: Scalars['Boolean']['input'];
  carrierProductId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityProductCreateManyAvailabilityCarrierInputEnvelope = {
  data: Array<AvailabilityProductCreateManyAvailabilityCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityProductCreateManyCarrierProductInput = {
  availabilityCarrierId: Scalars['Int']['input'];
  available: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityProductCreateManyCarrierProductInputEnvelope = {
  data: Array<AvailabilityProductCreateManyCarrierProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityProductCreateNestedManyWithoutAvailabilityCarrierInput = {
  connect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityProductCreateOrConnectWithoutAvailabilityCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityProductCreateWithoutAvailabilityCarrierInput>>;
  createMany?: InputMaybe<AvailabilityProductCreateManyAvailabilityCarrierInputEnvelope>;
};

export type AvailabilityProductCreateNestedManyWithoutCarrierProductInput = {
  connect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityProductCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<AvailabilityProductCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<AvailabilityProductCreateManyCarrierProductInputEnvelope>;
};

export type AvailabilityProductCreateOrConnectWithoutAvailabilityCarrierInput = {
  create: AvailabilityProductCreateWithoutAvailabilityCarrierInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductCreateOrConnectWithoutCarrierProductInput = {
  create: AvailabilityProductCreateWithoutCarrierProductInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductCreateWithoutAvailabilityCarrierInput = {
  available: Scalars['Boolean']['input'];
  carrierProduct: CarrierProductCreateNestedOneWithoutAvailabilityProductsInput;
};

export type AvailabilityProductCreateWithoutCarrierProductInput = {
  availabilityCarrier: AvailabilityCarrierCreateNestedOneWithoutAvailabilityProductsInput;
  available: Scalars['Boolean']['input'];
};

export type AvailabilityProductListRelationFilter = {
  every?: InputMaybe<AvailabilityProductWhereInput>;
  none?: InputMaybe<AvailabilityProductWhereInput>;
  some?: InputMaybe<AvailabilityProductWhereInput>;
};

export type AvailabilityProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AvailabilityProductOrderByWithRelationInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierOrderByWithRelationInput>;
  availabilityCarrierId?: InputMaybe<SortOrder>;
  available?: InputMaybe<SortOrder>;
  carrierProduct?: InputMaybe<CarrierProductOrderByWithRelationInput>;
  carrierProductId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum AvailabilityProductScalarFieldEnum {
  AvailabilityCarrierId = 'availabilityCarrierId',
  Available = 'available',
  CarrierProductId = 'carrierProductId',
  Id = 'id'
}

export type AvailabilityProductScalarWhereInput = {
  AND?: InputMaybe<Array<AvailabilityProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityProductScalarWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityProductScalarWhereInput>>;
  availabilityCarrierId?: InputMaybe<IntFilter>;
  available?: InputMaybe<BoolFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AvailabilityProductUpdateManyMutationInput = {
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AvailabilityProductUpdateManyWithWhereWithoutAvailabilityCarrierInput = {
  data: AvailabilityProductUpdateManyMutationInput;
  where: AvailabilityProductScalarWhereInput;
};

export type AvailabilityProductUpdateManyWithWhereWithoutCarrierProductInput = {
  data: AvailabilityProductUpdateManyMutationInput;
  where: AvailabilityProductScalarWhereInput;
};

export type AvailabilityProductUpdateManyWithoutAvailabilityCarrierNestedInput = {
  connect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityProductCreateOrConnectWithoutAvailabilityCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityProductCreateWithoutAvailabilityCarrierInput>>;
  createMany?: InputMaybe<AvailabilityProductCreateManyAvailabilityCarrierInputEnvelope>;
  delete?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AvailabilityProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  set?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  update?: InputMaybe<Array<AvailabilityProductUpdateWithWhereUniqueWithoutAvailabilityCarrierInput>>;
  updateMany?: InputMaybe<Array<AvailabilityProductUpdateManyWithWhereWithoutAvailabilityCarrierInput>>;
  upsert?: InputMaybe<Array<AvailabilityProductUpsertWithWhereUniqueWithoutAvailabilityCarrierInput>>;
};

export type AvailabilityProductUpdateManyWithoutCarrierProductNestedInput = {
  connect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityProductCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<AvailabilityProductCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<AvailabilityProductCreateManyCarrierProductInputEnvelope>;
  delete?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AvailabilityProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  set?: InputMaybe<Array<AvailabilityProductWhereUniqueInput>>;
  update?: InputMaybe<Array<AvailabilityProductUpdateWithWhereUniqueWithoutCarrierProductInput>>;
  updateMany?: InputMaybe<Array<AvailabilityProductUpdateManyWithWhereWithoutCarrierProductInput>>;
  upsert?: InputMaybe<Array<AvailabilityProductUpsertWithWhereUniqueWithoutCarrierProductInput>>;
};

export type AvailabilityProductUpdateWithWhereUniqueWithoutAvailabilityCarrierInput = {
  data: AvailabilityProductUpdateWithoutAvailabilityCarrierInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductUpdateWithWhereUniqueWithoutCarrierProductInput = {
  data: AvailabilityProductUpdateWithoutCarrierProductInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductUpdateWithoutAvailabilityCarrierInput = {
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutAvailabilityProductsNestedInput>;
};

export type AvailabilityProductUpdateWithoutCarrierProductInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierUpdateOneRequiredWithoutAvailabilityProductsNestedInput>;
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AvailabilityProductUpsertWithWhereUniqueWithoutAvailabilityCarrierInput = {
  create: AvailabilityProductCreateWithoutAvailabilityCarrierInput;
  update: AvailabilityProductUpdateWithoutAvailabilityCarrierInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductUpsertWithWhereUniqueWithoutCarrierProductInput = {
  create: AvailabilityProductCreateWithoutCarrierProductInput;
  update: AvailabilityProductUpdateWithoutCarrierProductInput;
  where: AvailabilityProductWhereUniqueInput;
};

export type AvailabilityProductWhereInput = {
  AND?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierRelationFilter>;
  availabilityCarrierId?: InputMaybe<IntFilter>;
  available?: InputMaybe<BoolFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AvailabilityProductWhereUniqueInput = {
  AND?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityProductWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierRelationFilter>;
  availabilityCarrierId?: InputMaybe<IntFilter>;
  available?: InputMaybe<BoolFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilityRelationFilter = {
  is?: InputMaybe<AvailabilityWhereInput>;
  isNot?: InputMaybe<AvailabilityWhereInput>;
};

export type AvailabilityReplicate = {
  __typename?: 'AvailabilityReplicate';
  _count?: Maybe<AvailabilityReplicateCount>;
  addressId?: Maybe<Scalars['BigInt']['output']>;
  asb?: Maybe<Scalars['Int']['output']>;
  availabilityCarrier: Array<AvailabilityCarrier>;
  bauHcEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  bauHcStart?: Maybe<Scalars['DateTimeISO']['output']>;
  carrier: Carrier;
  carrierId: Scalars['Int']['output'];
  city: Scalars['String']['output'];
  companyCount?: Maybe<Scalars['Int']['output']>;
  constructionStatus: ConstructionStatus;
  district?: Maybe<Scalars['String']['output']>;
  hno: Scalars['Int']['output'];
  hnoSuffix?: Maybe<Scalars['String']['output']>;
  householdCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  klsId?: Maybe<Scalars['BigInt']['output']>;
  landlordApproval?: Maybe<LandlordApproval>;
  localExchangeSize?: Maybe<LocalExchangeSize>;
  onkz?: Maybe<Scalars['Int']['output']>;
  reasonNoConstruction?: Maybe<Scalars['String']['output']>;
  startRvm?: Maybe<Scalars['DateTimeISO']['output']>;
  street: Scalars['String']['output'];
  technology?: Maybe<ConstructionTechnology>;
  vrvmEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  vrvmStart?: Maybe<Scalars['DateTimeISO']['output']>;
  vvmEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  vvmStart?: Maybe<Scalars['DateTimeISO']['output']>;
  zip: Scalars['String']['output'];
};


export type AvailabilityReplicateAvailabilityCarrierArgs = {
  cursor?: InputMaybe<AvailabilityCarrierWhereUniqueInput>;
  distinct?: InputMaybe<Array<AvailabilityCarrierScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AvailabilityCarrierOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityReplicateCarrierIdAddressIdCompoundUniqueInput = {
  addressId: Scalars['BigInt']['input'];
  carrierId: Scalars['Int']['input'];
};

export type AvailabilityReplicateCount = {
  __typename?: 'AvailabilityReplicateCount';
  availabilityCarrier: Scalars['Int']['output'];
};


export type AvailabilityReplicateCountAvailabilityCarrierArgs = {
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};

export type AvailabilityReplicateCreateManyCarrierInput = {
  addressId?: InputMaybe<Scalars['BigInt']['input']>;
  asb?: InputMaybe<Scalars['Int']['input']>;
  bauHcEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  bauHcStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  city: Scalars['String']['input'];
  companyCount?: InputMaybe<Scalars['Int']['input']>;
  constructionStatus: ConstructionStatus;
  district?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  householdCount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  klsId?: InputMaybe<Scalars['BigInt']['input']>;
  landlordApproval?: InputMaybe<LandlordApproval>;
  localExchangeSize?: InputMaybe<LocalExchangeSize>;
  onkz?: InputMaybe<Scalars['Int']['input']>;
  reasonNoConstruction?: InputMaybe<Scalars['String']['input']>;
  startRvm?: InputMaybe<Scalars['DateTimeISO']['input']>;
  street: Scalars['String']['input'];
  technology?: InputMaybe<ConstructionTechnology>;
  vrvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vrvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zip: Scalars['String']['input'];
};

export type AvailabilityReplicateCreateManyCarrierInputEnvelope = {
  data: Array<AvailabilityReplicateCreateManyCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AvailabilityReplicateCreateNestedManyWithoutCarrierInput = {
  connect?: InputMaybe<Array<AvailabilityReplicateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityReplicateCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityReplicateCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<AvailabilityReplicateCreateManyCarrierInputEnvelope>;
};

export type AvailabilityReplicateCreateNestedOneWithoutAvailabilityCarrierInput = {
  connect?: InputMaybe<AvailabilityReplicateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityReplicateCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<AvailabilityReplicateCreateWithoutAvailabilityCarrierInput>;
};

export type AvailabilityReplicateCreateOrConnectWithoutAvailabilityCarrierInput = {
  create: AvailabilityReplicateCreateWithoutAvailabilityCarrierInput;
  where: AvailabilityReplicateWhereUniqueInput;
};

export type AvailabilityReplicateCreateOrConnectWithoutCarrierInput = {
  create: AvailabilityReplicateCreateWithoutCarrierInput;
  where: AvailabilityReplicateWhereUniqueInput;
};

export type AvailabilityReplicateCreateWithoutAvailabilityCarrierInput = {
  addressId?: InputMaybe<Scalars['BigInt']['input']>;
  asb?: InputMaybe<Scalars['Int']['input']>;
  bauHcEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  bauHcStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  carrier: CarrierCreateNestedOneWithoutAvailabilityReplicatesInput;
  city: Scalars['String']['input'];
  companyCount?: InputMaybe<Scalars['Int']['input']>;
  constructionStatus: ConstructionStatus;
  district?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  householdCount?: InputMaybe<Scalars['Int']['input']>;
  klsId?: InputMaybe<Scalars['BigInt']['input']>;
  landlordApproval?: InputMaybe<LandlordApproval>;
  localExchangeSize?: InputMaybe<LocalExchangeSize>;
  onkz?: InputMaybe<Scalars['Int']['input']>;
  reasonNoConstruction?: InputMaybe<Scalars['String']['input']>;
  startRvm?: InputMaybe<Scalars['DateTimeISO']['input']>;
  street: Scalars['String']['input'];
  technology?: InputMaybe<ConstructionTechnology>;
  vrvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vrvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zip: Scalars['String']['input'];
};

export type AvailabilityReplicateCreateWithoutCarrierInput = {
  addressId?: InputMaybe<Scalars['BigInt']['input']>;
  asb?: InputMaybe<Scalars['Int']['input']>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierCreateNestedManyWithoutAvailabilityReplicateInput>;
  bauHcEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  bauHcStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  city: Scalars['String']['input'];
  companyCount?: InputMaybe<Scalars['Int']['input']>;
  constructionStatus: ConstructionStatus;
  district?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  householdCount?: InputMaybe<Scalars['Int']['input']>;
  klsId?: InputMaybe<Scalars['BigInt']['input']>;
  landlordApproval?: InputMaybe<LandlordApproval>;
  localExchangeSize?: InputMaybe<LocalExchangeSize>;
  onkz?: InputMaybe<Scalars['Int']['input']>;
  reasonNoConstruction?: InputMaybe<Scalars['String']['input']>;
  startRvm?: InputMaybe<Scalars['DateTimeISO']['input']>;
  street: Scalars['String']['input'];
  technology?: InputMaybe<ConstructionTechnology>;
  vrvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vrvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vvmStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zip: Scalars['String']['input'];
};

export type AvailabilityReplicateListRelationFilter = {
  every?: InputMaybe<AvailabilityReplicateWhereInput>;
  none?: InputMaybe<AvailabilityReplicateWhereInput>;
  some?: InputMaybe<AvailabilityReplicateWhereInput>;
};

export type AvailabilityReplicateNullableRelationFilter = {
  is?: InputMaybe<AvailabilityReplicateWhereInput>;
  isNot?: InputMaybe<AvailabilityReplicateWhereInput>;
};

export type AvailabilityReplicateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AvailabilityReplicateOrderByWithRelationInput = {
  addressId?: InputMaybe<SortOrderInput>;
  asb?: InputMaybe<SortOrderInput>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierOrderByRelationAggregateInput>;
  bauHcEnd?: InputMaybe<SortOrderInput>;
  bauHcStart?: InputMaybe<SortOrderInput>;
  carrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  carrierId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  companyCount?: InputMaybe<SortOrderInput>;
  constructionStatus?: InputMaybe<SortOrder>;
  district?: InputMaybe<SortOrderInput>;
  hno?: InputMaybe<SortOrder>;
  hnoSuffix?: InputMaybe<SortOrderInput>;
  householdCount?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  klsId?: InputMaybe<SortOrderInput>;
  landlordApproval?: InputMaybe<SortOrderInput>;
  localExchangeSize?: InputMaybe<SortOrderInput>;
  onkz?: InputMaybe<SortOrderInput>;
  reasonNoConstruction?: InputMaybe<SortOrderInput>;
  startRvm?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrder>;
  technology?: InputMaybe<SortOrderInput>;
  vrvmEnd?: InputMaybe<SortOrderInput>;
  vrvmStart?: InputMaybe<SortOrderInput>;
  vvmEnd?: InputMaybe<SortOrderInput>;
  vvmStart?: InputMaybe<SortOrderInput>;
  zip?: InputMaybe<SortOrder>;
};

export type AvailabilityReplicateScalarWhereInput = {
  AND?: InputMaybe<Array<AvailabilityReplicateScalarWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityReplicateScalarWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityReplicateScalarWhereInput>>;
  addressId?: InputMaybe<BigIntNullableFilter>;
  asb?: InputMaybe<IntNullableFilter>;
  bauHcEnd?: InputMaybe<DateTimeNullableFilter>;
  bauHcStart?: InputMaybe<DateTimeNullableFilter>;
  carrierId?: InputMaybe<IntFilter>;
  city?: InputMaybe<StringFilter>;
  companyCount?: InputMaybe<IntNullableFilter>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFilter>;
  district?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  householdCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  klsId?: InputMaybe<BigIntNullableFilter>;
  landlordApproval?: InputMaybe<EnumLandlordApprovalNullableFilter>;
  localExchangeSize?: InputMaybe<EnumLocalExchangeSizeNullableFilter>;
  onkz?: InputMaybe<IntNullableFilter>;
  reasonNoConstruction?: InputMaybe<StringNullableFilter>;
  startRvm?: InputMaybe<DateTimeNullableFilter>;
  street?: InputMaybe<StringFilter>;
  technology?: InputMaybe<EnumConstructionTechnologyNullableFilter>;
  vrvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vrvmStart?: InputMaybe<DateTimeNullableFilter>;
  vvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vvmStart?: InputMaybe<DateTimeNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type AvailabilityReplicateUpdateManyMutationInput = {
  addressId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  asb?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bauHcEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bauHcStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFieldUpdateOperationsInput>;
  district?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  householdCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  klsId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  landlordApproval?: InputMaybe<NullableEnumLandlordApprovalFieldUpdateOperationsInput>;
  localExchangeSize?: InputMaybe<NullableEnumLocalExchangeSizeFieldUpdateOperationsInput>;
  onkz?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reasonNoConstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startRvm?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  technology?: InputMaybe<NullableEnumConstructionTechnologyFieldUpdateOperationsInput>;
  vrvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vrvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AvailabilityReplicateUpdateManyWithWhereWithoutCarrierInput = {
  data: AvailabilityReplicateUpdateManyMutationInput;
  where: AvailabilityReplicateScalarWhereInput;
};

export type AvailabilityReplicateUpdateManyWithoutCarrierNestedInput = {
  connect?: InputMaybe<Array<AvailabilityReplicateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AvailabilityReplicateCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<AvailabilityReplicateCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<AvailabilityReplicateCreateManyCarrierInputEnvelope>;
  delete?: InputMaybe<Array<AvailabilityReplicateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AvailabilityReplicateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AvailabilityReplicateWhereUniqueInput>>;
  set?: InputMaybe<Array<AvailabilityReplicateWhereUniqueInput>>;
  update?: InputMaybe<Array<AvailabilityReplicateUpdateWithWhereUniqueWithoutCarrierInput>>;
  updateMany?: InputMaybe<Array<AvailabilityReplicateUpdateManyWithWhereWithoutCarrierInput>>;
  upsert?: InputMaybe<Array<AvailabilityReplicateUpsertWithWhereUniqueWithoutCarrierInput>>;
};

export type AvailabilityReplicateUpdateOneWithoutAvailabilityCarrierNestedInput = {
  connect?: InputMaybe<AvailabilityReplicateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityReplicateCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<AvailabilityReplicateCreateWithoutAvailabilityCarrierInput>;
  delete?: InputMaybe<AvailabilityReplicateWhereInput>;
  disconnect?: InputMaybe<AvailabilityReplicateWhereInput>;
  update?: InputMaybe<AvailabilityReplicateUpdateToOneWithWhereWithoutAvailabilityCarrierInput>;
  upsert?: InputMaybe<AvailabilityReplicateUpsertWithoutAvailabilityCarrierInput>;
};

export type AvailabilityReplicateUpdateToOneWithWhereWithoutAvailabilityCarrierInput = {
  data: AvailabilityReplicateUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<AvailabilityReplicateWhereInput>;
};

export type AvailabilityReplicateUpdateWithWhereUniqueWithoutCarrierInput = {
  data: AvailabilityReplicateUpdateWithoutCarrierInput;
  where: AvailabilityReplicateWhereUniqueInput;
};

export type AvailabilityReplicateUpdateWithoutAvailabilityCarrierInput = {
  addressId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  asb?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bauHcEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bauHcStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutAvailabilityReplicatesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFieldUpdateOperationsInput>;
  district?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  householdCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  klsId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  landlordApproval?: InputMaybe<NullableEnumLandlordApprovalFieldUpdateOperationsInput>;
  localExchangeSize?: InputMaybe<NullableEnumLocalExchangeSizeFieldUpdateOperationsInput>;
  onkz?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reasonNoConstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startRvm?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  technology?: InputMaybe<NullableEnumConstructionTechnologyFieldUpdateOperationsInput>;
  vrvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vrvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AvailabilityReplicateUpdateWithoutCarrierInput = {
  addressId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  asb?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierUpdateManyWithoutAvailabilityReplicateNestedInput>;
  bauHcEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bauHcStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFieldUpdateOperationsInput>;
  district?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  householdCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  klsId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  landlordApproval?: InputMaybe<NullableEnumLandlordApprovalFieldUpdateOperationsInput>;
  localExchangeSize?: InputMaybe<NullableEnumLocalExchangeSizeFieldUpdateOperationsInput>;
  onkz?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  reasonNoConstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startRvm?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  technology?: InputMaybe<NullableEnumConstructionTechnologyFieldUpdateOperationsInput>;
  vrvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vrvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  vvmStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AvailabilityReplicateUpsertWithWhereUniqueWithoutCarrierInput = {
  create: AvailabilityReplicateCreateWithoutCarrierInput;
  update: AvailabilityReplicateUpdateWithoutCarrierInput;
  where: AvailabilityReplicateWhereUniqueInput;
};

export type AvailabilityReplicateUpsertWithoutAvailabilityCarrierInput = {
  create: AvailabilityReplicateCreateWithoutAvailabilityCarrierInput;
  update: AvailabilityReplicateUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<AvailabilityReplicateWhereInput>;
};

export type AvailabilityReplicateWhereInput = {
  AND?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  addressId?: InputMaybe<BigIntNullableFilter>;
  asb?: InputMaybe<IntNullableFilter>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  bauHcEnd?: InputMaybe<DateTimeNullableFilter>;
  bauHcStart?: InputMaybe<DateTimeNullableFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  city?: InputMaybe<StringFilter>;
  companyCount?: InputMaybe<IntNullableFilter>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFilter>;
  district?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  householdCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  klsId?: InputMaybe<BigIntNullableFilter>;
  landlordApproval?: InputMaybe<EnumLandlordApprovalNullableFilter>;
  localExchangeSize?: InputMaybe<EnumLocalExchangeSizeNullableFilter>;
  onkz?: InputMaybe<IntNullableFilter>;
  reasonNoConstruction?: InputMaybe<StringNullableFilter>;
  startRvm?: InputMaybe<DateTimeNullableFilter>;
  street?: InputMaybe<StringFilter>;
  technology?: InputMaybe<EnumConstructionTechnologyNullableFilter>;
  vrvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vrvmStart?: InputMaybe<DateTimeNullableFilter>;
  vvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vvmStart?: InputMaybe<DateTimeNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type AvailabilityReplicateWhereUniqueInput = {
  AND?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityReplicateWhereInput>>;
  addressId?: InputMaybe<BigIntNullableFilter>;
  asb?: InputMaybe<IntNullableFilter>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  bauHcEnd?: InputMaybe<DateTimeNullableFilter>;
  bauHcStart?: InputMaybe<DateTimeNullableFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  carrierId_addressId?: InputMaybe<AvailabilityReplicateCarrierIdAddressIdCompoundUniqueInput>;
  city?: InputMaybe<StringFilter>;
  companyCount?: InputMaybe<IntNullableFilter>;
  constructionStatus?: InputMaybe<EnumConstructionStatusFilter>;
  district?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  householdCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  klsId?: InputMaybe<BigIntNullableFilter>;
  landlordApproval?: InputMaybe<EnumLandlordApprovalNullableFilter>;
  localExchangeSize?: InputMaybe<EnumLocalExchangeSizeNullableFilter>;
  onkz?: InputMaybe<IntNullableFilter>;
  reasonNoConstruction?: InputMaybe<StringNullableFilter>;
  startRvm?: InputMaybe<DateTimeNullableFilter>;
  street?: InputMaybe<StringFilter>;
  technology?: InputMaybe<EnumConstructionTechnologyNullableFilter>;
  vrvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vrvmStart?: InputMaybe<DateTimeNullableFilter>;
  vvmEnd?: InputMaybe<DateTimeNullableFilter>;
  vvmStart?: InputMaybe<DateTimeNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export enum AvailabilityScalarFieldEnum {
  City = 'city',
  Completed = 'completed',
  CreatedAt = 'createdAt',
  Hno = 'hno',
  HnoSuffix = 'hnoSuffix',
  Id = 'id',
  PartnerId = 'partnerId',
  Street = 'street',
  Zip = 'zip'
}

export type AvailabilityUpdateOneRequiredWithoutAvailabilityCarrierNestedInput = {
  connect?: InputMaybe<AvailabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AvailabilityCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<AvailabilityCreateWithoutAvailabilityCarrierInput>;
  update?: InputMaybe<AvailabilityUpdateToOneWithWhereWithoutAvailabilityCarrierInput>;
  upsert?: InputMaybe<AvailabilityUpsertWithoutAvailabilityCarrierInput>;
};

export type AvailabilityUpdateToOneWithWhereWithoutAvailabilityCarrierInput = {
  data: AvailabilityUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<AvailabilityWhereInput>;
};

export type AvailabilityUpdateWithoutAvailabilityCarrierInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AvailabilityUpsertWithoutAvailabilityCarrierInput = {
  create: AvailabilityCreateWithoutAvailabilityCarrierInput;
  update: AvailabilityUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<AvailabilityWhereInput>;
};

export type AvailabilityWhereInput = {
  AND?: InputMaybe<Array<AvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  completed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  street?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type AvailabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<AvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<AvailabilityWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  completed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type Aws = {
  __typename?: 'Aws';
  did: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  mode: AwsMode;
  name: Scalars['String']['output'];
  numberId: Scalars['Int']['output'];
  targets: Scalars['String']['output'];
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type AwsCreateManyNumberInput = {
  did: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  mode: AwsMode;
  name: Scalars['String']['input'];
  targets: Scalars['String']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type AwsCreateManyNumberInputEnvelope = {
  data: Array<AwsCreateManyNumberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AwsCreateNestedManyWithoutNumberInput = {
  connect?: InputMaybe<Array<AwsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AwsCreateOrConnectWithoutNumberInput>>;
  create?: InputMaybe<Array<AwsCreateWithoutNumberInput>>;
  createMany?: InputMaybe<AwsCreateManyNumberInputEnvelope>;
};

export type AwsCreateOrConnectWithoutNumberInput = {
  create: AwsCreateWithoutNumberInput;
  where: AwsWhereUniqueInput;
};

export type AwsCreateWithoutNumberInput = {
  did: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  mode: AwsMode;
  name: Scalars['String']['input'];
  targets: Scalars['String']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type AwsListRelationFilter = {
  every?: InputMaybe<AwsWhereInput>;
  none?: InputMaybe<AwsWhereInput>;
  some?: InputMaybe<AwsWhereInput>;
};

export enum AwsMode {
  Instant = 'INSTANT',
  Offline = 'OFFLINE',
  Parallel = 'PARALLEL',
  Time = 'TIME'
}

export type AwsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AwsOrderByWithRelationInput = {
  did?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mode?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<NumberOrderByWithRelationInput>;
  numberId?: InputMaybe<SortOrder>;
  targets?: InputMaybe<SortOrder>;
  timeout?: InputMaybe<SortOrderInput>;
};

export enum AwsScalarFieldEnum {
  Did = 'did',
  Enabled = 'enabled',
  Id = 'id',
  Mode = 'mode',
  Name = 'name',
  NumberId = 'numberId',
  Targets = 'targets',
  Timeout = 'timeout'
}

export type AwsScalarWhereInput = {
  AND?: InputMaybe<Array<AwsScalarWhereInput>>;
  NOT?: InputMaybe<Array<AwsScalarWhereInput>>;
  OR?: InputMaybe<Array<AwsScalarWhereInput>>;
  did?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  mode?: InputMaybe<EnumAwsModeFilter>;
  name?: InputMaybe<StringFilter>;
  numberId?: InputMaybe<IntFilter>;
  targets?: InputMaybe<StringFilter>;
  timeout?: InputMaybe<IntNullableFilter>;
};

export type AwsUpdateManyMutationInput = {
  did?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mode?: InputMaybe<EnumAwsModeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  targets?: InputMaybe<StringFieldUpdateOperationsInput>;
  timeout?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AwsUpdateManyWithWhereWithoutNumberInput = {
  data: AwsUpdateManyMutationInput;
  where: AwsScalarWhereInput;
};

export type AwsUpdateManyWithoutNumberNestedInput = {
  connect?: InputMaybe<Array<AwsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AwsCreateOrConnectWithoutNumberInput>>;
  create?: InputMaybe<Array<AwsCreateWithoutNumberInput>>;
  createMany?: InputMaybe<AwsCreateManyNumberInputEnvelope>;
  delete?: InputMaybe<Array<AwsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AwsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AwsWhereUniqueInput>>;
  set?: InputMaybe<Array<AwsWhereUniqueInput>>;
  update?: InputMaybe<Array<AwsUpdateWithWhereUniqueWithoutNumberInput>>;
  updateMany?: InputMaybe<Array<AwsUpdateManyWithWhereWithoutNumberInput>>;
  upsert?: InputMaybe<Array<AwsUpsertWithWhereUniqueWithoutNumberInput>>;
};

export type AwsUpdateWithWhereUniqueWithoutNumberInput = {
  data: AwsUpdateWithoutNumberInput;
  where: AwsWhereUniqueInput;
};

export type AwsUpdateWithoutNumberInput = {
  did?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mode?: InputMaybe<EnumAwsModeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  targets?: InputMaybe<StringFieldUpdateOperationsInput>;
  timeout?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AwsUpsertWithWhereUniqueWithoutNumberInput = {
  create: AwsCreateWithoutNumberInput;
  update: AwsUpdateWithoutNumberInput;
  where: AwsWhereUniqueInput;
};

export type AwsWhereInput = {
  AND?: InputMaybe<Array<AwsWhereInput>>;
  NOT?: InputMaybe<Array<AwsWhereInput>>;
  OR?: InputMaybe<Array<AwsWhereInput>>;
  did?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  mode?: InputMaybe<EnumAwsModeFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<NumberRelationFilter>;
  numberId?: InputMaybe<IntFilter>;
  targets?: InputMaybe<StringFilter>;
  timeout?: InputMaybe<IntNullableFilter>;
};

export type AwsWhereUniqueInput = {
  AND?: InputMaybe<Array<AwsWhereInput>>;
  NOT?: InputMaybe<Array<AwsWhereInput>>;
  OR?: InputMaybe<Array<AwsWhereInput>>;
  did?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<EnumAwsModeFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<NumberRelationFilter>;
  numberId?: InputMaybe<IntFilter>;
  targets?: InputMaybe<StringFilter>;
  timeout?: InputMaybe<IntNullableFilter>;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type CallDestination = {
  __typename?: 'CallDestination';
  _count?: Maybe<CallDestinationCount>;
  dialCode: Scalars['String']['output'];
  effectiveDate: Scalars['DateTimeISO']['output'];
  flatrateInt1: Scalars['Boolean']['output'];
  flatrateInt2: Scalars['Boolean']['output'];
  flatrateInt3: Scalars['Boolean']['output'];
  flatrateLandline: Scalars['Boolean']['output'];
  flatrateMobil: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rateVK: Scalars['Float']['output'];
};

export type CallDestinationCount = {
  __typename?: 'CallDestinationCount';
  cdrs: Scalars['Int']['output'];
};


export type CallDestinationCountCdrsArgs = {
  where?: InputMaybe<CdrWhereInput>;
};

export type CallDestinationCreateNestedOneWithoutCdrsInput = {
  connect?: InputMaybe<CallDestinationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CallDestinationCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<CallDestinationCreateWithoutCdrsInput>;
};

export type CallDestinationCreateOrConnectWithoutCdrsInput = {
  create: CallDestinationCreateWithoutCdrsInput;
  where: CallDestinationWhereUniqueInput;
};

export type CallDestinationCreateWithoutCdrsInput = {
  dialCode: Scalars['String']['input'];
  effectiveDate: Scalars['DateTimeISO']['input'];
  flatrateInt1?: InputMaybe<Scalars['Boolean']['input']>;
  flatrateInt2?: InputMaybe<Scalars['Boolean']['input']>;
  flatrateInt3?: InputMaybe<Scalars['Boolean']['input']>;
  flatrateLandline?: InputMaybe<Scalars['Boolean']['input']>;
  flatrateMobil?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rateVK: Scalars['Float']['input'];
};

export type CallDestinationNullableRelationFilter = {
  is?: InputMaybe<CallDestinationWhereInput>;
  isNot?: InputMaybe<CallDestinationWhereInput>;
};

export type CallDestinationOrderByWithRelationInput = {
  cdrs?: InputMaybe<CdrOrderByRelationAggregateInput>;
  dialCode?: InputMaybe<SortOrder>;
  effectiveDate?: InputMaybe<SortOrder>;
  flatrateInt1?: InputMaybe<SortOrder>;
  flatrateInt2?: InputMaybe<SortOrder>;
  flatrateInt3?: InputMaybe<SortOrder>;
  flatrateLandline?: InputMaybe<SortOrder>;
  flatrateMobil?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  rateVK?: InputMaybe<SortOrder>;
};

export type CallDestinationUpdateOneWithoutCdrsNestedInput = {
  connect?: InputMaybe<CallDestinationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CallDestinationCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<CallDestinationCreateWithoutCdrsInput>;
  delete?: InputMaybe<CallDestinationWhereInput>;
  disconnect?: InputMaybe<CallDestinationWhereInput>;
  update?: InputMaybe<CallDestinationUpdateToOneWithWhereWithoutCdrsInput>;
  upsert?: InputMaybe<CallDestinationUpsertWithoutCdrsInput>;
};

export type CallDestinationUpdateToOneWithWhereWithoutCdrsInput = {
  data: CallDestinationUpdateWithoutCdrsInput;
  where?: InputMaybe<CallDestinationWhereInput>;
};

export type CallDestinationUpdateWithoutCdrsInput = {
  dialCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  effectiveDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  flatrateInt1?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateInt2?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateInt3?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rateVK?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type CallDestinationUpsertWithoutCdrsInput = {
  create: CallDestinationCreateWithoutCdrsInput;
  update: CallDestinationUpdateWithoutCdrsInput;
  where?: InputMaybe<CallDestinationWhereInput>;
};

export type CallDestinationWhereInput = {
  AND?: InputMaybe<Array<CallDestinationWhereInput>>;
  NOT?: InputMaybe<Array<CallDestinationWhereInput>>;
  OR?: InputMaybe<Array<CallDestinationWhereInput>>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  dialCode?: InputMaybe<StringFilter>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  flatrateInt1?: InputMaybe<BoolFilter>;
  flatrateInt2?: InputMaybe<BoolFilter>;
  flatrateInt3?: InputMaybe<BoolFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  rateVK?: InputMaybe<FloatFilter>;
};

export type CallDestinationWhereUniqueInput = {
  AND?: InputMaybe<Array<CallDestinationWhereInput>>;
  NOT?: InputMaybe<Array<CallDestinationWhereInput>>;
  OR?: InputMaybe<Array<CallDestinationWhereInput>>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  dialCode?: InputMaybe<StringFilter>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  flatrateInt1?: InputMaybe<BoolFilter>;
  flatrateInt2?: InputMaybe<BoolFilter>;
  flatrateInt3?: InputMaybe<BoolFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  rateVK?: InputMaybe<FloatFilter>;
};

export type Carrier = {
  __typename?: 'Carrier';
  _count?: Maybe<CarrierCount>;
  id: Scalars['Int']['output'];
  itu: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CarrierCount = {
  __typename?: 'CarrierCount';
  availabilityCarrier: Scalars['Int']['output'];
  availabilityReplicates: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
};


export type CarrierCountAvailabilityCarrierArgs = {
  where?: InputMaybe<AvailabilityCarrierWhereInput>;
};


export type CarrierCountAvailabilityReplicatesArgs = {
  where?: InputMaybe<AvailabilityReplicateWhereInput>;
};


export type CarrierCountProductsArgs = {
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierCreateNestedOneWithoutAvailabilityCarrierInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<CarrierCreateWithoutAvailabilityCarrierInput>;
};

export type CarrierCreateNestedOneWithoutAvailabilityReplicatesInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutAvailabilityReplicatesInput>;
  create?: InputMaybe<CarrierCreateWithoutAvailabilityReplicatesInput>;
};

export type CarrierCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CarrierCreateWithoutProductsInput>;
};

export type CarrierCreateOrConnectWithoutAvailabilityCarrierInput = {
  create: CarrierCreateWithoutAvailabilityCarrierInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutAvailabilityReplicatesInput = {
  create: CarrierCreateWithoutAvailabilityReplicatesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutProductsInput = {
  create: CarrierCreateWithoutProductsInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateWithoutAvailabilityCarrierInput = {
  availabilityReplicates?: InputMaybe<AvailabilityReplicateCreateNestedManyWithoutCarrierInput>;
  itu: Scalars['String']['input'];
  name: Scalars['String']['input'];
  products?: InputMaybe<CarrierProductCreateNestedManyWithoutCarrierInput>;
};

export type CarrierCreateWithoutAvailabilityReplicatesInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierCreateNestedManyWithoutCarrierInput>;
  itu: Scalars['String']['input'];
  name: Scalars['String']['input'];
  products?: InputMaybe<CarrierProductCreateNestedManyWithoutCarrierInput>;
};

export type CarrierCreateWithoutProductsInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierCreateNestedManyWithoutCarrierInput>;
  availabilityReplicates?: InputMaybe<AvailabilityReplicateCreateNestedManyWithoutCarrierInput>;
  itu: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CarrierOrderByWithRelationInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierOrderByRelationAggregateInput>;
  availabilityReplicates?: InputMaybe<AvailabilityReplicateOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  itu?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  products?: InputMaybe<CarrierProductOrderByRelationAggregateInput>;
};

export type CarrierProduct = {
  __typename?: 'CarrierProduct';
  _count?: Maybe<CarrierProductCount>;
  accesses: Array<Access>;
  availabilityProducts: Array<AvailabilityProduct>;
  carrier: Carrier;
  carrierId: Scalars['Int']['output'];
  connectionType?: Maybe<ConnectionType>;
  ethernets: Array<Ethernet>;
  id: Scalars['Int']['output'];
  maxDownstream?: Maybe<Scalars['Float']['output']>;
  maxUpstream?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  setupDuration?: Maybe<Scalars['Int']['output']>;
  supportLineDiagnose: Scalars['Boolean']['output'];
  supportLineReset: Scalars['Boolean']['output'];
  usernamePrefix?: Maybe<Scalars['String']['output']>;
  usernameSuffix?: Maybe<Scalars['String']['output']>;
};


export type CarrierProductAccessesArgs = {
  cursor?: InputMaybe<AccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessWhereInput>;
};


export type CarrierProductAvailabilityProductsArgs = {
  cursor?: InputMaybe<AvailabilityProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<AvailabilityProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AvailabilityProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvailabilityProductWhereInput>;
};


export type CarrierProductEthernetsArgs = {
  cursor?: InputMaybe<EthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<EthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EthernetWhereInput>;
};

export type CarrierProductCount = {
  __typename?: 'CarrierProductCount';
  accesses: Scalars['Int']['output'];
  availabilityProducts: Scalars['Int']['output'];
  ethernets: Scalars['Int']['output'];
};


export type CarrierProductCountAccessesArgs = {
  where?: InputMaybe<AccessWhereInput>;
};


export type CarrierProductCountAvailabilityProductsArgs = {
  where?: InputMaybe<AvailabilityProductWhereInput>;
};


export type CarrierProductCountEthernetsArgs = {
  where?: InputMaybe<EthernetWhereInput>;
};

export type CarrierProductCreateManyCarrierInput = {
  connectionType?: InputMaybe<ConnectionType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateManyCarrierInputEnvelope = {
  data: Array<CarrierProductCreateManyCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarrierProductCreateManyProductInput = {
  carrierId: Scalars['Int']['input'];
  connectionType?: InputMaybe<ConnectionType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateManyProductInputEnvelope = {
  data: Array<CarrierProductCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarrierProductCreateNestedManyWithoutCarrierInput = {
  connect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierProductCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<CarrierProductCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<CarrierProductCreateManyCarrierInputEnvelope>;
};

export type CarrierProductCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierProductCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<CarrierProductCreateWithoutProductInput>>;
  createMany?: InputMaybe<CarrierProductCreateManyProductInputEnvelope>;
};

export type CarrierProductCreateNestedOneWithoutAccessesInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<CarrierProductCreateWithoutAccessesInput>;
};

export type CarrierProductCreateNestedOneWithoutAvailabilityProductsInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutAvailabilityProductsInput>;
  create?: InputMaybe<CarrierProductCreateWithoutAvailabilityProductsInput>;
};

export type CarrierProductCreateNestedOneWithoutEthernetsInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutEthernetsInput>;
  create?: InputMaybe<CarrierProductCreateWithoutEthernetsInput>;
};

export type CarrierProductCreateOrConnectWithoutAccessesInput = {
  create: CarrierProductCreateWithoutAccessesInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductCreateOrConnectWithoutAvailabilityProductsInput = {
  create: CarrierProductCreateWithoutAvailabilityProductsInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductCreateOrConnectWithoutCarrierInput = {
  create: CarrierProductCreateWithoutCarrierInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductCreateOrConnectWithoutEthernetsInput = {
  create: CarrierProductCreateWithoutEthernetsInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductCreateOrConnectWithoutProductInput = {
  create: CarrierProductCreateWithoutProductInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductCreateWithoutAccessesInput = {
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutCarrierProductInput>;
  carrier: CarrierCreateNestedOneWithoutProductsInput;
  connectionType?: InputMaybe<ConnectionType>;
  ethernets?: InputMaybe<EthernetCreateNestedManyWithoutCarrierProductInput>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  product: ProductCreateNestedOneWithoutCarrierProductsInput;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateWithoutAvailabilityProductsInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutCarrierProductInput>;
  carrier: CarrierCreateNestedOneWithoutProductsInput;
  connectionType?: InputMaybe<ConnectionType>;
  ethernets?: InputMaybe<EthernetCreateNestedManyWithoutCarrierProductInput>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  product: ProductCreateNestedOneWithoutCarrierProductsInput;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateWithoutCarrierInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutCarrierProductInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutCarrierProductInput>;
  connectionType?: InputMaybe<ConnectionType>;
  ethernets?: InputMaybe<EthernetCreateNestedManyWithoutCarrierProductInput>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  product: ProductCreateNestedOneWithoutCarrierProductsInput;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateWithoutEthernetsInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutCarrierProductInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutCarrierProductInput>;
  carrier: CarrierCreateNestedOneWithoutProductsInput;
  connectionType?: InputMaybe<ConnectionType>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  product: ProductCreateNestedOneWithoutCarrierProductsInput;
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductCreateWithoutProductInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutCarrierProductInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductCreateNestedManyWithoutCarrierProductInput>;
  carrier: CarrierCreateNestedOneWithoutProductsInput;
  connectionType?: InputMaybe<ConnectionType>;
  ethernets?: InputMaybe<EthernetCreateNestedManyWithoutCarrierProductInput>;
  maxDownstream?: InputMaybe<Scalars['Float']['input']>;
  maxUpstream?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  setupDuration?: InputMaybe<Scalars['Int']['input']>;
  supportLineDiagnose?: InputMaybe<Scalars['Boolean']['input']>;
  supportLineReset?: InputMaybe<Scalars['Boolean']['input']>;
  usernamePrefix?: InputMaybe<Scalars['String']['input']>;
  usernameSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierProductListRelationFilter = {
  every?: InputMaybe<CarrierProductWhereInput>;
  none?: InputMaybe<CarrierProductWhereInput>;
  some?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CarrierProductOrderByWithRelationInput = {
  accesses?: InputMaybe<AccessOrderByRelationAggregateInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductOrderByRelationAggregateInput>;
  carrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  carrierId?: InputMaybe<SortOrder>;
  connectionType?: InputMaybe<SortOrderInput>;
  ethernets?: InputMaybe<EthernetOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  maxDownstream?: InputMaybe<SortOrderInput>;
  maxUpstream?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  setupDuration?: InputMaybe<SortOrderInput>;
  supportLineDiagnose?: InputMaybe<SortOrder>;
  supportLineReset?: InputMaybe<SortOrder>;
  usernamePrefix?: InputMaybe<SortOrderInput>;
  usernameSuffix?: InputMaybe<SortOrderInput>;
};

export type CarrierProductRelationFilter = {
  is?: InputMaybe<CarrierProductWhereInput>;
  isNot?: InputMaybe<CarrierProductWhereInput>;
};

export enum CarrierProductScalarFieldEnum {
  CarrierId = 'carrierId',
  ConnectionType = 'connectionType',
  Id = 'id',
  MaxDownstream = 'maxDownstream',
  MaxUpstream = 'maxUpstream',
  Name = 'name',
  ProductId = 'productId',
  SetupDuration = 'setupDuration',
  SupportLineDiagnose = 'supportLineDiagnose',
  SupportLineReset = 'supportLineReset',
  UsernamePrefix = 'usernamePrefix',
  UsernameSuffix = 'usernameSuffix'
}

export type CarrierProductScalarWhereInput = {
  AND?: InputMaybe<Array<CarrierProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<CarrierProductScalarWhereInput>>;
  OR?: InputMaybe<Array<CarrierProductScalarWhereInput>>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  productId?: InputMaybe<IntFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
  supportLineDiagnose?: InputMaybe<BoolFilter>;
  supportLineReset?: InputMaybe<BoolFilter>;
  usernamePrefix?: InputMaybe<StringNullableFilter>;
  usernameSuffix?: InputMaybe<StringNullableFilter>;
};

export type CarrierProductUpdateManyMutationInput = {
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpdateManyWithWhereWithoutCarrierInput = {
  data: CarrierProductUpdateManyMutationInput;
  where: CarrierProductScalarWhereInput;
};

export type CarrierProductUpdateManyWithWhereWithoutProductInput = {
  data: CarrierProductUpdateManyMutationInput;
  where: CarrierProductScalarWhereInput;
};

export type CarrierProductUpdateManyWithoutCarrierNestedInput = {
  connect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierProductCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<CarrierProductCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<CarrierProductCreateManyCarrierInputEnvelope>;
  delete?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CarrierProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  set?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  update?: InputMaybe<Array<CarrierProductUpdateWithWhereUniqueWithoutCarrierInput>>;
  updateMany?: InputMaybe<Array<CarrierProductUpdateManyWithWhereWithoutCarrierInput>>;
  upsert?: InputMaybe<Array<CarrierProductUpsertWithWhereUniqueWithoutCarrierInput>>;
};

export type CarrierProductUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierProductCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<CarrierProductCreateWithoutProductInput>>;
  createMany?: InputMaybe<CarrierProductCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CarrierProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  set?: InputMaybe<Array<CarrierProductWhereUniqueInput>>;
  update?: InputMaybe<Array<CarrierProductUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<CarrierProductUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<CarrierProductUpsertWithWhereUniqueWithoutProductInput>>;
};

export type CarrierProductUpdateOneRequiredWithoutAccessesNestedInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<CarrierProductCreateWithoutAccessesInput>;
  update?: InputMaybe<CarrierProductUpdateToOneWithWhereWithoutAccessesInput>;
  upsert?: InputMaybe<CarrierProductUpsertWithoutAccessesInput>;
};

export type CarrierProductUpdateOneRequiredWithoutAvailabilityProductsNestedInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutAvailabilityProductsInput>;
  create?: InputMaybe<CarrierProductCreateWithoutAvailabilityProductsInput>;
  update?: InputMaybe<CarrierProductUpdateToOneWithWhereWithoutAvailabilityProductsInput>;
  upsert?: InputMaybe<CarrierProductUpsertWithoutAvailabilityProductsInput>;
};

export type CarrierProductUpdateOneRequiredWithoutEthernetsNestedInput = {
  connect?: InputMaybe<CarrierProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierProductCreateOrConnectWithoutEthernetsInput>;
  create?: InputMaybe<CarrierProductCreateWithoutEthernetsInput>;
  update?: InputMaybe<CarrierProductUpdateToOneWithWhereWithoutEthernetsInput>;
  upsert?: InputMaybe<CarrierProductUpsertWithoutEthernetsInput>;
};

export type CarrierProductUpdateToOneWithWhereWithoutAccessesInput = {
  data: CarrierProductUpdateWithoutAccessesInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductUpdateToOneWithWhereWithoutAvailabilityProductsInput = {
  data: CarrierProductUpdateWithoutAvailabilityProductsInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductUpdateToOneWithWhereWithoutEthernetsInput = {
  data: CarrierProductUpdateWithoutEthernetsInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductUpdateWithWhereUniqueWithoutCarrierInput = {
  data: CarrierProductUpdateWithoutCarrierInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductUpdateWithWhereUniqueWithoutProductInput = {
  data: CarrierProductUpdateWithoutProductInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductUpdateWithoutAccessesInput = {
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutCarrierProductNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutProductsNestedInput>;
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  ethernets?: InputMaybe<EthernetUpdateManyWithoutCarrierProductNestedInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCarrierProductsNestedInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpdateWithoutAvailabilityProductsInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutCarrierProductNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutProductsNestedInput>;
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  ethernets?: InputMaybe<EthernetUpdateManyWithoutCarrierProductNestedInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCarrierProductsNestedInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpdateWithoutCarrierInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutCarrierProductNestedInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutCarrierProductNestedInput>;
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  ethernets?: InputMaybe<EthernetUpdateManyWithoutCarrierProductNestedInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCarrierProductsNestedInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpdateWithoutEthernetsInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutCarrierProductNestedInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutCarrierProductNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutProductsNestedInput>;
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutCarrierProductsNestedInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpdateWithoutProductInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutCarrierProductNestedInput>;
  availabilityProducts?: InputMaybe<AvailabilityProductUpdateManyWithoutCarrierProductNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutProductsNestedInput>;
  connectionType?: InputMaybe<NullableEnumConnectionTypeFieldUpdateOperationsInput>;
  ethernets?: InputMaybe<EthernetUpdateManyWithoutCarrierProductNestedInput>;
  maxDownstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxUpstream?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  setupDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supportLineDiagnose?: InputMaybe<BoolFieldUpdateOperationsInput>;
  supportLineReset?: InputMaybe<BoolFieldUpdateOperationsInput>;
  usernamePrefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CarrierProductUpsertWithWhereUniqueWithoutCarrierInput = {
  create: CarrierProductCreateWithoutCarrierInput;
  update: CarrierProductUpdateWithoutCarrierInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductUpsertWithWhereUniqueWithoutProductInput = {
  create: CarrierProductCreateWithoutProductInput;
  update: CarrierProductUpdateWithoutProductInput;
  where: CarrierProductWhereUniqueInput;
};

export type CarrierProductUpsertWithoutAccessesInput = {
  create: CarrierProductCreateWithoutAccessesInput;
  update: CarrierProductUpdateWithoutAccessesInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductUpsertWithoutAvailabilityProductsInput = {
  create: CarrierProductCreateWithoutAvailabilityProductsInput;
  update: CarrierProductUpdateWithoutAvailabilityProductsInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductUpsertWithoutEthernetsInput = {
  create: CarrierProductCreateWithoutEthernetsInput;
  update: CarrierProductUpdateWithoutEthernetsInput;
  where?: InputMaybe<CarrierProductWhereInput>;
};

export type CarrierProductWhereInput = {
  AND?: InputMaybe<Array<CarrierProductWhereInput>>;
  NOT?: InputMaybe<Array<CarrierProductWhereInput>>;
  OR?: InputMaybe<Array<CarrierProductWhereInput>>;
  accesses?: InputMaybe<AccessListRelationFilter>;
  availabilityProducts?: InputMaybe<AvailabilityProductListRelationFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeNullableFilter>;
  ethernets?: InputMaybe<EthernetListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
  supportLineDiagnose?: InputMaybe<BoolFilter>;
  supportLineReset?: InputMaybe<BoolFilter>;
  usernamePrefix?: InputMaybe<StringNullableFilter>;
  usernameSuffix?: InputMaybe<StringNullableFilter>;
};

export type CarrierProductWhereUniqueInput = {
  AND?: InputMaybe<Array<CarrierProductWhereInput>>;
  NOT?: InputMaybe<Array<CarrierProductWhereInput>>;
  OR?: InputMaybe<Array<CarrierProductWhereInput>>;
  accesses?: InputMaybe<AccessListRelationFilter>;
  availabilityProducts?: InputMaybe<AvailabilityProductListRelationFilter>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<IntFilter>;
  connectionType?: InputMaybe<EnumConnectionTypeNullableFilter>;
  ethernets?: InputMaybe<EthernetListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxDownstream?: InputMaybe<FloatNullableFilter>;
  maxUpstream?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
  setupDuration?: InputMaybe<IntNullableFilter>;
  supportLineDiagnose?: InputMaybe<BoolFilter>;
  supportLineReset?: InputMaybe<BoolFilter>;
  usernamePrefix?: InputMaybe<StringNullableFilter>;
  usernameSuffix?: InputMaybe<StringNullableFilter>;
};

export type CarrierRelationFilter = {
  is?: InputMaybe<CarrierWhereInput>;
  isNot?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateOneRequiredWithoutAvailabilityCarrierNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutAvailabilityCarrierInput>;
  create?: InputMaybe<CarrierCreateWithoutAvailabilityCarrierInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutAvailabilityCarrierInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutAvailabilityCarrierInput>;
};

export type CarrierUpdateOneRequiredWithoutAvailabilityReplicatesNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutAvailabilityReplicatesInput>;
  create?: InputMaybe<CarrierCreateWithoutAvailabilityReplicatesInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutAvailabilityReplicatesInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutAvailabilityReplicatesInput>;
};

export type CarrierUpdateOneRequiredWithoutProductsNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CarrierCreateWithoutProductsInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutProductsInput>;
};

export type CarrierUpdateToOneWithWhereWithoutAvailabilityCarrierInput = {
  data: CarrierUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutAvailabilityReplicatesInput = {
  data: CarrierUpdateWithoutAvailabilityReplicatesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutProductsInput = {
  data: CarrierUpdateWithoutProductsInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateWithoutAvailabilityCarrierInput = {
  availabilityReplicates?: InputMaybe<AvailabilityReplicateUpdateManyWithoutCarrierNestedInput>;
  itu?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  products?: InputMaybe<CarrierProductUpdateManyWithoutCarrierNestedInput>;
};

export type CarrierUpdateWithoutAvailabilityReplicatesInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierUpdateManyWithoutCarrierNestedInput>;
  itu?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  products?: InputMaybe<CarrierProductUpdateManyWithoutCarrierNestedInput>;
};

export type CarrierUpdateWithoutProductsInput = {
  availabilityCarrier?: InputMaybe<AvailabilityCarrierUpdateManyWithoutCarrierNestedInput>;
  availabilityReplicates?: InputMaybe<AvailabilityReplicateUpdateManyWithoutCarrierNestedInput>;
  itu?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CarrierUpsertWithoutAvailabilityCarrierInput = {
  create: CarrierCreateWithoutAvailabilityCarrierInput;
  update: CarrierUpdateWithoutAvailabilityCarrierInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutAvailabilityReplicatesInput = {
  create: CarrierCreateWithoutAvailabilityReplicatesInput;
  update: CarrierUpdateWithoutAvailabilityReplicatesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutProductsInput = {
  create: CarrierCreateWithoutProductsInput;
  update: CarrierUpdateWithoutProductsInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierWhereInput = {
  AND?: InputMaybe<Array<CarrierWhereInput>>;
  NOT?: InputMaybe<Array<CarrierWhereInput>>;
  OR?: InputMaybe<Array<CarrierWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  availabilityReplicates?: InputMaybe<AvailabilityReplicateListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  itu?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<CarrierProductListRelationFilter>;
};

export type CarrierWhereUniqueInput = {
  AND?: InputMaybe<Array<CarrierWhereInput>>;
  NOT?: InputMaybe<Array<CarrierWhereInput>>;
  OR?: InputMaybe<Array<CarrierWhereInput>>;
  availabilityCarrier?: InputMaybe<AvailabilityCarrierListRelationFilter>;
  availabilityReplicates?: InputMaybe<AvailabilityReplicateListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itu?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<CarrierProductListRelationFilter>;
};

export type Cdr = {
  __typename?: 'Cdr';
  calldate: Scalars['DateTimeISO']['output'];
  destination?: Maybe<CallDestination>;
  destinationId?: Maybe<Scalars['Int']['output']>;
  direction: CdrDirection;
  disposition: CdrDisposition;
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  localId: Scalars['String']['output'];
  number?: Maybe<Number>;
  numberId?: Maybe<Scalars['Int']['output']>;
  remoteId: Scalars['String']['output'];
  trunk: Trunk;
  trunkId: Scalars['Int']['output'];
};


export type CdrDestinationArgs = {
  where?: InputMaybe<CallDestinationWhereInput>;
};


export type CdrNumberArgs = {
  where?: InputMaybe<NumberWhereInput>;
};

export type CdrByDestination = {
  __typename?: 'CdrByDestination';
  destination: Scalars['String']['output'];
  minutes: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
};

export type CdrCreateManyNumberInput = {
  calldate: Scalars['DateTimeISO']['input'];
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  direction: CdrDirection;
  disposition: CdrDisposition;
  duration: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  localId: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  trunkId: Scalars['Int']['input'];
};

export type CdrCreateManyNumberInputEnvelope = {
  data: Array<CdrCreateManyNumberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CdrCreateManyTrunkInput = {
  calldate: Scalars['DateTimeISO']['input'];
  destinationId?: InputMaybe<Scalars['Int']['input']>;
  direction: CdrDirection;
  disposition: CdrDisposition;
  duration: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  localId: Scalars['String']['input'];
  numberId?: InputMaybe<Scalars['Int']['input']>;
  remoteId: Scalars['String']['input'];
};

export type CdrCreateManyTrunkInputEnvelope = {
  data: Array<CdrCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CdrCreateNestedManyWithoutNumberInput = {
  connect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CdrCreateOrConnectWithoutNumberInput>>;
  create?: InputMaybe<Array<CdrCreateWithoutNumberInput>>;
  createMany?: InputMaybe<CdrCreateManyNumberInputEnvelope>;
};

export type CdrCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CdrCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<CdrCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<CdrCreateManyTrunkInputEnvelope>;
};

export type CdrCreateOrConnectWithoutNumberInput = {
  create: CdrCreateWithoutNumberInput;
  where: CdrWhereUniqueInput;
};

export type CdrCreateOrConnectWithoutTrunkInput = {
  create: CdrCreateWithoutTrunkInput;
  where: CdrWhereUniqueInput;
};

export type CdrCreateWithoutNumberInput = {
  calldate: Scalars['DateTimeISO']['input'];
  destination?: InputMaybe<CallDestinationCreateNestedOneWithoutCdrsInput>;
  direction: CdrDirection;
  disposition: CdrDisposition;
  duration: Scalars['Int']['input'];
  localId: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  trunk: TrunkCreateNestedOneWithoutCdrsInput;
};

export type CdrCreateWithoutTrunkInput = {
  calldate: Scalars['DateTimeISO']['input'];
  destination?: InputMaybe<CallDestinationCreateNestedOneWithoutCdrsInput>;
  direction: CdrDirection;
  disposition: CdrDisposition;
  duration: Scalars['Int']['input'];
  localId: Scalars['String']['input'];
  number?: InputMaybe<NumberCreateNestedOneWithoutCdrsInput>;
  remoteId: Scalars['String']['input'];
};

export enum CdrDirection {
  In = 'IN',
  Out = 'OUT'
}

export enum CdrDisposition {
  Answered = 'ANSWERED',
  Busy = 'BUSY',
  Congestion = 'CONGESTION',
  Failed = 'FAILED',
  NoAnswer = 'NO_ANSWER',
  Unknown = 'UNKNOWN'
}

export type CdrListRelationFilter = {
  every?: InputMaybe<CdrWhereInput>;
  none?: InputMaybe<CdrWhereInput>;
  some?: InputMaybe<CdrWhereInput>;
};

export type CdrOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CdrOrderByWithRelationInput = {
  calldate?: InputMaybe<SortOrder>;
  destination?: InputMaybe<CallDestinationOrderByWithRelationInput>;
  destinationId?: InputMaybe<SortOrderInput>;
  direction?: InputMaybe<SortOrder>;
  disposition?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  localId?: InputMaybe<SortOrder>;
  number?: InputMaybe<NumberOrderByWithRelationInput>;
  numberId?: InputMaybe<SortOrderInput>;
  remoteId?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrder>;
};

export enum CdrScalarFieldEnum {
  Calldate = 'calldate',
  DestinationId = 'destinationId',
  Direction = 'direction',
  Disposition = 'disposition',
  Duration = 'duration',
  Id = 'id',
  LocalId = 'localId',
  NumberId = 'numberId',
  RemoteId = 'remoteId',
  TrunkId = 'trunkId'
}

export type CdrScalarWhereInput = {
  AND?: InputMaybe<Array<CdrScalarWhereInput>>;
  NOT?: InputMaybe<Array<CdrScalarWhereInput>>;
  OR?: InputMaybe<Array<CdrScalarWhereInput>>;
  calldate?: InputMaybe<DateTimeFilter>;
  destinationId?: InputMaybe<IntNullableFilter>;
  direction?: InputMaybe<EnumCdrDirectionFilter>;
  disposition?: InputMaybe<EnumCdrDispositionFilter>;
  duration?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  localId?: InputMaybe<StringFilter>;
  numberId?: InputMaybe<IntNullableFilter>;
  remoteId?: InputMaybe<StringFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type CdrUpdateManyMutationInput = {
  calldate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  direction?: InputMaybe<EnumCdrDirectionFieldUpdateOperationsInput>;
  disposition?: InputMaybe<EnumCdrDispositionFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  localId?: InputMaybe<StringFieldUpdateOperationsInput>;
  remoteId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CdrUpdateManyWithWhereWithoutNumberInput = {
  data: CdrUpdateManyMutationInput;
  where: CdrScalarWhereInput;
};

export type CdrUpdateManyWithWhereWithoutTrunkInput = {
  data: CdrUpdateManyMutationInput;
  where: CdrScalarWhereInput;
};

export type CdrUpdateManyWithoutNumberNestedInput = {
  connect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CdrCreateOrConnectWithoutNumberInput>>;
  create?: InputMaybe<Array<CdrCreateWithoutNumberInput>>;
  createMany?: InputMaybe<CdrCreateManyNumberInputEnvelope>;
  delete?: InputMaybe<Array<CdrWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CdrScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  set?: InputMaybe<Array<CdrWhereUniqueInput>>;
  update?: InputMaybe<Array<CdrUpdateWithWhereUniqueWithoutNumberInput>>;
  updateMany?: InputMaybe<Array<CdrUpdateManyWithWhereWithoutNumberInput>>;
  upsert?: InputMaybe<Array<CdrUpsertWithWhereUniqueWithoutNumberInput>>;
};

export type CdrUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CdrCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<CdrCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<CdrCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<CdrWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CdrScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CdrWhereUniqueInput>>;
  set?: InputMaybe<Array<CdrWhereUniqueInput>>;
  update?: InputMaybe<Array<CdrUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<CdrUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<CdrUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type CdrUpdateWithWhereUniqueWithoutNumberInput = {
  data: CdrUpdateWithoutNumberInput;
  where: CdrWhereUniqueInput;
};

export type CdrUpdateWithWhereUniqueWithoutTrunkInput = {
  data: CdrUpdateWithoutTrunkInput;
  where: CdrWhereUniqueInput;
};

export type CdrUpdateWithoutNumberInput = {
  calldate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  destination?: InputMaybe<CallDestinationUpdateOneWithoutCdrsNestedInput>;
  direction?: InputMaybe<EnumCdrDirectionFieldUpdateOperationsInput>;
  disposition?: InputMaybe<EnumCdrDispositionFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  localId?: InputMaybe<StringFieldUpdateOperationsInput>;
  remoteId?: InputMaybe<StringFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneRequiredWithoutCdrsNestedInput>;
};

export type CdrUpdateWithoutTrunkInput = {
  calldate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  destination?: InputMaybe<CallDestinationUpdateOneWithoutCdrsNestedInput>;
  direction?: InputMaybe<EnumCdrDirectionFieldUpdateOperationsInput>;
  disposition?: InputMaybe<EnumCdrDispositionFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  localId?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NumberUpdateOneWithoutCdrsNestedInput>;
  remoteId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CdrUpsertWithWhereUniqueWithoutNumberInput = {
  create: CdrCreateWithoutNumberInput;
  update: CdrUpdateWithoutNumberInput;
  where: CdrWhereUniqueInput;
};

export type CdrUpsertWithWhereUniqueWithoutTrunkInput = {
  create: CdrCreateWithoutTrunkInput;
  update: CdrUpdateWithoutTrunkInput;
  where: CdrWhereUniqueInput;
};

export type CdrWhereInput = {
  AND?: InputMaybe<Array<CdrWhereInput>>;
  NOT?: InputMaybe<Array<CdrWhereInput>>;
  OR?: InputMaybe<Array<CdrWhereInput>>;
  calldate?: InputMaybe<DateTimeFilter>;
  destination?: InputMaybe<CallDestinationNullableRelationFilter>;
  destinationId?: InputMaybe<IntNullableFilter>;
  direction?: InputMaybe<EnumCdrDirectionFilter>;
  disposition?: InputMaybe<EnumCdrDispositionFilter>;
  duration?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  localId?: InputMaybe<StringFilter>;
  number?: InputMaybe<NumberNullableRelationFilter>;
  numberId?: InputMaybe<IntNullableFilter>;
  remoteId?: InputMaybe<StringFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type CdrWhereUniqueInput = {
  AND?: InputMaybe<Array<CdrWhereInput>>;
  NOT?: InputMaybe<Array<CdrWhereInput>>;
  OR?: InputMaybe<Array<CdrWhereInput>>;
  calldate?: InputMaybe<DateTimeFilter>;
  destination?: InputMaybe<CallDestinationNullableRelationFilter>;
  destinationId?: InputMaybe<IntNullableFilter>;
  direction?: InputMaybe<EnumCdrDirectionFilter>;
  disposition?: InputMaybe<EnumCdrDispositionFilter>;
  duration?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  localId?: InputMaybe<StringFilter>;
  number?: InputMaybe<NumberNullableRelationFilter>;
  numberId?: InputMaybe<IntNullableFilter>;
  remoteId?: InputMaybe<StringFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

/** New Password */
export type ChangePwInput = {
  password: Scalars['String']['input'];
};

export type ChangePwResponse = {
  __typename?: 'ChangePWResponse';
  success: Scalars['Boolean']['output'];
};

export enum ConnectionType {
  Adsl = 'ADSL',
  Cellular = 'CELLULAR',
  FtthAsym = 'FTTH_ASYM',
  FtthSym = 'FTTH_SYM',
  Vdsl = 'VDSL'
}

export enum ConstructionStatus {
  AreaPlanned = 'AREA_PLANNED',
  HomesConnected = 'HOMES_CONNECTED',
  HomesPassed = 'HOMES_PASSED',
  HomesPassedPlus = 'HOMES_PASSED_PLUS',
  HomesPrepared = 'HOMES_PREPARED',
  HomesPreparedPlus = 'HOMES_PREPARED_PLUS',
  HomesReady = 'HOMES_READY',
  NotPlanned = 'NOT_PLANNED',
  PreMarketing = 'PRE_MARKETING',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

export enum ConstructionTechnology {
  GponBPlus = 'GPON_B_PLUS'
}

export type Contact = {
  __typename?: 'Contact';
  customerId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastname: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ContactCreateManyCustomerInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  lastname: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactCreateManyCustomerInputEnvelope = {
  data: Array<ContactCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<ContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<ContactCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<ContactCreateManyCustomerInputEnvelope>;
};

export type ContactCreateOrConnectWithoutCustomerInput = {
  create: ContactCreateWithoutCustomerInput;
  where: ContactWhereUniqueInput;
};

export type ContactCreateWithoutCustomerInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactListRelationFilter = {
  every?: InputMaybe<ContactWhereInput>;
  none?: InputMaybe<ContactWhereInput>;
  some?: InputMaybe<ContactWhereInput>;
};

export type ContactOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContactOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstname?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastname?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
};

export enum ContactScalarFieldEnum {
  CustomerId = 'customerId',
  Email = 'email',
  Firstname = 'firstname',
  Id = 'id',
  Lastname = 'lastname',
  Phone = 'phone'
}

export type ContactScalarWhereInput = {
  AND?: InputMaybe<Array<ContactScalarWhereInput>>;
  NOT?: InputMaybe<Array<ContactScalarWhereInput>>;
  OR?: InputMaybe<Array<ContactScalarWhereInput>>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type ContactUpdateManyMutationInput = {
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ContactUpdateManyWithWhereWithoutCustomerInput = {
  data: ContactUpdateManyMutationInput;
  where: ContactScalarWhereInput;
};

export type ContactUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<ContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<ContactCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<ContactCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<ContactWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContactScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContactWhereUniqueInput>>;
  set?: InputMaybe<Array<ContactWhereUniqueInput>>;
  update?: InputMaybe<Array<ContactUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<ContactUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<ContactUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type ContactUpdateWithWhereUniqueWithoutCustomerInput = {
  data: ContactUpdateWithoutCustomerInput;
  where: ContactWhereUniqueInput;
};

export type ContactUpdateWithoutCustomerInput = {
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ContactUpsertWithWhereUniqueWithoutCustomerInput = {
  create: ContactCreateWithoutCustomerInput;
  update: ContactUpdateWithoutCustomerInput;
  where: ContactWhereUniqueInput;
};

export type ContactWhereInput = {
  AND?: InputMaybe<Array<ContactWhereInput>>;
  NOT?: InputMaybe<Array<ContactWhereInput>>;
  OR?: InputMaybe<Array<ContactWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type ContactWhereUniqueInput = {
  AND?: InputMaybe<Array<ContactWhereInput>>;
  NOT?: InputMaybe<Array<ContactWhereInput>>;
  OR?: InputMaybe<Array<ContactWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type Customer = {
  __typename?: 'Customer';
  _count?: Maybe<CustomerCount>;
  addresses: Array<Address>;
  appProvisioning?: Maybe<AppProvisioning>;
  appProvisioningId?: Maybe<Scalars['Int']['output']>;
  contacts: Array<Contact>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  no?: Maybe<Scalars['Int']['output']>;
  orders: Array<Order>;
  sepa?: Maybe<Sepa>;
  status: CustomerStatus;
};


export type CustomerAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type CustomerAppProvisioningArgs = {
  where?: InputMaybe<AppProvisioningWhereInput>;
};


export type CustomerContactsArgs = {
  cursor?: InputMaybe<ContactWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContactScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContactOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactWhereInput>;
};


export type CustomerOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type CustomerSepaArgs = {
  where?: InputMaybe<SepaWhereInput>;
};

export type CustomerCount = {
  __typename?: 'CustomerCount';
  addresses: Scalars['Int']['output'];
  contacts: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
};


export type CustomerCountAddressesArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type CustomerCountContactsArgs = {
  where?: InputMaybe<ContactWhereInput>;
};


export type CustomerCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type CustomerCreateInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  appProvisioning?: InputMaybe<AppProvisioningCreateNestedOneWithoutCustomersInput>;
  contacts?: InputMaybe<ContactCreateNestedManyWithoutCustomerInput>;
  name: Scalars['String']['input'];
  sepa?: InputMaybe<SepaCreateNestedOneWithoutCustomerInput>;
  status?: InputMaybe<CustomerStatus>;
};

export type CustomerCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
};

export type CustomerCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
};

export type CustomerCreateOrConnectWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateWithoutAddressesInput = {
  appProvisioning?: InputMaybe<AppProvisioningCreateNestedOneWithoutCustomersInput>;
  contacts?: InputMaybe<ContactCreateNestedManyWithoutCustomerInput>;
  name: Scalars['String']['input'];
  sepa?: InputMaybe<SepaCreateNestedOneWithoutCustomerInput>;
  status?: InputMaybe<CustomerStatus>;
};

export type CustomerCreateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  appProvisioning?: InputMaybe<AppProvisioningCreateNestedOneWithoutCustomersInput>;
  contacts?: InputMaybe<ContactCreateNestedManyWithoutCustomerInput>;
  name: Scalars['String']['input'];
  sepa?: InputMaybe<SepaCreateNestedOneWithoutCustomerInput>;
  status?: InputMaybe<CustomerStatus>;
};

export type CustomerListRelationFilter = {
  every?: InputMaybe<CustomerWhereInput>;
  none?: InputMaybe<CustomerWhereInput>;
  some?: InputMaybe<CustomerWhereInput>;
};

export type CustomerNamePartnerIdCompoundUniqueInput = {
  name: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type CustomerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerOrderByWithRelationInput = {
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  appProvisioning?: InputMaybe<AppProvisioningOrderByWithRelationInput>;
  appProvisioningId?: InputMaybe<SortOrderInput>;
  contacts?: InputMaybe<ContactOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  sepa?: InputMaybe<SepaOrderByWithRelationInput>;
  status?: InputMaybe<SortOrder>;
};

export type CustomerRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export enum CustomerScalarFieldEnum {
  AppProvisioningId = 'appProvisioningId',
  Id = 'id',
  Name = 'name',
  No = 'no',
  PartnerId = 'partnerId',
  Status = 'status'
}

export enum CustomerStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export type CustomerUpdateInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  appProvisioning?: InputMaybe<AppProvisioningUpdateOneWithoutCustomersNestedInput>;
  contacts?: InputMaybe<ContactUpdateManyWithoutCustomerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sepa?: InputMaybe<SepaUpdateOneWithoutCustomerNestedInput>;
  status?: InputMaybe<EnumCustomerStatusFieldUpdateOperationsInput>;
};

export type CustomerUpdateOneRequiredWithoutAddressesNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutAddressesInput>;
};

export type CustomerUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutOrdersInput>;
};

export type CustomerUpdateToOneWithWhereWithoutAddressesInput = {
  data: CustomerUpdateWithoutAddressesInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateToOneWithWhereWithoutOrdersInput = {
  data: CustomerUpdateWithoutOrdersInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateWithoutAddressesInput = {
  appProvisioning?: InputMaybe<AppProvisioningUpdateOneWithoutCustomersNestedInput>;
  contacts?: InputMaybe<ContactUpdateManyWithoutCustomerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sepa?: InputMaybe<SepaUpdateOneWithoutCustomerNestedInput>;
  status?: InputMaybe<EnumCustomerStatusFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  appProvisioning?: InputMaybe<AppProvisioningUpdateOneWithoutCustomersNestedInput>;
  contacts?: InputMaybe<ContactUpdateManyWithoutCustomerNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sepa?: InputMaybe<SepaUpdateOneWithoutCustomerNestedInput>;
  status?: InputMaybe<EnumCustomerStatusFieldUpdateOperationsInput>;
};

export type CustomerUpsertWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  update: CustomerUpdateWithoutAddressesInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpsertWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  update: CustomerUpdateWithoutOrdersInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  appProvisioning?: InputMaybe<AppProvisioningNullableRelationFilter>;
  appProvisioningId?: InputMaybe<IntNullableFilter>;
  contacts?: InputMaybe<ContactListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  sepa?: InputMaybe<SepaNullableRelationFilter>;
  status?: InputMaybe<EnumCustomerStatusFilter>;
};

export type CustomerWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  appProvisioning?: InputMaybe<AppProvisioningNullableRelationFilter>;
  appProvisioningId?: InputMaybe<IntNullableFilter>;
  contacts?: InputMaybe<ContactListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  name_partnerId?: InputMaybe<CustomerNamePartnerIdCompoundUniqueInput>;
  sepa?: InputMaybe<SepaNullableRelationFilter>;
  status?: InputMaybe<EnumCustomerStatusFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export enum Delivery {
  AtPorting = 'AT_PORTING',
  DesiredDate = 'DESIRED_DATE',
  SoonAsPossible = 'SOON_AS_POSSIBLE'
}

export type Ekp = {
  __typename?: 'Ekp';
  _count?: Maybe<EkpCount>;
  email?: Maybe<Scalars['String']['output']>;
  favorite: Scalars['Boolean']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itu?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  wbci: Scalars['Boolean']['output'];
};

export type EkpCount = {
  __typename?: 'EkpCount';
  portingAbg: Scalars['Int']['output'];
};


export type EkpCountPortingAbgArgs = {
  where?: InputMaybe<PortingWhereInput>;
};

export type EkpCreateNestedOneWithoutPortingAbgInput = {
  connect?: InputMaybe<EkpWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EkpCreateOrConnectWithoutPortingAbgInput>;
  create?: InputMaybe<EkpCreateWithoutPortingAbgInput>;
};

export type EkpCreateOrConnectWithoutPortingAbgInput = {
  create: EkpCreateWithoutPortingAbgInput;
  where: EkpWhereUniqueInput;
};

export type EkpCreateWithoutPortingAbgInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  itu?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  wbci: Scalars['Boolean']['input'];
};

export type EkpOrderByWithRelationInput = {
  email?: InputMaybe<SortOrderInput>;
  favorite?: InputMaybe<SortOrder>;
  fax?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  itu?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  portingAbg?: InputMaybe<PortingOrderByRelationAggregateInput>;
  wbci?: InputMaybe<SortOrder>;
};

export type EkpRelationFilter = {
  is?: InputMaybe<EkpWhereInput>;
  isNot?: InputMaybe<EkpWhereInput>;
};

export enum EkpScalarFieldEnum {
  Email = 'email',
  Favorite = 'favorite',
  Fax = 'fax',
  Id = 'id',
  Itu = 'itu',
  Name = 'name',
  Wbci = 'wbci'
}

export type EkpUpdateOneRequiredWithoutPortingAbgNestedInput = {
  connect?: InputMaybe<EkpWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EkpCreateOrConnectWithoutPortingAbgInput>;
  create?: InputMaybe<EkpCreateWithoutPortingAbgInput>;
  update?: InputMaybe<EkpUpdateToOneWithWhereWithoutPortingAbgInput>;
  upsert?: InputMaybe<EkpUpsertWithoutPortingAbgInput>;
};

export type EkpUpdateToOneWithWhereWithoutPortingAbgInput = {
  data: EkpUpdateWithoutPortingAbgInput;
  where?: InputMaybe<EkpWhereInput>;
};

export type EkpUpdateWithoutPortingAbgInput = {
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  favorite?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  wbci?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EkpUpsertWithoutPortingAbgInput = {
  create: EkpCreateWithoutPortingAbgInput;
  update: EkpUpdateWithoutPortingAbgInput;
  where?: InputMaybe<EkpWhereInput>;
};

export type EkpWhereInput = {
  AND?: InputMaybe<Array<EkpWhereInput>>;
  NOT?: InputMaybe<Array<EkpWhereInput>>;
  OR?: InputMaybe<Array<EkpWhereInput>>;
  email?: InputMaybe<StringNullableFilter>;
  favorite?: InputMaybe<BoolFilter>;
  fax?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  itu?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  portingAbg?: InputMaybe<PortingListRelationFilter>;
  wbci?: InputMaybe<BoolFilter>;
};

export type EkpWhereUniqueInput = {
  AND?: InputMaybe<Array<EkpWhereInput>>;
  NOT?: InputMaybe<Array<EkpWhereInput>>;
  OR?: InputMaybe<Array<EkpWhereInput>>;
  email?: InputMaybe<StringNullableFilter>;
  favorite?: InputMaybe<BoolFilter>;
  fax?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itu?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  portingAbg?: InputMaybe<PortingListRelationFilter>;
  wbci?: InputMaybe<BoolFilter>;
};

export type EnumAwsModeFieldUpdateOperationsInput = {
  set?: InputMaybe<AwsMode>;
};

export type EnumAwsModeFilter = {
  equals?: InputMaybe<AwsMode>;
  in?: InputMaybe<Array<AwsMode>>;
  not?: InputMaybe<NestedEnumAwsModeFilter>;
  notIn?: InputMaybe<Array<AwsMode>>;
};

export type EnumCdrDirectionFieldUpdateOperationsInput = {
  set?: InputMaybe<CdrDirection>;
};

export type EnumCdrDirectionFilter = {
  equals?: InputMaybe<CdrDirection>;
  in?: InputMaybe<Array<CdrDirection>>;
  not?: InputMaybe<NestedEnumCdrDirectionFilter>;
  notIn?: InputMaybe<Array<CdrDirection>>;
};

export type EnumCdrDispositionFieldUpdateOperationsInput = {
  set?: InputMaybe<CdrDisposition>;
};

export type EnumCdrDispositionFilter = {
  equals?: InputMaybe<CdrDisposition>;
  in?: InputMaybe<Array<CdrDisposition>>;
  not?: InputMaybe<NestedEnumCdrDispositionFilter>;
  notIn?: InputMaybe<Array<CdrDisposition>>;
};

export type EnumConnectionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ConnectionType>;
};

export type EnumConnectionTypeFilter = {
  equals?: InputMaybe<ConnectionType>;
  in?: InputMaybe<Array<ConnectionType>>;
  not?: InputMaybe<NestedEnumConnectionTypeFilter>;
  notIn?: InputMaybe<Array<ConnectionType>>;
};

export type EnumConnectionTypeNullableFilter = {
  equals?: InputMaybe<ConnectionType>;
  in?: InputMaybe<Array<ConnectionType>>;
  not?: InputMaybe<NestedEnumConnectionTypeNullableFilter>;
  notIn?: InputMaybe<Array<ConnectionType>>;
};

export type EnumConstructionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ConstructionStatus>;
};

export type EnumConstructionStatusFilter = {
  equals?: InputMaybe<ConstructionStatus>;
  in?: InputMaybe<Array<ConstructionStatus>>;
  not?: InputMaybe<NestedEnumConstructionStatusFilter>;
  notIn?: InputMaybe<Array<ConstructionStatus>>;
};

export type EnumConstructionTechnologyNullableFilter = {
  equals?: InputMaybe<ConstructionTechnology>;
  in?: InputMaybe<Array<ConstructionTechnology>>;
  not?: InputMaybe<NestedEnumConstructionTechnologyNullableFilter>;
  notIn?: InputMaybe<Array<ConstructionTechnology>>;
};

export type EnumCustomerStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<CustomerStatus>;
};

export type EnumCustomerStatusFilter = {
  equals?: InputMaybe<CustomerStatus>;
  in?: InputMaybe<Array<CustomerStatus>>;
  not?: InputMaybe<NestedEnumCustomerStatusFilter>;
  notIn?: InputMaybe<Array<CustomerStatus>>;
};

export type EnumDeliveryFieldUpdateOperationsInput = {
  set?: InputMaybe<Delivery>;
};

export type EnumDeliveryFilter = {
  equals?: InputMaybe<Delivery>;
  in?: InputMaybe<Array<Delivery>>;
  not?: InputMaybe<NestedEnumDeliveryFilter>;
  notIn?: InputMaybe<Array<Delivery>>;
};

export type EnumLandlordApprovalNullableFilter = {
  equals?: InputMaybe<LandlordApproval>;
  in?: InputMaybe<Array<LandlordApproval>>;
  not?: InputMaybe<NestedEnumLandlordApprovalNullableFilter>;
  notIn?: InputMaybe<Array<LandlordApproval>>;
};

export type EnumLineDiagnosisStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<LineDiagnosisStatus>;
};

export type EnumLineDiagnosisStatusFilter = {
  equals?: InputMaybe<LineDiagnosisStatus>;
  in?: InputMaybe<Array<LineDiagnosisStatus>>;
  not?: InputMaybe<NestedEnumLineDiagnosisStatusFilter>;
  notIn?: InputMaybe<Array<LineDiagnosisStatus>>;
};

export type EnumLocalExchangeSizeNullableFilter = {
  equals?: InputMaybe<LocalExchangeSize>;
  in?: InputMaybe<Array<LocalExchangeSize>>;
  not?: InputMaybe<NestedEnumLocalExchangeSizeNullableFilter>;
  notIn?: InputMaybe<Array<LocalExchangeSize>>;
};

export type EnumMediaEncryptionFieldUpdateOperationsInput = {
  set?: InputMaybe<MediaEncryption>;
};

export type EnumMediaEncryptionFilter = {
  equals?: InputMaybe<MediaEncryption>;
  in?: InputMaybe<Array<MediaEncryption>>;
  not?: InputMaybe<NestedEnumMediaEncryptionFilter>;
  notIn?: InputMaybe<Array<MediaEncryption>>;
};

export type EnumNumberTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NumberType>;
};

export type EnumNumberTypeFilter = {
  equals?: InputMaybe<NumberType>;
  in?: InputMaybe<Array<NumberType>>;
  not?: InputMaybe<NestedEnumNumberTypeFilter>;
  notIn?: InputMaybe<Array<NumberType>>;
};

export type EnumOrderAccessStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderAccessStatus>;
};

export type EnumOrderAccessStatusFilter = {
  equals?: InputMaybe<OrderAccessStatus>;
  in?: InputMaybe<Array<OrderAccessStatus>>;
  not?: InputMaybe<NestedEnumOrderAccessStatusFilter>;
  notIn?: InputMaybe<Array<OrderAccessStatus>>;
};

export type EnumOrderAccessTypeNullableFilter = {
  equals?: InputMaybe<OrderAccessType>;
  in?: InputMaybe<Array<OrderAccessType>>;
  not?: InputMaybe<NestedEnumOrderAccessTypeNullableFilter>;
  notIn?: InputMaybe<Array<OrderAccessType>>;
};

export type EnumOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatus>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPortingStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PortingStatus>;
};

export type EnumPortingStatusFilter = {
  equals?: InputMaybe<PortingStatus>;
  in?: InputMaybe<Array<PortingStatus>>;
  not?: InputMaybe<NestedEnumPortingStatusFilter>;
  notIn?: InputMaybe<Array<PortingStatus>>;
};

export type EnumWbciResultNullableFilter = {
  equals?: InputMaybe<WbciResult>;
  in?: InputMaybe<Array<WbciResult>>;
  not?: InputMaybe<NestedEnumWbciResultNullableFilter>;
  notIn?: InputMaybe<Array<WbciResult>>;
};

export type EnumWbciStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<WbciStatus>;
};

export type EnumWbciStatusFilter = {
  equals?: InputMaybe<WbciStatus>;
  in?: InputMaybe<Array<WbciStatus>>;
  not?: InputMaybe<NestedEnumWbciStatusFilter>;
  notIn?: InputMaybe<Array<WbciStatus>>;
};

export type Ethernet = {
  __typename?: 'Ethernet';
  _count?: Maybe<EthernetCount>;
  address: Address;
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  carrierProduct: CarrierProduct;
  carrierProductId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  incidents: Array<Incident>;
  vlanId: Scalars['Int']['output'];
};


export type EthernetIncidentsArgs = {
  cursor?: InputMaybe<IncidentWhereUniqueInput>;
  distinct?: InputMaybe<Array<IncidentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IncidentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IncidentWhereInput>;
};

export type EthernetCount = {
  __typename?: 'EthernetCount';
  incidents: Scalars['Int']['output'];
};


export type EthernetCountIncidentsArgs = {
  where?: InputMaybe<IncidentWhereInput>;
};

export type EthernetCreateManyCarrierProductInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  vlanId: Scalars['Int']['input'];
};

export type EthernetCreateManyCarrierProductInputEnvelope = {
  data: Array<EthernetCreateManyCarrierProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EthernetCreateNestedManyWithoutCarrierProductInput = {
  connect?: InputMaybe<Array<EthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EthernetCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<EthernetCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<EthernetCreateManyCarrierProductInputEnvelope>;
};

export type EthernetCreateNestedOneWithoutIncidentsInput = {
  connect?: InputMaybe<EthernetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EthernetCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<EthernetCreateWithoutIncidentsInput>;
};

export type EthernetCreateOrConnectWithoutCarrierProductInput = {
  create: EthernetCreateWithoutCarrierProductInput;
  where: EthernetWhereUniqueInput;
};

export type EthernetCreateOrConnectWithoutIncidentsInput = {
  create: EthernetCreateWithoutIncidentsInput;
  where: EthernetWhereUniqueInput;
};

export type EthernetCreateWithoutCarrierProductInput = {
  address: AddressCreateNestedOneWithoutEthernetsInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutEthernetInput>;
  vlanId: Scalars['Int']['input'];
};

export type EthernetCreateWithoutIncidentsInput = {
  address: AddressCreateNestedOneWithoutEthernetsInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  carrierProduct: CarrierProductCreateNestedOneWithoutEthernetsInput;
  vlanId: Scalars['Int']['input'];
};

export type EthernetListRelationFilter = {
  every?: InputMaybe<EthernetWhereInput>;
  none?: InputMaybe<EthernetWhereInput>;
  some?: InputMaybe<EthernetWhereInput>;
};

export type EthernetNullableRelationFilter = {
  is?: InputMaybe<EthernetWhereInput>;
  isNot?: InputMaybe<EthernetWhereInput>;
};

export type EthernetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EthernetOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  carrierProduct?: InputMaybe<CarrierProductOrderByWithRelationInput>;
  carrierProductId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incidents?: InputMaybe<IncidentOrderByRelationAggregateInput>;
  vlanId?: InputMaybe<SortOrder>;
};

export enum EthernetScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  CarrierProductId = 'carrierProductId',
  Id = 'id',
  VlanId = 'vlanId'
}

export type EthernetScalarWhereInput = {
  AND?: InputMaybe<Array<EthernetScalarWhereInput>>;
  NOT?: InputMaybe<Array<EthernetScalarWhereInput>>;
  OR?: InputMaybe<Array<EthernetScalarWhereInput>>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  vlanId?: InputMaybe<IntFilter>;
};

export type EthernetUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EthernetUpdateManyWithWhereWithoutCarrierProductInput = {
  data: EthernetUpdateManyMutationInput;
  where: EthernetScalarWhereInput;
};

export type EthernetUpdateManyWithoutCarrierProductNestedInput = {
  connect?: InputMaybe<Array<EthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EthernetCreateOrConnectWithoutCarrierProductInput>>;
  create?: InputMaybe<Array<EthernetCreateWithoutCarrierProductInput>>;
  createMany?: InputMaybe<EthernetCreateManyCarrierProductInputEnvelope>;
  delete?: InputMaybe<Array<EthernetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EthernetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EthernetWhereUniqueInput>>;
  set?: InputMaybe<Array<EthernetWhereUniqueInput>>;
  update?: InputMaybe<Array<EthernetUpdateWithWhereUniqueWithoutCarrierProductInput>>;
  updateMany?: InputMaybe<Array<EthernetUpdateManyWithWhereWithoutCarrierProductInput>>;
  upsert?: InputMaybe<Array<EthernetUpsertWithWhereUniqueWithoutCarrierProductInput>>;
};

export type EthernetUpdateOneWithoutIncidentsNestedInput = {
  connect?: InputMaybe<EthernetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EthernetCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<EthernetCreateWithoutIncidentsInput>;
  delete?: InputMaybe<EthernetWhereInput>;
  disconnect?: InputMaybe<EthernetWhereInput>;
  update?: InputMaybe<EthernetUpdateToOneWithWhereWithoutIncidentsInput>;
  upsert?: InputMaybe<EthernetUpsertWithoutIncidentsInput>;
};

export type EthernetUpdateToOneWithWhereWithoutIncidentsInput = {
  data: EthernetUpdateWithoutIncidentsInput;
  where?: InputMaybe<EthernetWhereInput>;
};

export type EthernetUpdateWithWhereUniqueWithoutCarrierProductInput = {
  data: EthernetUpdateWithoutCarrierProductInput;
  where: EthernetWhereUniqueInput;
};

export type EthernetUpdateWithoutCarrierProductInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutEthernetsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutEthernetNestedInput>;
  vlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EthernetUpdateWithoutIncidentsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutEthernetsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  carrierProduct?: InputMaybe<CarrierProductUpdateOneRequiredWithoutEthernetsNestedInput>;
  vlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EthernetUpsertWithWhereUniqueWithoutCarrierProductInput = {
  create: EthernetCreateWithoutCarrierProductInput;
  update: EthernetUpdateWithoutCarrierProductInput;
  where: EthernetWhereUniqueInput;
};

export type EthernetUpsertWithoutIncidentsInput = {
  create: EthernetCreateWithoutIncidentsInput;
  update: EthernetUpdateWithoutIncidentsInput;
  where?: InputMaybe<EthernetWhereInput>;
};

export type EthernetWhereInput = {
  AND?: InputMaybe<Array<EthernetWhereInput>>;
  NOT?: InputMaybe<Array<EthernetWhereInput>>;
  OR?: InputMaybe<Array<EthernetWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  vlanId?: InputMaybe<IntFilter>;
};

export type EthernetWhereUniqueInput = {
  AND?: InputMaybe<Array<EthernetWhereInput>>;
  NOT?: InputMaybe<Array<EthernetWhereInput>>;
  OR?: InputMaybe<Array<EthernetWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  carrierProduct?: InputMaybe<CarrierProductRelationFilter>;
  carrierProductId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  vlanId?: InputMaybe<IntFilter>;
};

export type File = {
  __typename?: 'File';
  _count?: Maybe<FileCount>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FileCount = {
  __typename?: 'FileCount';
  portings: Scalars['Int']['output'];
};


export type FileCountPortingsArgs = {
  where?: InputMaybe<PortingWhereInput>;
};

export type FileInput = {
  files: Array<Scalars['Upload']['input']>;
  orderId: Scalars['Int']['input'];
};

export type FileNullableRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export type FileOrderByWithRelationInput = {
  name?: InputMaybe<SortOrder>;
};

export enum FileScalarFieldEnum {
  Id = 'id',
  Mimetype = 'mimetype',
  Name = 'name',
  OrderId = 'orderId',
  Size = 'size',
  UploadAt = 'uploadAt'
}

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  name?: InputMaybe<StringFilter>;
};

export type FileWhereUniqueInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  name?: InputMaybe<StringFilter>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Image */
export type Image = {
  __typename?: 'Image';
  base64EncodedImage: Scalars['String']['output'];
};

export type Incident = {
  __typename?: 'Incident';
  _count?: Maybe<IncidentCount>;
  access?: Maybe<Access>;
  accessId?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['DateTimeISO']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  ethernet?: Maybe<Ethernet>;
  ethernetId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lineDiagnosis?: Maybe<LineDiagnosis>;
  lineReset?: Maybe<LineReset>;
  technicianDate?: Maybe<Scalars['DateTimeISO']['output']>;
  trunk?: Maybe<Trunk>;
  trunkId?: Maybe<Scalars['Int']['output']>;
  updates: Array<IncidentUpdate>;
};


export type IncidentAccessArgs = {
  where?: InputMaybe<AccessWhereInput>;
};


export type IncidentEthernetArgs = {
  where?: InputMaybe<EthernetWhereInput>;
};


export type IncidentLineDiagnosisArgs = {
  where?: InputMaybe<LineDiagnosisWhereInput>;
};


export type IncidentLineResetArgs = {
  where?: InputMaybe<LineResetWhereInput>;
};


export type IncidentTrunkArgs = {
  where?: InputMaybe<TrunkWhereInput>;
};


export type IncidentUpdatesArgs = {
  cursor?: InputMaybe<IncidentUpdateWhereUniqueInput>;
  distinct?: InputMaybe<Array<IncidentUpdateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IncidentUpdateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IncidentUpdateWhereInput>;
};

export type IncidentCount = {
  __typename?: 'IncidentCount';
  updates: Scalars['Int']['output'];
};


export type IncidentCountUpdatesArgs = {
  where?: InputMaybe<IncidentUpdateWhereInput>;
};

export type IncidentCreateInput = {
  access?: InputMaybe<AccessCreateNestedOneWithoutIncidentsInput>;
  comment: Scalars['String']['input'];
  ethernet?: InputMaybe<EthernetCreateNestedOneWithoutIncidentsInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisCreateNestedOneWithoutIncidentInput>;
  lineReset?: InputMaybe<LineResetCreateNestedOneWithoutIncidentInput>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutIncidentsInput>;
};

export type IncidentCreateManyAccessInput = {
  comment: Scalars['String']['input'];
  ethernetId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type IncidentCreateManyAccessInputEnvelope = {
  data: Array<IncidentCreateManyAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentCreateManyEthernetInput = {
  accessId?: InputMaybe<Scalars['Int']['input']>;
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type IncidentCreateManyEthernetInputEnvelope = {
  data: Array<IncidentCreateManyEthernetInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentCreateManyTrunkInput = {
  accessId?: InputMaybe<Scalars['Int']['input']>;
  comment: Scalars['String']['input'];
  ethernetId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type IncidentCreateManyTrunkInputEnvelope = {
  data: Array<IncidentCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentCreateNestedManyWithoutAccessInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutAccessInput>>;
  createMany?: InputMaybe<IncidentCreateManyAccessInputEnvelope>;
};

export type IncidentCreateNestedManyWithoutEthernetInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutEthernetInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutEthernetInput>>;
  createMany?: InputMaybe<IncidentCreateManyEthernetInputEnvelope>;
};

export type IncidentCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<IncidentCreateManyTrunkInputEnvelope>;
};

export type IncidentCreateNestedOneWithoutLineDiagnosisInput = {
  connect?: InputMaybe<IncidentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IncidentCreateOrConnectWithoutLineDiagnosisInput>;
  create?: InputMaybe<IncidentCreateWithoutLineDiagnosisInput>;
};

export type IncidentCreateNestedOneWithoutLineResetInput = {
  connect?: InputMaybe<IncidentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IncidentCreateOrConnectWithoutLineResetInput>;
  create?: InputMaybe<IncidentCreateWithoutLineResetInput>;
};

export type IncidentCreateOrConnectWithoutAccessInput = {
  create: IncidentCreateWithoutAccessInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentCreateOrConnectWithoutEthernetInput = {
  create: IncidentCreateWithoutEthernetInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentCreateOrConnectWithoutLineDiagnosisInput = {
  create: IncidentCreateWithoutLineDiagnosisInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentCreateOrConnectWithoutLineResetInput = {
  create: IncidentCreateWithoutLineResetInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentCreateOrConnectWithoutTrunkInput = {
  create: IncidentCreateWithoutTrunkInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentCreateWithoutAccessInput = {
  comment: Scalars['String']['input'];
  ethernet?: InputMaybe<EthernetCreateNestedOneWithoutIncidentsInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisCreateNestedOneWithoutIncidentInput>;
  lineReset?: InputMaybe<LineResetCreateNestedOneWithoutIncidentInput>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutIncidentsInput>;
};

export type IncidentCreateWithoutEthernetInput = {
  access?: InputMaybe<AccessCreateNestedOneWithoutIncidentsInput>;
  comment: Scalars['String']['input'];
  lineDiagnosis?: InputMaybe<LineDiagnosisCreateNestedOneWithoutIncidentInput>;
  lineReset?: InputMaybe<LineResetCreateNestedOneWithoutIncidentInput>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutIncidentsInput>;
};

export type IncidentCreateWithoutLineDiagnosisInput = {
  access?: InputMaybe<AccessCreateNestedOneWithoutIncidentsInput>;
  comment: Scalars['String']['input'];
  ethernet?: InputMaybe<EthernetCreateNestedOneWithoutIncidentsInput>;
  lineReset?: InputMaybe<LineResetCreateNestedOneWithoutIncidentInput>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutIncidentsInput>;
};

export type IncidentCreateWithoutLineResetInput = {
  access?: InputMaybe<AccessCreateNestedOneWithoutIncidentsInput>;
  comment: Scalars['String']['input'];
  ethernet?: InputMaybe<EthernetCreateNestedOneWithoutIncidentsInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisCreateNestedOneWithoutIncidentInput>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutIncidentsInput>;
};

export type IncidentCreateWithoutTrunkInput = {
  access?: InputMaybe<AccessCreateNestedOneWithoutIncidentsInput>;
  comment: Scalars['String']['input'];
  ethernet?: InputMaybe<EthernetCreateNestedOneWithoutIncidentsInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisCreateNestedOneWithoutIncidentInput>;
  lineReset?: InputMaybe<LineResetCreateNestedOneWithoutIncidentInput>;
};

export type IncidentListRelationFilter = {
  every?: InputMaybe<IncidentWhereInput>;
  none?: InputMaybe<IncidentWhereInput>;
  some?: InputMaybe<IncidentWhereInput>;
};

export type IncidentNullableRelationFilter = {
  is?: InputMaybe<IncidentWhereInput>;
  isNot?: InputMaybe<IncidentWhereInput>;
};

export type IncidentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IncidentOrderByWithRelationInput = {
  access?: InputMaybe<AccessOrderByWithRelationInput>;
  accessId?: InputMaybe<SortOrderInput>;
  closed?: InputMaybe<SortOrderInput>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ethernet?: InputMaybe<EthernetOrderByWithRelationInput>;
  ethernetId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lineDiagnosis?: InputMaybe<LineDiagnosisOrderByWithRelationInput>;
  lineReset?: InputMaybe<LineResetOrderByWithRelationInput>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrderInput>;
};

export type IncidentRelationFilter = {
  is?: InputMaybe<IncidentWhereInput>;
  isNot?: InputMaybe<IncidentWhereInput>;
};

export enum IncidentScalarFieldEnum {
  AccessId = 'accessId',
  Closed = 'closed',
  Comment = 'comment',
  CreatedAt = 'createdAt',
  EthernetId = 'ethernetId',
  Id = 'id',
  TechnicianDate = 'technicianDate',
  TrunkId = 'trunkId'
}

export type IncidentScalarWhereInput = {
  AND?: InputMaybe<Array<IncidentScalarWhereInput>>;
  NOT?: InputMaybe<Array<IncidentScalarWhereInput>>;
  OR?: InputMaybe<Array<IncidentScalarWhereInput>>;
  accessId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ethernetId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type IncidentUpdate = {
  __typename?: 'IncidentUpdate';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  incidentId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type IncidentUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IncidentUpdateManyWithWhereWithoutAccessInput = {
  data: IncidentUpdateManyMutationInput;
  where: IncidentScalarWhereInput;
};

export type IncidentUpdateManyWithWhereWithoutEthernetInput = {
  data: IncidentUpdateManyMutationInput;
  where: IncidentScalarWhereInput;
};

export type IncidentUpdateManyWithWhereWithoutTrunkInput = {
  data: IncidentUpdateManyMutationInput;
  where: IncidentScalarWhereInput;
};

export type IncidentUpdateManyWithoutAccessNestedInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutAccessInput>>;
  createMany?: InputMaybe<IncidentCreateManyAccessInputEnvelope>;
  delete?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IncidentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  set?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  update?: InputMaybe<Array<IncidentUpdateWithWhereUniqueWithoutAccessInput>>;
  updateMany?: InputMaybe<Array<IncidentUpdateManyWithWhereWithoutAccessInput>>;
  upsert?: InputMaybe<Array<IncidentUpsertWithWhereUniqueWithoutAccessInput>>;
};

export type IncidentUpdateManyWithoutEthernetNestedInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutEthernetInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutEthernetInput>>;
  createMany?: InputMaybe<IncidentCreateManyEthernetInputEnvelope>;
  delete?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IncidentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  set?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  update?: InputMaybe<Array<IncidentUpdateWithWhereUniqueWithoutEthernetInput>>;
  updateMany?: InputMaybe<Array<IncidentUpdateManyWithWhereWithoutEthernetInput>>;
  upsert?: InputMaybe<Array<IncidentUpsertWithWhereUniqueWithoutEthernetInput>>;
};

export type IncidentUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IncidentCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<IncidentCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<IncidentCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IncidentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  set?: InputMaybe<Array<IncidentWhereUniqueInput>>;
  update?: InputMaybe<Array<IncidentUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<IncidentUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<IncidentUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type IncidentUpdateOneWithoutLineDiagnosisNestedInput = {
  connect?: InputMaybe<IncidentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IncidentCreateOrConnectWithoutLineDiagnosisInput>;
  create?: InputMaybe<IncidentCreateWithoutLineDiagnosisInput>;
  delete?: InputMaybe<IncidentWhereInput>;
  disconnect?: InputMaybe<IncidentWhereInput>;
  update?: InputMaybe<IncidentUpdateToOneWithWhereWithoutLineDiagnosisInput>;
  upsert?: InputMaybe<IncidentUpsertWithoutLineDiagnosisInput>;
};

export type IncidentUpdateOneWithoutLineResetNestedInput = {
  connect?: InputMaybe<IncidentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IncidentCreateOrConnectWithoutLineResetInput>;
  create?: InputMaybe<IncidentCreateWithoutLineResetInput>;
  delete?: InputMaybe<IncidentWhereInput>;
  disconnect?: InputMaybe<IncidentWhereInput>;
  update?: InputMaybe<IncidentUpdateToOneWithWhereWithoutLineResetInput>;
  upsert?: InputMaybe<IncidentUpsertWithoutLineResetInput>;
};

export type IncidentUpdateOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  incident?: InputMaybe<IncidentOrderByWithRelationInput>;
  incidentId?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
};

export enum IncidentUpdateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IncidentId = 'incidentId',
  Message = 'message'
}

export type IncidentUpdateToOneWithWhereWithoutLineDiagnosisInput = {
  data: IncidentUpdateWithoutLineDiagnosisInput;
  where?: InputMaybe<IncidentWhereInput>;
};

export type IncidentUpdateToOneWithWhereWithoutLineResetInput = {
  data: IncidentUpdateWithoutLineResetInput;
  where?: InputMaybe<IncidentWhereInput>;
};

export type IncidentUpdateWhereInput = {
  AND?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  NOT?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  OR?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  id?: InputMaybe<IntFilter>;
  incident?: InputMaybe<IncidentRelationFilter>;
  incidentId?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
};

export type IncidentUpdateWhereUniqueInput = {
  AND?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  NOT?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  OR?: InputMaybe<Array<IncidentUpdateWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<IncidentRelationFilter>;
  incidentId?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
};

export type IncidentUpdateWithWhereUniqueWithoutAccessInput = {
  data: IncidentUpdateWithoutAccessInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpdateWithWhereUniqueWithoutEthernetInput = {
  data: IncidentUpdateWithoutEthernetInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpdateWithWhereUniqueWithoutTrunkInput = {
  data: IncidentUpdateWithoutTrunkInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpdateWithoutAccessInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethernet?: InputMaybe<EthernetUpdateOneWithoutIncidentsNestedInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisUpdateOneWithoutIncidentNestedInput>;
  lineReset?: InputMaybe<LineResetUpdateOneWithoutIncidentNestedInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutIncidentsNestedInput>;
};

export type IncidentUpdateWithoutEthernetInput = {
  access?: InputMaybe<AccessUpdateOneWithoutIncidentsNestedInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisUpdateOneWithoutIncidentNestedInput>;
  lineReset?: InputMaybe<LineResetUpdateOneWithoutIncidentNestedInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutIncidentsNestedInput>;
};

export type IncidentUpdateWithoutLineDiagnosisInput = {
  access?: InputMaybe<AccessUpdateOneWithoutIncidentsNestedInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethernet?: InputMaybe<EthernetUpdateOneWithoutIncidentsNestedInput>;
  lineReset?: InputMaybe<LineResetUpdateOneWithoutIncidentNestedInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutIncidentsNestedInput>;
};

export type IncidentUpdateWithoutLineResetInput = {
  access?: InputMaybe<AccessUpdateOneWithoutIncidentsNestedInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethernet?: InputMaybe<EthernetUpdateOneWithoutIncidentsNestedInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisUpdateOneWithoutIncidentNestedInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutIncidentsNestedInput>;
};

export type IncidentUpdateWithoutTrunkInput = {
  access?: InputMaybe<AccessUpdateOneWithoutIncidentsNestedInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethernet?: InputMaybe<EthernetUpdateOneWithoutIncidentsNestedInput>;
  lineDiagnosis?: InputMaybe<LineDiagnosisUpdateOneWithoutIncidentNestedInput>;
  lineReset?: InputMaybe<LineResetUpdateOneWithoutIncidentNestedInput>;
};

export type IncidentUpsertWithWhereUniqueWithoutAccessInput = {
  create: IncidentCreateWithoutAccessInput;
  update: IncidentUpdateWithoutAccessInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpsertWithWhereUniqueWithoutEthernetInput = {
  create: IncidentCreateWithoutEthernetInput;
  update: IncidentUpdateWithoutEthernetInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpsertWithWhereUniqueWithoutTrunkInput = {
  create: IncidentCreateWithoutTrunkInput;
  update: IncidentUpdateWithoutTrunkInput;
  where: IncidentWhereUniqueInput;
};

export type IncidentUpsertWithoutLineDiagnosisInput = {
  create: IncidentCreateWithoutLineDiagnosisInput;
  update: IncidentUpdateWithoutLineDiagnosisInput;
  where?: InputMaybe<IncidentWhereInput>;
};

export type IncidentUpsertWithoutLineResetInput = {
  create: IncidentCreateWithoutLineResetInput;
  update: IncidentUpdateWithoutLineResetInput;
  where?: InputMaybe<IncidentWhereInput>;
};

export type IncidentWhereInput = {
  AND?: InputMaybe<Array<IncidentWhereInput>>;
  NOT?: InputMaybe<Array<IncidentWhereInput>>;
  OR?: InputMaybe<Array<IncidentWhereInput>>;
  access?: InputMaybe<AccessNullableRelationFilter>;
  accessId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ethernet?: InputMaybe<EthernetNullableRelationFilter>;
  ethernetId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lineDiagnosis?: InputMaybe<LineDiagnosisNullableRelationFilter>;
  lineReset?: InputMaybe<LineResetNullableRelationFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type IncidentWhereUniqueInput = {
  AND?: InputMaybe<Array<IncidentWhereInput>>;
  NOT?: InputMaybe<Array<IncidentWhereInput>>;
  OR?: InputMaybe<Array<IncidentWhereInput>>;
  access?: InputMaybe<AccessNullableRelationFilter>;
  accessId?: InputMaybe<IntNullableFilter>;
  closed?: InputMaybe<DateTimeNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ethernet?: InputMaybe<EthernetNullableRelationFilter>;
  ethernetId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lineDiagnosis?: InputMaybe<LineDiagnosisNullableRelationFilter>;
  lineReset?: InputMaybe<LineResetNullableRelationFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum LandlordApproval {
  Granted = 'GRANTED',
  Rejected = 'REJECTED'
}

export type LineDiagnosis = {
  __typename?: 'LineDiagnosis';
  access: Access;
  accessId: Scalars['Int']['output'];
  attenuationDown?: Maybe<Scalars['Float']['output']>;
  attenuationUp?: Maybe<Scalars['Float']['output']>;
  bitRateDown?: Maybe<Scalars['Float']['output']>;
  bitrateUp?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deviceIdentification?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incident?: Maybe<Incident>;
  incidentId?: Maybe<Scalars['Int']['output']>;
  lineTermination?: Maybe<Scalars['String']['output']>;
  resistAB?: Maybe<Scalars['Float']['output']>;
  resistAE?: Maybe<Scalars['Float']['output']>;
  resistBA?: Maybe<Scalars['Float']['output']>;
  resistBE?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  snrDown?: Maybe<Scalars['Float']['output']>;
  snrUp?: Maybe<Scalars['Float']['output']>;
  status: LineDiagnosisStatus;
  synced?: Maybe<Scalars['Boolean']['output']>;
  wireLength?: Maybe<Scalars['Float']['output']>;
};


export type LineDiagnosisIncidentArgs = {
  where?: InputMaybe<IncidentWhereInput>;
};

export type LineDiagnosisCreateInput = {
  access: AccessCreateNestedOneWithoutLineDiagnosesInput;
  attenuationDown?: InputMaybe<Scalars['Float']['input']>;
  incident?: InputMaybe<IncidentCreateNestedOneWithoutLineDiagnosisInput>;
  status?: InputMaybe<LineDiagnosisStatus>;
};

export type LineDiagnosisCreateManyAccessInput = {
  attenuationDown?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidentId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LineDiagnosisStatus>;
};

export type LineDiagnosisCreateManyAccessInputEnvelope = {
  data: Array<LineDiagnosisCreateManyAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineDiagnosisCreateNestedManyWithoutAccessInput = {
  connect?: InputMaybe<Array<LineDiagnosisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LineDiagnosisCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<LineDiagnosisCreateWithoutAccessInput>>;
  createMany?: InputMaybe<LineDiagnosisCreateManyAccessInputEnvelope>;
};

export type LineDiagnosisCreateNestedOneWithoutIncidentInput = {
  connect?: InputMaybe<LineDiagnosisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LineDiagnosisCreateOrConnectWithoutIncidentInput>;
  create?: InputMaybe<LineDiagnosisCreateWithoutIncidentInput>;
};

export type LineDiagnosisCreateOrConnectWithoutAccessInput = {
  create: LineDiagnosisCreateWithoutAccessInput;
  where: LineDiagnosisWhereUniqueInput;
};

export type LineDiagnosisCreateOrConnectWithoutIncidentInput = {
  create: LineDiagnosisCreateWithoutIncidentInput;
  where: LineDiagnosisWhereUniqueInput;
};

export type LineDiagnosisCreateWithoutAccessInput = {
  attenuationDown?: InputMaybe<Scalars['Float']['input']>;
  incident?: InputMaybe<IncidentCreateNestedOneWithoutLineDiagnosisInput>;
  status?: InputMaybe<LineDiagnosisStatus>;
};

export type LineDiagnosisCreateWithoutIncidentInput = {
  access: AccessCreateNestedOneWithoutLineDiagnosesInput;
  attenuationDown?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<LineDiagnosisStatus>;
};

export type LineDiagnosisListRelationFilter = {
  every?: InputMaybe<LineDiagnosisWhereInput>;
  none?: InputMaybe<LineDiagnosisWhereInput>;
  some?: InputMaybe<LineDiagnosisWhereInput>;
};

export type LineDiagnosisNullableRelationFilter = {
  is?: InputMaybe<LineDiagnosisWhereInput>;
  isNot?: InputMaybe<LineDiagnosisWhereInput>;
};

export type LineDiagnosisOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LineDiagnosisOrderByWithRelationInput = {
  access?: InputMaybe<AccessOrderByWithRelationInput>;
  accessId?: InputMaybe<SortOrder>;
  attenuationDown?: InputMaybe<SortOrderInput>;
  attenuationUp?: InputMaybe<SortOrderInput>;
  bitRateDown?: InputMaybe<SortOrderInput>;
  bitrateUp?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deviceIdentification?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  incident?: InputMaybe<IncidentOrderByWithRelationInput>;
  incidentId?: InputMaybe<SortOrderInput>;
  lineTermination?: InputMaybe<SortOrderInput>;
  resistAB?: InputMaybe<SortOrderInput>;
  resistAE?: InputMaybe<SortOrderInput>;
  resistBA?: InputMaybe<SortOrderInput>;
  resistBE?: InputMaybe<SortOrderInput>;
  result?: InputMaybe<SortOrderInput>;
  snrDown?: InputMaybe<SortOrderInput>;
  snrUp?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  synced?: InputMaybe<SortOrderInput>;
  wireLength?: InputMaybe<SortOrderInput>;
};

export enum LineDiagnosisScalarFieldEnum {
  AccessId = 'accessId',
  AttenuationDown = 'attenuationDown',
  AttenuationUp = 'attenuationUp',
  BitRateDown = 'bitRateDown',
  BitrateUp = 'bitrateUp',
  CreatedAt = 'createdAt',
  DeviceIdentification = 'deviceIdentification',
  Id = 'id',
  IncidentId = 'incidentId',
  LineTermination = 'lineTermination',
  ResistAb = 'resistAB',
  ResistAe = 'resistAE',
  ResistBa = 'resistBA',
  ResistBe = 'resistBE',
  Result = 'result',
  SnrDown = 'snrDown',
  SnrUp = 'snrUp',
  Status = 'status',
  Synced = 'synced',
  WireLength = 'wireLength'
}

export type LineDiagnosisScalarWhereInput = {
  AND?: InputMaybe<Array<LineDiagnosisScalarWhereInput>>;
  NOT?: InputMaybe<Array<LineDiagnosisScalarWhereInput>>;
  OR?: InputMaybe<Array<LineDiagnosisScalarWhereInput>>;
  accessId?: InputMaybe<IntFilter>;
  attenuationDown?: InputMaybe<FloatNullableFilter>;
  attenuationUp?: InputMaybe<FloatNullableFilter>;
  bitRateDown?: InputMaybe<FloatNullableFilter>;
  bitrateUp?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceIdentification?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  incidentId?: InputMaybe<IntNullableFilter>;
  lineTermination?: InputMaybe<StringNullableFilter>;
  resistAB?: InputMaybe<FloatNullableFilter>;
  resistAE?: InputMaybe<FloatNullableFilter>;
  resistBA?: InputMaybe<FloatNullableFilter>;
  resistBE?: InputMaybe<FloatNullableFilter>;
  result?: InputMaybe<StringNullableFilter>;
  snrDown?: InputMaybe<FloatNullableFilter>;
  snrUp?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumLineDiagnosisStatusFilter>;
  synced?: InputMaybe<BoolNullableFilter>;
  wireLength?: InputMaybe<FloatNullableFilter>;
};

export enum LineDiagnosisStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Processed = 'PROCESSED'
}

export type LineDiagnosisUpdateManyMutationInput = {
  attenuationDown?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumLineDiagnosisStatusFieldUpdateOperationsInput>;
};

export type LineDiagnosisUpdateManyWithWhereWithoutAccessInput = {
  data: LineDiagnosisUpdateManyMutationInput;
  where: LineDiagnosisScalarWhereInput;
};

export type LineDiagnosisUpdateManyWithoutAccessNestedInput = {
  connect?: InputMaybe<Array<LineDiagnosisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LineDiagnosisCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<LineDiagnosisCreateWithoutAccessInput>>;
  createMany?: InputMaybe<LineDiagnosisCreateManyAccessInputEnvelope>;
  delete?: InputMaybe<Array<LineDiagnosisWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LineDiagnosisScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LineDiagnosisWhereUniqueInput>>;
  set?: InputMaybe<Array<LineDiagnosisWhereUniqueInput>>;
  update?: InputMaybe<Array<LineDiagnosisUpdateWithWhereUniqueWithoutAccessInput>>;
  updateMany?: InputMaybe<Array<LineDiagnosisUpdateManyWithWhereWithoutAccessInput>>;
  upsert?: InputMaybe<Array<LineDiagnosisUpsertWithWhereUniqueWithoutAccessInput>>;
};

export type LineDiagnosisUpdateOneWithoutIncidentNestedInput = {
  connect?: InputMaybe<LineDiagnosisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LineDiagnosisCreateOrConnectWithoutIncidentInput>;
  create?: InputMaybe<LineDiagnosisCreateWithoutIncidentInput>;
  delete?: InputMaybe<LineDiagnosisWhereInput>;
  disconnect?: InputMaybe<LineDiagnosisWhereInput>;
  update?: InputMaybe<LineDiagnosisUpdateToOneWithWhereWithoutIncidentInput>;
  upsert?: InputMaybe<LineDiagnosisUpsertWithoutIncidentInput>;
};

export type LineDiagnosisUpdateToOneWithWhereWithoutIncidentInput = {
  data: LineDiagnosisUpdateWithoutIncidentInput;
  where?: InputMaybe<LineDiagnosisWhereInput>;
};

export type LineDiagnosisUpdateWithWhereUniqueWithoutAccessInput = {
  data: LineDiagnosisUpdateWithoutAccessInput;
  where: LineDiagnosisWhereUniqueInput;
};

export type LineDiagnosisUpdateWithoutAccessInput = {
  attenuationDown?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  incident?: InputMaybe<IncidentUpdateOneWithoutLineDiagnosisNestedInput>;
  status?: InputMaybe<EnumLineDiagnosisStatusFieldUpdateOperationsInput>;
};

export type LineDiagnosisUpdateWithoutIncidentInput = {
  access?: InputMaybe<AccessUpdateOneRequiredWithoutLineDiagnosesNestedInput>;
  attenuationDown?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumLineDiagnosisStatusFieldUpdateOperationsInput>;
};

export type LineDiagnosisUpsertWithWhereUniqueWithoutAccessInput = {
  create: LineDiagnosisCreateWithoutAccessInput;
  update: LineDiagnosisUpdateWithoutAccessInput;
  where: LineDiagnosisWhereUniqueInput;
};

export type LineDiagnosisUpsertWithoutIncidentInput = {
  create: LineDiagnosisCreateWithoutIncidentInput;
  update: LineDiagnosisUpdateWithoutIncidentInput;
  where?: InputMaybe<LineDiagnosisWhereInput>;
};

export type LineDiagnosisWhereInput = {
  AND?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  NOT?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  OR?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  attenuationDown?: InputMaybe<FloatNullableFilter>;
  attenuationUp?: InputMaybe<FloatNullableFilter>;
  bitRateDown?: InputMaybe<FloatNullableFilter>;
  bitrateUp?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceIdentification?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  incident?: InputMaybe<IncidentNullableRelationFilter>;
  incidentId?: InputMaybe<IntNullableFilter>;
  lineTermination?: InputMaybe<StringNullableFilter>;
  resistAB?: InputMaybe<FloatNullableFilter>;
  resistAE?: InputMaybe<FloatNullableFilter>;
  resistBA?: InputMaybe<FloatNullableFilter>;
  resistBE?: InputMaybe<FloatNullableFilter>;
  result?: InputMaybe<StringNullableFilter>;
  snrDown?: InputMaybe<FloatNullableFilter>;
  snrUp?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumLineDiagnosisStatusFilter>;
  synced?: InputMaybe<BoolNullableFilter>;
  wireLength?: InputMaybe<FloatNullableFilter>;
};

export type LineDiagnosisWhereUniqueInput = {
  AND?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  NOT?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  OR?: InputMaybe<Array<LineDiagnosisWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  attenuationDown?: InputMaybe<FloatNullableFilter>;
  attenuationUp?: InputMaybe<FloatNullableFilter>;
  bitRateDown?: InputMaybe<FloatNullableFilter>;
  bitrateUp?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceIdentification?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<IncidentNullableRelationFilter>;
  incidentId?: InputMaybe<Scalars['Int']['input']>;
  lineTermination?: InputMaybe<StringNullableFilter>;
  resistAB?: InputMaybe<FloatNullableFilter>;
  resistAE?: InputMaybe<FloatNullableFilter>;
  resistBA?: InputMaybe<FloatNullableFilter>;
  resistBE?: InputMaybe<FloatNullableFilter>;
  result?: InputMaybe<StringNullableFilter>;
  snrDown?: InputMaybe<FloatNullableFilter>;
  snrUp?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumLineDiagnosisStatusFilter>;
  synced?: InputMaybe<BoolNullableFilter>;
  wireLength?: InputMaybe<FloatNullableFilter>;
};

export type LineReset = {
  __typename?: 'LineReset';
  access: Access;
  accessId: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  incident?: Maybe<Incident>;
  incidentId?: Maybe<Scalars['Int']['output']>;
};


export type LineResetIncidentArgs = {
  where?: InputMaybe<IncidentWhereInput>;
};

export type LineResetCreateInput = {
  access: AccessCreateNestedOneWithoutLineResetsInput;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  incident?: InputMaybe<IncidentCreateNestedOneWithoutLineResetInput>;
};

export type LineResetCreateManyAccessInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidentId?: InputMaybe<Scalars['Int']['input']>;
};

export type LineResetCreateManyAccessInputEnvelope = {
  data: Array<LineResetCreateManyAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineResetCreateNestedManyWithoutAccessInput = {
  connect?: InputMaybe<Array<LineResetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LineResetCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<LineResetCreateWithoutAccessInput>>;
  createMany?: InputMaybe<LineResetCreateManyAccessInputEnvelope>;
};

export type LineResetCreateNestedOneWithoutIncidentInput = {
  connect?: InputMaybe<LineResetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LineResetCreateOrConnectWithoutIncidentInput>;
  create?: InputMaybe<LineResetCreateWithoutIncidentInput>;
};

export type LineResetCreateOrConnectWithoutAccessInput = {
  create: LineResetCreateWithoutAccessInput;
  where: LineResetWhereUniqueInput;
};

export type LineResetCreateOrConnectWithoutIncidentInput = {
  create: LineResetCreateWithoutIncidentInput;
  where: LineResetWhereUniqueInput;
};

export type LineResetCreateWithoutAccessInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  incident?: InputMaybe<IncidentCreateNestedOneWithoutLineResetInput>;
};

export type LineResetCreateWithoutIncidentInput = {
  access: AccessCreateNestedOneWithoutLineResetsInput;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineResetListRelationFilter = {
  every?: InputMaybe<LineResetWhereInput>;
  none?: InputMaybe<LineResetWhereInput>;
  some?: InputMaybe<LineResetWhereInput>;
};

export type LineResetNullableRelationFilter = {
  is?: InputMaybe<LineResetWhereInput>;
  isNot?: InputMaybe<LineResetWhereInput>;
};

export type LineResetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LineResetOrderByWithRelationInput = {
  access?: InputMaybe<AccessOrderByWithRelationInput>;
  accessId?: InputMaybe<SortOrder>;
  completed?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incident?: InputMaybe<IncidentOrderByWithRelationInput>;
  incidentId?: InputMaybe<SortOrderInput>;
};

export enum LineResetScalarFieldEnum {
  AccessId = 'accessId',
  Completed = 'completed',
  CreatedAt = 'createdAt',
  Id = 'id',
  IncidentId = 'incidentId'
}

export type LineResetScalarWhereInput = {
  AND?: InputMaybe<Array<LineResetScalarWhereInput>>;
  NOT?: InputMaybe<Array<LineResetScalarWhereInput>>;
  OR?: InputMaybe<Array<LineResetScalarWhereInput>>;
  accessId?: InputMaybe<IntFilter>;
  completed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  incidentId?: InputMaybe<IntNullableFilter>;
};

export type LineResetUpdateManyMutationInput = {
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type LineResetUpdateManyWithWhereWithoutAccessInput = {
  data: LineResetUpdateManyMutationInput;
  where: LineResetScalarWhereInput;
};

export type LineResetUpdateManyWithoutAccessNestedInput = {
  connect?: InputMaybe<Array<LineResetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LineResetCreateOrConnectWithoutAccessInput>>;
  create?: InputMaybe<Array<LineResetCreateWithoutAccessInput>>;
  createMany?: InputMaybe<LineResetCreateManyAccessInputEnvelope>;
  delete?: InputMaybe<Array<LineResetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LineResetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LineResetWhereUniqueInput>>;
  set?: InputMaybe<Array<LineResetWhereUniqueInput>>;
  update?: InputMaybe<Array<LineResetUpdateWithWhereUniqueWithoutAccessInput>>;
  updateMany?: InputMaybe<Array<LineResetUpdateManyWithWhereWithoutAccessInput>>;
  upsert?: InputMaybe<Array<LineResetUpsertWithWhereUniqueWithoutAccessInput>>;
};

export type LineResetUpdateOneWithoutIncidentNestedInput = {
  connect?: InputMaybe<LineResetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LineResetCreateOrConnectWithoutIncidentInput>;
  create?: InputMaybe<LineResetCreateWithoutIncidentInput>;
  delete?: InputMaybe<LineResetWhereInput>;
  disconnect?: InputMaybe<LineResetWhereInput>;
  update?: InputMaybe<LineResetUpdateToOneWithWhereWithoutIncidentInput>;
  upsert?: InputMaybe<LineResetUpsertWithoutIncidentInput>;
};

export type LineResetUpdateToOneWithWhereWithoutIncidentInput = {
  data: LineResetUpdateWithoutIncidentInput;
  where?: InputMaybe<LineResetWhereInput>;
};

export type LineResetUpdateWithWhereUniqueWithoutAccessInput = {
  data: LineResetUpdateWithoutAccessInput;
  where: LineResetWhereUniqueInput;
};

export type LineResetUpdateWithoutAccessInput = {
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incident?: InputMaybe<IncidentUpdateOneWithoutLineResetNestedInput>;
};

export type LineResetUpdateWithoutIncidentInput = {
  access?: InputMaybe<AccessUpdateOneRequiredWithoutLineResetsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type LineResetUpsertWithWhereUniqueWithoutAccessInput = {
  create: LineResetCreateWithoutAccessInput;
  update: LineResetUpdateWithoutAccessInput;
  where: LineResetWhereUniqueInput;
};

export type LineResetUpsertWithoutIncidentInput = {
  create: LineResetCreateWithoutIncidentInput;
  update: LineResetUpdateWithoutIncidentInput;
  where?: InputMaybe<LineResetWhereInput>;
};

export type LineResetWhereInput = {
  AND?: InputMaybe<Array<LineResetWhereInput>>;
  NOT?: InputMaybe<Array<LineResetWhereInput>>;
  OR?: InputMaybe<Array<LineResetWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  completed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  incident?: InputMaybe<IncidentNullableRelationFilter>;
  incidentId?: InputMaybe<IntNullableFilter>;
};

export type LineResetWhereUniqueInput = {
  AND?: InputMaybe<Array<LineResetWhereInput>>;
  NOT?: InputMaybe<Array<LineResetWhereInput>>;
  OR?: InputMaybe<Array<LineResetWhereInput>>;
  access?: InputMaybe<AccessRelationFilter>;
  accessId?: InputMaybe<IntFilter>;
  completed?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<IncidentNullableRelationFilter>;
  incidentId?: InputMaybe<Scalars['Int']['input']>;
};

export enum LocalExchangeSize {
  Big = 'BIG',
  Small = 'SMALL'
}

export type LocationInput = {
  city: Scalars['String']['input'];
  hno: Scalars['Float']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export enum MediaEncryption {
  Disabled = 'DISABLED',
  Dtls = 'DTLS',
  Sdes = 'SDES'
}

export type Mutation = {
  __typename?: 'Mutation';
  PdfToImage: Image;
  authenticate: AuthenticationResponse;
  authenticateAsPartner: AuthenticationResponse;
  changePW: ChangePwResponse;
  completeOrder: ResultOrderComplete;
  createOneAddress: Address;
  createOneAvailability: Availability;
  createOneCustomer: Customer;
  createOneIncident: Incident;
  createOneLineDiagnosis: LineDiagnosis;
  createOneLineReset: LineReset;
  createOneOrder: Order;
  deleteOneCustomer?: Maybe<Customer>;
  newsShown: Partner;
  researchAvailability: Availability;
  updateOneCustomer?: Maybe<Customer>;
  updateOneOrder: Order;
  updateOneTrunk?: Maybe<Trunk>;
  uploadFiles: Array<File>;
};


export type MutationPdfToImageArgs = {
  pdfToImageInput: PdfToImageInput;
};


export type MutationAuthenticateArgs = {
  data: AuthenticationInput;
};


export type MutationAuthenticateAsPartnerArgs = {
  partnerId: Scalars['Int']['input'];
};


export type MutationChangePwArgs = {
  data: ChangePwInput;
};


export type MutationCompleteOrderArgs = {
  accesses: Array<AccessOrderCompleteType>;
  orderId: Scalars['Float']['input'];
  portings: Array<PortingOrderCompleteType>;
};


export type MutationCreateOneAddressArgs = {
  data: AddressCreateInput;
};


export type MutationCreateOneAvailabilityArgs = {
  data: AvailabilityCreateInput;
};


export type MutationCreateOneCustomerArgs = {
  data: CustomerCreateInput;
};


export type MutationCreateOneIncidentArgs = {
  data: IncidentCreateInput;
};


export type MutationCreateOneLineDiagnosisArgs = {
  data: LineDiagnosisCreateInput;
};


export type MutationCreateOneLineResetArgs = {
  data: LineResetCreateInput;
};


export type MutationCreateOneOrderArgs = {
  data: OrderCreateInput;
};


export type MutationDeleteOneCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type MutationResearchAvailabilityArgs = {
  location: LocationInput;
};


export type MutationUpdateOneCustomerArgs = {
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOneTrunkArgs = {
  data: TrunkUpdateInput;
  where: TrunkWhereUniqueInput;
};


export type MutationUploadFilesArgs = {
  fileInput: FileInput;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedEnumAwsModeFilter = {
  equals?: InputMaybe<AwsMode>;
  in?: InputMaybe<Array<AwsMode>>;
  not?: InputMaybe<NestedEnumAwsModeFilter>;
  notIn?: InputMaybe<Array<AwsMode>>;
};

export type NestedEnumCdrDirectionFilter = {
  equals?: InputMaybe<CdrDirection>;
  in?: InputMaybe<Array<CdrDirection>>;
  not?: InputMaybe<NestedEnumCdrDirectionFilter>;
  notIn?: InputMaybe<Array<CdrDirection>>;
};

export type NestedEnumCdrDispositionFilter = {
  equals?: InputMaybe<CdrDisposition>;
  in?: InputMaybe<Array<CdrDisposition>>;
  not?: InputMaybe<NestedEnumCdrDispositionFilter>;
  notIn?: InputMaybe<Array<CdrDisposition>>;
};

export type NestedEnumConnectionTypeFilter = {
  equals?: InputMaybe<ConnectionType>;
  in?: InputMaybe<Array<ConnectionType>>;
  not?: InputMaybe<NestedEnumConnectionTypeFilter>;
  notIn?: InputMaybe<Array<ConnectionType>>;
};

export type NestedEnumConnectionTypeNullableFilter = {
  equals?: InputMaybe<ConnectionType>;
  in?: InputMaybe<Array<ConnectionType>>;
  not?: InputMaybe<NestedEnumConnectionTypeNullableFilter>;
  notIn?: InputMaybe<Array<ConnectionType>>;
};

export type NestedEnumConstructionStatusFilter = {
  equals?: InputMaybe<ConstructionStatus>;
  in?: InputMaybe<Array<ConstructionStatus>>;
  not?: InputMaybe<NestedEnumConstructionStatusFilter>;
  notIn?: InputMaybe<Array<ConstructionStatus>>;
};

export type NestedEnumConstructionTechnologyNullableFilter = {
  equals?: InputMaybe<ConstructionTechnology>;
  in?: InputMaybe<Array<ConstructionTechnology>>;
  not?: InputMaybe<NestedEnumConstructionTechnologyNullableFilter>;
  notIn?: InputMaybe<Array<ConstructionTechnology>>;
};

export type NestedEnumCustomerStatusFilter = {
  equals?: InputMaybe<CustomerStatus>;
  in?: InputMaybe<Array<CustomerStatus>>;
  not?: InputMaybe<NestedEnumCustomerStatusFilter>;
  notIn?: InputMaybe<Array<CustomerStatus>>;
};

export type NestedEnumDeliveryFilter = {
  equals?: InputMaybe<Delivery>;
  in?: InputMaybe<Array<Delivery>>;
  not?: InputMaybe<NestedEnumDeliveryFilter>;
  notIn?: InputMaybe<Array<Delivery>>;
};

export type NestedEnumLandlordApprovalNullableFilter = {
  equals?: InputMaybe<LandlordApproval>;
  in?: InputMaybe<Array<LandlordApproval>>;
  not?: InputMaybe<NestedEnumLandlordApprovalNullableFilter>;
  notIn?: InputMaybe<Array<LandlordApproval>>;
};

export type NestedEnumLineDiagnosisStatusFilter = {
  equals?: InputMaybe<LineDiagnosisStatus>;
  in?: InputMaybe<Array<LineDiagnosisStatus>>;
  not?: InputMaybe<NestedEnumLineDiagnosisStatusFilter>;
  notIn?: InputMaybe<Array<LineDiagnosisStatus>>;
};

export type NestedEnumLocalExchangeSizeNullableFilter = {
  equals?: InputMaybe<LocalExchangeSize>;
  in?: InputMaybe<Array<LocalExchangeSize>>;
  not?: InputMaybe<NestedEnumLocalExchangeSizeNullableFilter>;
  notIn?: InputMaybe<Array<LocalExchangeSize>>;
};

export type NestedEnumMediaEncryptionFilter = {
  equals?: InputMaybe<MediaEncryption>;
  in?: InputMaybe<Array<MediaEncryption>>;
  not?: InputMaybe<NestedEnumMediaEncryptionFilter>;
  notIn?: InputMaybe<Array<MediaEncryption>>;
};

export type NestedEnumNumberTypeFilter = {
  equals?: InputMaybe<NumberType>;
  in?: InputMaybe<Array<NumberType>>;
  not?: InputMaybe<NestedEnumNumberTypeFilter>;
  notIn?: InputMaybe<Array<NumberType>>;
};

export type NestedEnumOrderAccessStatusFilter = {
  equals?: InputMaybe<OrderAccessStatus>;
  in?: InputMaybe<Array<OrderAccessStatus>>;
  not?: InputMaybe<NestedEnumOrderAccessStatusFilter>;
  notIn?: InputMaybe<Array<OrderAccessStatus>>;
};

export type NestedEnumOrderAccessTypeNullableFilter = {
  equals?: InputMaybe<OrderAccessType>;
  in?: InputMaybe<Array<OrderAccessType>>;
  not?: InputMaybe<NestedEnumOrderAccessTypeNullableFilter>;
  notIn?: InputMaybe<Array<OrderAccessType>>;
};

export type NestedEnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumPortingStatusFilter = {
  equals?: InputMaybe<PortingStatus>;
  in?: InputMaybe<Array<PortingStatus>>;
  not?: InputMaybe<NestedEnumPortingStatusFilter>;
  notIn?: InputMaybe<Array<PortingStatus>>;
};

export type NestedEnumWbciResultNullableFilter = {
  equals?: InputMaybe<WbciResult>;
  in?: InputMaybe<Array<WbciResult>>;
  not?: InputMaybe<NestedEnumWbciResultNullableFilter>;
  notIn?: InputMaybe<Array<WbciResult>>;
};

export type NestedEnumWbciStatusFilter = {
  equals?: InputMaybe<WbciStatus>;
  in?: InputMaybe<Array<WbciStatus>>;
  not?: InputMaybe<NestedEnumWbciStatusFilter>;
  notIn?: InputMaybe<Array<WbciStatus>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NullableEnumConnectionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ConnectionType>;
};

export type NullableEnumConstructionTechnologyFieldUpdateOperationsInput = {
  set?: InputMaybe<ConstructionTechnology>;
};

export type NullableEnumLandlordApprovalFieldUpdateOperationsInput = {
  set?: InputMaybe<LandlordApproval>;
};

export type NullableEnumLocalExchangeSizeFieldUpdateOperationsInput = {
  set?: InputMaybe<LocalExchangeSize>;
};

export type NullableEnumOrderAccessTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderAccessType>;
};

export type NullableEnumWbciResultFieldUpdateOperationsInput = {
  set?: InputMaybe<WbciResult>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Number = {
  __typename?: 'Number';
  _count?: Maybe<NumberCount>;
  aws: Array<Aws>;
  cdrs: Array<Cdr>;
  ddiFrom?: Maybe<Scalars['String']['output']>;
  ddiTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  trunk: Trunk;
  trunkId: Scalars['Int']['output'];
};


export type NumberAwsArgs = {
  cursor?: InputMaybe<AwsWhereUniqueInput>;
  distinct?: InputMaybe<Array<AwsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AwsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AwsWhereInput>;
};


export type NumberCdrsArgs = {
  cursor?: InputMaybe<CdrWhereUniqueInput>;
  distinct?: InputMaybe<Array<CdrScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CdrOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CdrWhereInput>;
};

export type NumberCount = {
  __typename?: 'NumberCount';
  aws: Scalars['Int']['output'];
  cdrs: Scalars['Int']['output'];
};


export type NumberCountAwsArgs = {
  where?: InputMaybe<AwsWhereInput>;
};


export type NumberCountCdrsArgs = {
  where?: InputMaybe<CdrWhereInput>;
};

export type NumberCreateManyTrunkInput = {
  ddiFrom?: InputMaybe<Scalars['String']['input']>;
  ddiTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
};

export type NumberCreateManyTrunkInputEnvelope = {
  data: Array<NumberCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<NumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NumberCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<NumberCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<NumberCreateManyTrunkInputEnvelope>;
};

export type NumberCreateNestedOneWithoutCdrsInput = {
  connect?: InputMaybe<NumberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NumberCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<NumberCreateWithoutCdrsInput>;
};

export type NumberCreateOrConnectWithoutCdrsInput = {
  create: NumberCreateWithoutCdrsInput;
  where: NumberWhereUniqueInput;
};

export type NumberCreateOrConnectWithoutTrunkInput = {
  create: NumberCreateWithoutTrunkInput;
  where: NumberWhereUniqueInput;
};

export type NumberCreateWithoutCdrsInput = {
  aws?: InputMaybe<AwsCreateNestedManyWithoutNumberInput>;
  ddiFrom?: InputMaybe<Scalars['String']['input']>;
  ddiTo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  trunk: TrunkCreateNestedOneWithoutNumbersInput;
};

export type NumberCreateWithoutTrunkInput = {
  aws?: InputMaybe<AwsCreateNestedManyWithoutNumberInput>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutNumberInput>;
  ddiFrom?: InputMaybe<Scalars['String']['input']>;
  ddiTo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type NumberListRelationFilter = {
  every?: InputMaybe<NumberWhereInput>;
  none?: InputMaybe<NumberWhereInput>;
  some?: InputMaybe<NumberWhereInput>;
};

export type NumberNullableRelationFilter = {
  is?: InputMaybe<NumberWhereInput>;
  isNot?: InputMaybe<NumberWhereInput>;
};

export type NumberOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NumberOrderByWithRelationInput = {
  aws?: InputMaybe<AwsOrderByRelationAggregateInput>;
  cdrs?: InputMaybe<CdrOrderByRelationAggregateInput>;
  ddiFrom?: InputMaybe<SortOrderInput>;
  ddiTo?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrder>;
};

export type NumberRelationFilter = {
  is?: InputMaybe<NumberWhereInput>;
  isNot?: InputMaybe<NumberWhereInput>;
};

export enum NumberScalarFieldEnum {
  DdiFrom = 'ddiFrom',
  DdiTo = 'ddiTo',
  Id = 'id',
  Number = 'number',
  TrunkId = 'trunkId'
}

export type NumberScalarWhereInput = {
  AND?: InputMaybe<Array<NumberScalarWhereInput>>;
  NOT?: InputMaybe<Array<NumberScalarWhereInput>>;
  OR?: InputMaybe<Array<NumberScalarWhereInput>>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export enum NumberType {
  Aa = 'AA',
  Mga = 'MGA'
}

export type NumberUpdateManyMutationInput = {
  ddiFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NumberUpdateManyWithWhereWithoutTrunkInput = {
  data: NumberUpdateManyMutationInput;
  where: NumberScalarWhereInput;
};

export type NumberUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<NumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NumberCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<NumberCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<NumberCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<NumberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NumberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NumberWhereUniqueInput>>;
  set?: InputMaybe<Array<NumberWhereUniqueInput>>;
  update?: InputMaybe<Array<NumberUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<NumberUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<NumberUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type NumberUpdateOneWithoutCdrsNestedInput = {
  connect?: InputMaybe<NumberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NumberCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<NumberCreateWithoutCdrsInput>;
  delete?: InputMaybe<NumberWhereInput>;
  disconnect?: InputMaybe<NumberWhereInput>;
  update?: InputMaybe<NumberUpdateToOneWithWhereWithoutCdrsInput>;
  upsert?: InputMaybe<NumberUpsertWithoutCdrsInput>;
};

export type NumberUpdateToOneWithWhereWithoutCdrsInput = {
  data: NumberUpdateWithoutCdrsInput;
  where?: InputMaybe<NumberWhereInput>;
};

export type NumberUpdateWithWhereUniqueWithoutTrunkInput = {
  data: NumberUpdateWithoutTrunkInput;
  where: NumberWhereUniqueInput;
};

export type NumberUpdateWithoutCdrsInput = {
  aws?: InputMaybe<AwsUpdateManyWithoutNumberNestedInput>;
  ddiFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneRequiredWithoutNumbersNestedInput>;
};

export type NumberUpdateWithoutTrunkInput = {
  aws?: InputMaybe<AwsUpdateManyWithoutNumberNestedInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutNumberNestedInput>;
  ddiFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NumberUpsertWithWhereUniqueWithoutTrunkInput = {
  create: NumberCreateWithoutTrunkInput;
  update: NumberUpdateWithoutTrunkInput;
  where: NumberWhereUniqueInput;
};

export type NumberUpsertWithoutCdrsInput = {
  create: NumberCreateWithoutCdrsInput;
  update: NumberUpdateWithoutCdrsInput;
  where?: InputMaybe<NumberWhereInput>;
};

export type NumberWhereInput = {
  AND?: InputMaybe<Array<NumberWhereInput>>;
  NOT?: InputMaybe<Array<NumberWhereInput>>;
  OR?: InputMaybe<Array<NumberWhereInput>>;
  aws?: InputMaybe<AwsListRelationFilter>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type NumberWhereUniqueInput = {
  AND?: InputMaybe<Array<NumberWhereInput>>;
  NOT?: InputMaybe<Array<NumberWhereInput>>;
  OR?: InputMaybe<Array<NumberWhereInput>>;
  aws?: InputMaybe<AwsListRelationFilter>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<StringFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type Order = {
  __typename?: 'Order';
  _count?: Maybe<OrderCount>;
  accesses: Array<OrderAccess>;
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  ethernets: Array<OrderEthernet>;
  files: Array<File>;
  id: Scalars['Int']['output'];
  misc?: Maybe<Scalars['String']['output']>;
  numbers: Array<OrderNumber>;
  portings: Array<Porting>;
  signedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: OrderStatus;
  trunks: Array<OrderTrunk>;
  updates: Array<OrderUpdate>;
};


export type OrderAccessesArgs = {
  cursor?: InputMaybe<OrderAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type OrderEthernetsArgs = {
  cursor?: InputMaybe<OrderEthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderEthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderEthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type OrderFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type OrderNumbersArgs = {
  cursor?: InputMaybe<OrderNumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type OrderPortingsArgs = {
  cursor?: InputMaybe<PortingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingWhereInput>;
};


export type OrderTrunksArgs = {
  cursor?: InputMaybe<OrderTrunkWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderTrunkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderTrunkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type OrderUpdatesArgs = {
  cursor?: InputMaybe<OrderUpdateWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderUpdateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderUpdateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderUpdateWhereInput>;
};

export type OrderAccess = {
  __typename?: 'OrderAccess';
  _count?: Maybe<OrderAccessCount>;
  accesses: Array<Access>;
  address: Address;
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstname?: Maybe<Scalars['String']['output']>;
  customerLastname?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  customerSalutation?: Maybe<Scalars['String']['output']>;
  delivery: Delivery;
  desiredDate?: Maybe<Scalars['DateTimeISO']['output']>;
  homeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  landlordCity?: Maybe<Scalars['String']['output']>;
  landlordCompany?: Maybe<Scalars['String']['output']>;
  landlordEmail?: Maybe<Scalars['String']['output']>;
  landlordFirstname?: Maybe<Scalars['String']['output']>;
  landlordHno?: Maybe<Scalars['String']['output']>;
  landlordLastname?: Maybe<Scalars['String']['output']>;
  landlordPhone?: Maybe<Scalars['String']['output']>;
  landlordSalutation?: Maybe<Scalars['String']['output']>;
  landlordStreet?: Maybe<Scalars['String']['output']>;
  landlordType?: Maybe<Scalars['String']['output']>;
  landlordZip?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderAccessType?: Maybe<OrderAccessType>;
  orderAccessUpdates: Array<OrderAccessUpdate>;
  orderId: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  status: OrderAccessStatus;
};


export type OrderAccessAccessesArgs = {
  cursor?: InputMaybe<AccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessWhereInput>;
};


export type OrderAccessOrderAccessUpdatesArgs = {
  cursor?: InputMaybe<OrderAccessUpdateWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderAccessUpdateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderAccessUpdateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderAccessUpdateWhereInput>;
};

export type OrderAccessCount = {
  __typename?: 'OrderAccessCount';
  accesses: Scalars['Int']['output'];
  orderAccessUpdates: Scalars['Int']['output'];
};


export type OrderAccessCountAccessesArgs = {
  where?: InputMaybe<AccessWhereInput>;
};


export type OrderAccessCountOrderAccessUpdatesArgs = {
  where?: InputMaybe<OrderAccessUpdateWhereInput>;
};

export type OrderAccessCreateManyOrderInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstname?: InputMaybe<Scalars['String']['input']>;
  customerLastname?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerSalutation?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEmail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZip?: InputMaybe<Scalars['String']['input']>;
  orderAccessType?: InputMaybe<OrderAccessType>;
  productId: Scalars['Int']['input'];
  status?: InputMaybe<OrderAccessStatus>;
};

export type OrderAccessCreateManyOrderInputEnvelope = {
  data: Array<OrderAccessCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAccessCreateManyProductInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstname?: InputMaybe<Scalars['String']['input']>;
  customerLastname?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerSalutation?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEmail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZip?: InputMaybe<Scalars['String']['input']>;
  orderAccessType?: InputMaybe<OrderAccessType>;
  orderId: Scalars['Int']['input'];
  status?: InputMaybe<OrderAccessStatus>;
};

export type OrderAccessCreateManyProductInputEnvelope = {
  data: Array<OrderAccessCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAccessCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderAccessCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderAccessCreateManyOrderInputEnvelope>;
};

export type OrderAccessCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<OrderAccessCreateWithoutProductInput>>;
  createMany?: InputMaybe<OrderAccessCreateManyProductInputEnvelope>;
};

export type OrderAccessCreateNestedOneWithoutAccessesInput = {
  connect?: InputMaybe<OrderAccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAccessCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<OrderAccessCreateWithoutAccessesInput>;
};

export type OrderAccessCreateOrConnectWithoutAccessesInput = {
  create: OrderAccessCreateWithoutAccessesInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessCreateOrConnectWithoutOrderInput = {
  create: OrderAccessCreateWithoutOrderInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessCreateOrConnectWithoutProductInput = {
  create: OrderAccessCreateWithoutProductInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessCreateWithoutAccessesInput = {
  address: AddressCreateNestedOneWithoutOrderAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstname?: InputMaybe<Scalars['String']['input']>;
  customerLastname?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerSalutation?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEmail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZip?: InputMaybe<Scalars['String']['input']>;
  orderAccessType?: InputMaybe<OrderAccessType>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateCreateNestedManyWithoutOrderAccessInput>;
  product: ProductCreateNestedOneWithoutOrderAccessesInput;
  status?: InputMaybe<OrderAccessStatus>;
};

export type OrderAccessCreateWithoutOrderInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutOrderAccessInput>;
  address: AddressCreateNestedOneWithoutOrderAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstname?: InputMaybe<Scalars['String']['input']>;
  customerLastname?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerSalutation?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEmail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZip?: InputMaybe<Scalars['String']['input']>;
  orderAccessType?: InputMaybe<OrderAccessType>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateCreateNestedManyWithoutOrderAccessInput>;
  product: ProductCreateNestedOneWithoutOrderAccessesInput;
  status?: InputMaybe<OrderAccessStatus>;
};

export type OrderAccessCreateWithoutProductInput = {
  accesses?: InputMaybe<AccessCreateNestedManyWithoutOrderAccessInput>;
  address: AddressCreateNestedOneWithoutOrderAccessesInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFirstname?: InputMaybe<Scalars['String']['input']>;
  customerLastname?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerSalutation?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  homeId?: InputMaybe<Scalars['String']['input']>;
  landlordCity?: InputMaybe<Scalars['String']['input']>;
  landlordCompany?: InputMaybe<Scalars['String']['input']>;
  landlordEmail?: InputMaybe<Scalars['String']['input']>;
  landlordFirstname?: InputMaybe<Scalars['String']['input']>;
  landlordHno?: InputMaybe<Scalars['String']['input']>;
  landlordLastname?: InputMaybe<Scalars['String']['input']>;
  landlordPhone?: InputMaybe<Scalars['String']['input']>;
  landlordSalutation?: InputMaybe<Scalars['String']['input']>;
  landlordStreet?: InputMaybe<Scalars['String']['input']>;
  landlordType?: InputMaybe<Scalars['String']['input']>;
  landlordZip?: InputMaybe<Scalars['String']['input']>;
  orderAccessType?: InputMaybe<OrderAccessType>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateCreateNestedManyWithoutOrderAccessInput>;
  status?: InputMaybe<OrderAccessStatus>;
};

export type OrderAccessListRelationFilter = {
  every?: InputMaybe<OrderAccessWhereInput>;
  none?: InputMaybe<OrderAccessWhereInput>;
  some?: InputMaybe<OrderAccessWhereInput>;
};

export type OrderAccessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderAccessOrderByWithRelationInput = {
  accesses?: InputMaybe<AccessOrderByRelationAggregateInput>;
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  customerEmail?: InputMaybe<SortOrderInput>;
  customerFirstname?: InputMaybe<SortOrderInput>;
  customerLastname?: InputMaybe<SortOrderInput>;
  customerPhone?: InputMaybe<SortOrderInput>;
  customerSalutation?: InputMaybe<SortOrderInput>;
  delivery?: InputMaybe<SortOrder>;
  desiredDate?: InputMaybe<SortOrderInput>;
  homeId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  landlordCity?: InputMaybe<SortOrderInput>;
  landlordCompany?: InputMaybe<SortOrderInput>;
  landlordEmail?: InputMaybe<SortOrderInput>;
  landlordFirstname?: InputMaybe<SortOrderInput>;
  landlordHno?: InputMaybe<SortOrderInput>;
  landlordLastname?: InputMaybe<SortOrderInput>;
  landlordPhone?: InputMaybe<SortOrderInput>;
  landlordSalutation?: InputMaybe<SortOrderInput>;
  landlordStreet?: InputMaybe<SortOrderInput>;
  landlordType?: InputMaybe<SortOrderInput>;
  landlordZip?: InputMaybe<SortOrderInput>;
  orderAccessType?: InputMaybe<SortOrderInput>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateOrderByRelationAggregateInput>;
  orderId?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type OrderAccessRelationFilter = {
  is?: InputMaybe<OrderAccessWhereInput>;
  isNot?: InputMaybe<OrderAccessWhereInput>;
};

export enum OrderAccessScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  CustomerEmail = 'customerEmail',
  CustomerFirstname = 'customerFirstname',
  CustomerLastname = 'customerLastname',
  CustomerPhone = 'customerPhone',
  CustomerSalutation = 'customerSalutation',
  Delivery = 'delivery',
  DesiredDate = 'desiredDate',
  HomeId = 'homeId',
  Id = 'id',
  LandlordCity = 'landlordCity',
  LandlordCompany = 'landlordCompany',
  LandlordEmail = 'landlordEmail',
  LandlordFirstname = 'landlordFirstname',
  LandlordHno = 'landlordHno',
  LandlordLastname = 'landlordLastname',
  LandlordPhone = 'landlordPhone',
  LandlordSalutation = 'landlordSalutation',
  LandlordStreet = 'landlordStreet',
  LandlordType = 'landlordType',
  LandlordZip = 'landlordZip',
  OrderAccessType = 'orderAccessType',
  OrderId = 'orderId',
  ProductId = 'productId',
  Status = 'status'
}

export type OrderAccessScalarWhereInput = {
  AND?: InputMaybe<Array<OrderAccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessScalarWhereInput>>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  customerEmail?: InputMaybe<StringNullableFilter>;
  customerFirstname?: InputMaybe<StringNullableFilter>;
  customerLastname?: InputMaybe<StringNullableFilter>;
  customerPhone?: InputMaybe<StringNullableFilter>;
  customerSalutation?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  homeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  landlordCity?: InputMaybe<StringNullableFilter>;
  landlordCompany?: InputMaybe<StringNullableFilter>;
  landlordEmail?: InputMaybe<StringNullableFilter>;
  landlordFirstname?: InputMaybe<StringNullableFilter>;
  landlordHno?: InputMaybe<StringNullableFilter>;
  landlordLastname?: InputMaybe<StringNullableFilter>;
  landlordPhone?: InputMaybe<StringNullableFilter>;
  landlordSalutation?: InputMaybe<StringNullableFilter>;
  landlordStreet?: InputMaybe<StringNullableFilter>;
  landlordType?: InputMaybe<StringNullableFilter>;
  landlordZip?: InputMaybe<StringNullableFilter>;
  orderAccessType?: InputMaybe<EnumOrderAccessTypeNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumOrderAccessStatusFilter>;
};

export enum OrderAccessStatus {
  Canceled = 'CANCELED',
  CarrierDispatched = 'CARRIER_DISPATCHED',
  CarrierFailed = 'CARRIER_FAILED',
  CarrierOrdered = 'CARRIER_ORDERED',
  CarrierRejected = 'CARRIER_REJECTED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Placed = 'PLACED'
}

export enum OrderAccessType {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED'
}

export type OrderAccessUpdate = {
  __typename?: 'OrderAccessUpdate';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  orderAccessId: Scalars['Int']['output'];
};

export type OrderAccessUpdateCreateManyOrderAccessInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
};

export type OrderAccessUpdateCreateManyOrderAccessInputEnvelope = {
  data: Array<OrderAccessUpdateCreateManyOrderAccessInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAccessUpdateCreateNestedManyWithoutOrderAccessInput = {
  connect?: InputMaybe<Array<OrderAccessUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessUpdateCreateOrConnectWithoutOrderAccessInput>>;
  create?: InputMaybe<Array<OrderAccessUpdateCreateWithoutOrderAccessInput>>;
  createMany?: InputMaybe<OrderAccessUpdateCreateManyOrderAccessInputEnvelope>;
};

export type OrderAccessUpdateCreateOrConnectWithoutOrderAccessInput = {
  create: OrderAccessUpdateCreateWithoutOrderAccessInput;
  where: OrderAccessUpdateWhereUniqueInput;
};

export type OrderAccessUpdateCreateWithoutOrderAccessInput = {
  message: Scalars['String']['input'];
};

export type OrderAccessUpdateListRelationFilter = {
  every?: InputMaybe<OrderAccessUpdateWhereInput>;
  none?: InputMaybe<OrderAccessUpdateWhereInput>;
  some?: InputMaybe<OrderAccessUpdateWhereInput>;
};

export type OrderAccessUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  homeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordHno?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordStreet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderAccessType?: InputMaybe<NullableEnumOrderAccessTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderAccessStatusFieldUpdateOperationsInput>;
};

export type OrderAccessUpdateManyWithWhereWithoutOrderInput = {
  data: OrderAccessUpdateManyMutationInput;
  where: OrderAccessScalarWhereInput;
};

export type OrderAccessUpdateManyWithWhereWithoutProductInput = {
  data: OrderAccessUpdateManyMutationInput;
  where: OrderAccessScalarWhereInput;
};

export type OrderAccessUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderAccessCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderAccessCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderAccessUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderAccessUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderAccessUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderAccessUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<OrderAccessCreateWithoutProductInput>>;
  createMany?: InputMaybe<OrderAccessCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderAccessUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<OrderAccessUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<OrderAccessUpsertWithWhereUniqueWithoutProductInput>>;
};

export type OrderAccessUpdateOneRequiredWithoutAccessesNestedInput = {
  connect?: InputMaybe<OrderAccessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAccessCreateOrConnectWithoutAccessesInput>;
  create?: InputMaybe<OrderAccessCreateWithoutAccessesInput>;
  update?: InputMaybe<OrderAccessUpdateToOneWithWhereWithoutAccessesInput>;
  upsert?: InputMaybe<OrderAccessUpsertWithoutAccessesInput>;
};

export type OrderAccessUpdateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderAccessUpdateOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  orderAccess?: InputMaybe<OrderAccessOrderByWithRelationInput>;
  orderAccessId?: InputMaybe<SortOrder>;
};

export enum OrderAccessUpdateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  OrderAccessId = 'orderAccessId'
}

export type OrderAccessUpdateScalarWhereInput = {
  AND?: InputMaybe<Array<OrderAccessUpdateScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessUpdateScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessUpdateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
};

export type OrderAccessUpdateToOneWithWhereWithoutAccessesInput = {
  data: OrderAccessUpdateWithoutAccessesInput;
  where?: InputMaybe<OrderAccessWhereInput>;
};

export type OrderAccessUpdateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderAccessUpdateUpdateManyWithWhereWithoutOrderAccessInput = {
  data: OrderAccessUpdateUpdateManyMutationInput;
  where: OrderAccessUpdateScalarWhereInput;
};

export type OrderAccessUpdateUpdateManyWithoutOrderAccessNestedInput = {
  connect?: InputMaybe<Array<OrderAccessUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderAccessUpdateCreateOrConnectWithoutOrderAccessInput>>;
  create?: InputMaybe<Array<OrderAccessUpdateCreateWithoutOrderAccessInput>>;
  createMany?: InputMaybe<OrderAccessUpdateCreateManyOrderAccessInputEnvelope>;
  delete?: InputMaybe<Array<OrderAccessUpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderAccessUpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderAccessUpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderAccessUpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderAccessUpdateUpdateWithWhereUniqueWithoutOrderAccessInput>>;
  updateMany?: InputMaybe<Array<OrderAccessUpdateUpdateManyWithWhereWithoutOrderAccessInput>>;
  upsert?: InputMaybe<Array<OrderAccessUpdateUpsertWithWhereUniqueWithoutOrderAccessInput>>;
};

export type OrderAccessUpdateUpdateWithWhereUniqueWithoutOrderAccessInput = {
  data: OrderAccessUpdateUpdateWithoutOrderAccessInput;
  where: OrderAccessUpdateWhereUniqueInput;
};

export type OrderAccessUpdateUpdateWithoutOrderAccessInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderAccessUpdateUpsertWithWhereUniqueWithoutOrderAccessInput = {
  create: OrderAccessUpdateCreateWithoutOrderAccessInput;
  update: OrderAccessUpdateUpdateWithoutOrderAccessInput;
  where: OrderAccessUpdateWhereUniqueInput;
};

export type OrderAccessUpdateWhereInput = {
  AND?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  orderAccess?: InputMaybe<OrderAccessRelationFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
};

export type OrderAccessUpdateWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessUpdateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringFilter>;
  orderAccess?: InputMaybe<OrderAccessRelationFilter>;
  orderAccessId?: InputMaybe<IntFilter>;
};

export type OrderAccessUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderAccessUpdateWithoutOrderInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessUpdateWithWhereUniqueWithoutProductInput = {
  data: OrderAccessUpdateWithoutProductInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessUpdateWithoutAccessesInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  homeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordHno?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordStreet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderAccessType?: InputMaybe<NullableEnumOrderAccessTypeFieldUpdateOperationsInput>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateUpdateManyWithoutOrderAccessNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutOrderAccessesNestedInput>;
  status?: InputMaybe<EnumOrderAccessStatusFieldUpdateOperationsInput>;
};

export type OrderAccessUpdateWithoutOrderInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutOrderAccessNestedInput>;
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  homeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordHno?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordStreet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderAccessType?: InputMaybe<NullableEnumOrderAccessTypeFieldUpdateOperationsInput>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateUpdateManyWithoutOrderAccessNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutOrderAccessesNestedInput>;
  status?: InputMaybe<EnumOrderAccessStatusFieldUpdateOperationsInput>;
};

export type OrderAccessUpdateWithoutProductInput = {
  accesses?: InputMaybe<AccessUpdateManyWithoutOrderAccessNestedInput>;
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderAccessesNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  homeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordFirstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordHno?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordLastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordSalutation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordStreet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landlordZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderAccessType?: InputMaybe<NullableEnumOrderAccessTypeFieldUpdateOperationsInput>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateUpdateManyWithoutOrderAccessNestedInput>;
  status?: InputMaybe<EnumOrderAccessStatusFieldUpdateOperationsInput>;
};

export type OrderAccessUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderAccessCreateWithoutOrderInput;
  update: OrderAccessUpdateWithoutOrderInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessUpsertWithWhereUniqueWithoutProductInput = {
  create: OrderAccessCreateWithoutProductInput;
  update: OrderAccessUpdateWithoutProductInput;
  where: OrderAccessWhereUniqueInput;
};

export type OrderAccessUpsertWithoutAccessesInput = {
  create: OrderAccessCreateWithoutAccessesInput;
  update: OrderAccessUpdateWithoutAccessesInput;
  where?: InputMaybe<OrderAccessWhereInput>;
};

export type OrderAccessWhereInput = {
  AND?: InputMaybe<Array<OrderAccessWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessWhereInput>>;
  accesses?: InputMaybe<AccessListRelationFilter>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  customerEmail?: InputMaybe<StringNullableFilter>;
  customerFirstname?: InputMaybe<StringNullableFilter>;
  customerLastname?: InputMaybe<StringNullableFilter>;
  customerPhone?: InputMaybe<StringNullableFilter>;
  customerSalutation?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  homeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  landlordCity?: InputMaybe<StringNullableFilter>;
  landlordCompany?: InputMaybe<StringNullableFilter>;
  landlordEmail?: InputMaybe<StringNullableFilter>;
  landlordFirstname?: InputMaybe<StringNullableFilter>;
  landlordHno?: InputMaybe<StringNullableFilter>;
  landlordLastname?: InputMaybe<StringNullableFilter>;
  landlordPhone?: InputMaybe<StringNullableFilter>;
  landlordSalutation?: InputMaybe<StringNullableFilter>;
  landlordStreet?: InputMaybe<StringNullableFilter>;
  landlordType?: InputMaybe<StringNullableFilter>;
  landlordZip?: InputMaybe<StringNullableFilter>;
  orderAccessType?: InputMaybe<EnumOrderAccessTypeNullableFilter>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateListRelationFilter>;
  orderId?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumOrderAccessStatusFilter>;
};

export type OrderAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderAccessWhereInput>>;
  NOT?: InputMaybe<Array<OrderAccessWhereInput>>;
  OR?: InputMaybe<Array<OrderAccessWhereInput>>;
  accesses?: InputMaybe<AccessListRelationFilter>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  customerEmail?: InputMaybe<StringNullableFilter>;
  customerFirstname?: InputMaybe<StringNullableFilter>;
  customerLastname?: InputMaybe<StringNullableFilter>;
  customerPhone?: InputMaybe<StringNullableFilter>;
  customerSalutation?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  homeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  landlordCity?: InputMaybe<StringNullableFilter>;
  landlordCompany?: InputMaybe<StringNullableFilter>;
  landlordEmail?: InputMaybe<StringNullableFilter>;
  landlordFirstname?: InputMaybe<StringNullableFilter>;
  landlordHno?: InputMaybe<StringNullableFilter>;
  landlordLastname?: InputMaybe<StringNullableFilter>;
  landlordPhone?: InputMaybe<StringNullableFilter>;
  landlordSalutation?: InputMaybe<StringNullableFilter>;
  landlordStreet?: InputMaybe<StringNullableFilter>;
  landlordType?: InputMaybe<StringNullableFilter>;
  landlordZip?: InputMaybe<StringNullableFilter>;
  orderAccessType?: InputMaybe<EnumOrderAccessTypeNullableFilter>;
  orderAccessUpdates?: InputMaybe<OrderAccessUpdateListRelationFilter>;
  orderId?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumOrderAccessStatusFilter>;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  accesses: Scalars['Int']['output'];
  ethernets: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  numbers: Scalars['Int']['output'];
  portings: Scalars['Int']['output'];
  trunks: Scalars['Int']['output'];
  updates: Scalars['Int']['output'];
};


export type OrderCountAccessesArgs = {
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type OrderCountEthernetsArgs = {
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type OrderCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type OrderCountNumbersArgs = {
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type OrderCountPortingsArgs = {
  where?: InputMaybe<PortingWhereInput>;
};


export type OrderCountTrunksArgs = {
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type OrderCountUpdatesArgs = {
  where?: InputMaybe<OrderUpdateWhereInput>;
};

export type OrderCreateInput = {
  accesses?: InputMaybe<OrderAccessCreateNestedManyWithoutOrderInput>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  ethernets?: InputMaybe<OrderEthernetCreateNestedManyWithoutOrderInput>;
  misc?: InputMaybe<Scalars['String']['input']>;
  numbers?: InputMaybe<OrderNumberCreateNestedManyWithoutOrderInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutOrderInput>;
  signedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<OrderStatus>;
  trunks?: InputMaybe<OrderTrunkCreateNestedManyWithoutOrderInput>;
  updates?: InputMaybe<OrderUpdateCreateNestedManyWithoutOrderInput>;
};

export type OrderEthernet = {
  __typename?: 'OrderEthernet';
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  delivery: Delivery;
  desiredDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  locationNetworking: Scalars['Boolean']['output'];
  orderId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
};

export type OrderEthernetCreateManyOrderInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationNetworking: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};

export type OrderEthernetCreateManyOrderInputEnvelope = {
  data: Array<OrderEthernetCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderEthernetCreateManyProductInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationNetworking: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};

export type OrderEthernetCreateManyProductInputEnvelope = {
  data: Array<OrderEthernetCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderEthernetCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderEthernetCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderEthernetCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderEthernetCreateManyOrderInputEnvelope>;
};

export type OrderEthernetCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderEthernetCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<OrderEthernetCreateWithoutProductInput>>;
  createMany?: InputMaybe<OrderEthernetCreateManyProductInputEnvelope>;
};

export type OrderEthernetCreateOrConnectWithoutOrderInput = {
  create: OrderEthernetCreateWithoutOrderInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetCreateOrConnectWithoutProductInput = {
  create: OrderEthernetCreateWithoutProductInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetCreateWithoutOrderInput = {
  address: AddressCreateNestedOneWithoutOrderEthernetsInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  locationNetworking: Scalars['Boolean']['input'];
  product: ProductCreateNestedOneWithoutOrderEthernetsInput;
};

export type OrderEthernetCreateWithoutProductInput = {
  address: AddressCreateNestedOneWithoutOrderEthernetsInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  locationNetworking: Scalars['Boolean']['input'];
};

export type OrderEthernetListRelationFilter = {
  every?: InputMaybe<OrderEthernetWhereInput>;
  none?: InputMaybe<OrderEthernetWhereInput>;
  some?: InputMaybe<OrderEthernetWhereInput>;
};

export type OrderEthernetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderEthernetOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  delivery?: InputMaybe<SortOrder>;
  desiredDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locationNetworking?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
};

export enum OrderEthernetScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  Delivery = 'delivery',
  DesiredDate = 'desiredDate',
  Id = 'id',
  LocationNetworking = 'locationNetworking',
  OrderId = 'orderId',
  ProductId = 'productId'
}

export type OrderEthernetScalarWhereInput = {
  AND?: InputMaybe<Array<OrderEthernetScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderEthernetScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderEthernetScalarWhereInput>>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  locationNetworking?: InputMaybe<BoolFilter>;
  orderId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
};

export type OrderEthernetUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  locationNetworking?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type OrderEthernetUpdateManyWithWhereWithoutOrderInput = {
  data: OrderEthernetUpdateManyMutationInput;
  where: OrderEthernetScalarWhereInput;
};

export type OrderEthernetUpdateManyWithWhereWithoutProductInput = {
  data: OrderEthernetUpdateManyMutationInput;
  where: OrderEthernetScalarWhereInput;
};

export type OrderEthernetUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderEthernetCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderEthernetCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderEthernetCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderEthernetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderEthernetUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderEthernetUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderEthernetUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderEthernetUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderEthernetCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<OrderEthernetCreateWithoutProductInput>>;
  createMany?: InputMaybe<OrderEthernetCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderEthernetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderEthernetWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderEthernetUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<OrderEthernetUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<OrderEthernetUpsertWithWhereUniqueWithoutProductInput>>;
};

export type OrderEthernetUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderEthernetUpdateWithoutOrderInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetUpdateWithWhereUniqueWithoutProductInput = {
  data: OrderEthernetUpdateWithoutProductInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetUpdateWithoutOrderInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderEthernetsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  locationNetworking?: InputMaybe<BoolFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutOrderEthernetsNestedInput>;
};

export type OrderEthernetUpdateWithoutProductInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderEthernetsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  locationNetworking?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type OrderEthernetUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderEthernetCreateWithoutOrderInput;
  update: OrderEthernetUpdateWithoutOrderInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetUpsertWithWhereUniqueWithoutProductInput = {
  create: OrderEthernetCreateWithoutProductInput;
  update: OrderEthernetUpdateWithoutProductInput;
  where: OrderEthernetWhereUniqueInput;
};

export type OrderEthernetWhereInput = {
  AND?: InputMaybe<Array<OrderEthernetWhereInput>>;
  NOT?: InputMaybe<Array<OrderEthernetWhereInput>>;
  OR?: InputMaybe<Array<OrderEthernetWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  locationNetworking?: InputMaybe<BoolFilter>;
  orderId?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
};

export type OrderEthernetWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderEthernetWhereInput>>;
  NOT?: InputMaybe<Array<OrderEthernetWhereInput>>;
  OR?: InputMaybe<Array<OrderEthernetWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationNetworking?: InputMaybe<BoolFilter>;
  orderId?: InputMaybe<IntFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
};

export type OrderNumber = {
  __typename?: 'OrderNumber';
  blockSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  order: Order;
  orderId: Scalars['Int']['output'];
  orderTrunk?: Maybe<OrderTrunk>;
  orderTrunkId?: Maybe<Scalars['Int']['output']>;
  status: OrderStatus;
  trunk?: Maybe<Trunk>;
  trunkId?: Maybe<Scalars['Int']['output']>;
  type: NumberType;
};


export type OrderNumberOrderTrunkArgs = {
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type OrderNumberTrunkArgs = {
  where?: InputMaybe<TrunkWhereInput>;
};

export type OrderNumberCreateManyOrderInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
  type: NumberType;
};

export type OrderNumberCreateManyOrderInputEnvelope = {
  data: Array<OrderNumberCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNumberCreateManyOrderTrunkInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  status?: InputMaybe<OrderStatus>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
  type: NumberType;
};

export type OrderNumberCreateManyOrderTrunkInputEnvelope = {
  data: Array<OrderNumberCreateManyOrderTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNumberCreateManyTrunkInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  type: NumberType;
};

export type OrderNumberCreateManyTrunkInputEnvelope = {
  data: Array<OrderNumberCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNumberCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyOrderInputEnvelope>;
};

export type OrderNumberCreateNestedManyWithoutOrderTrunkInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutOrderTrunkInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutOrderTrunkInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyOrderTrunkInputEnvelope>;
};

export type OrderNumberCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyTrunkInputEnvelope>;
};

export type OrderNumberCreateOrConnectWithoutOrderInput = {
  create: OrderNumberCreateWithoutOrderInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberCreateOrConnectWithoutOrderTrunkInput = {
  create: OrderNumberCreateWithoutOrderTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberCreateOrConnectWithoutTrunkInput = {
  create: OrderNumberCreateWithoutTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberCreateWithoutOrderInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  orderTrunk?: InputMaybe<OrderTrunkCreateNestedOneWithoutOrderNumbersInput>;
  status?: InputMaybe<OrderStatus>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutOrderNumbersInput>;
  type: NumberType;
};

export type OrderNumberCreateWithoutOrderTrunkInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutOrderNumbersInput>;
  type: NumberType;
};

export type OrderNumberCreateWithoutTrunkInput = {
  blockSize?: InputMaybe<Scalars['Int']['input']>;
  orderTrunk?: InputMaybe<OrderTrunkCreateNestedOneWithoutOrderNumbersInput>;
  status?: InputMaybe<OrderStatus>;
  type: NumberType;
};

export type OrderNumberListRelationFilter = {
  every?: InputMaybe<OrderNumberWhereInput>;
  none?: InputMaybe<OrderNumberWhereInput>;
  some?: InputMaybe<OrderNumberWhereInput>;
};

export type OrderNumberOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderNumberOrderByWithRelationInput = {
  blockSize?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  orderTrunk?: InputMaybe<OrderTrunkOrderByWithRelationInput>;
  orderTrunkId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export enum OrderNumberScalarFieldEnum {
  BlockSize = 'blockSize',
  Id = 'id',
  OrderId = 'orderId',
  OrderTrunkId = 'orderTrunkId',
  Status = 'status',
  TrunkId = 'trunkId',
  Type = 'type'
}

export type OrderNumberScalarWhereInput = {
  AND?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  blockSize?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumNumberTypeFilter>;
};

export type OrderNumberUpdateManyMutationInput = {
  blockSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNumberTypeFieldUpdateOperationsInput>;
};

export type OrderNumberUpdateManyWithWhereWithoutOrderInput = {
  data: OrderNumberUpdateManyMutationInput;
  where: OrderNumberScalarWhereInput;
};

export type OrderNumberUpdateManyWithWhereWithoutOrderTrunkInput = {
  data: OrderNumberUpdateManyMutationInput;
  where: OrderNumberScalarWhereInput;
};

export type OrderNumberUpdateManyWithWhereWithoutTrunkInput = {
  data: OrderNumberUpdateManyMutationInput;
  where: OrderNumberScalarWhereInput;
};

export type OrderNumberUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderNumberUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderNumberUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderNumberUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderNumberUpdateManyWithoutOrderTrunkNestedInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutOrderTrunkInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutOrderTrunkInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyOrderTrunkInputEnvelope>;
  delete?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderNumberUpdateWithWhereUniqueWithoutOrderTrunkInput>>;
  updateMany?: InputMaybe<Array<OrderNumberUpdateManyWithWhereWithoutOrderTrunkInput>>;
  upsert?: InputMaybe<Array<OrderNumberUpsertWithWhereUniqueWithoutOrderTrunkInput>>;
};

export type OrderNumberUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNumberCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<OrderNumberCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<OrderNumberCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderNumberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderNumberWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderNumberUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<OrderNumberUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<OrderNumberUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type OrderNumberUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderNumberUpdateWithoutOrderInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberUpdateWithWhereUniqueWithoutOrderTrunkInput = {
  data: OrderNumberUpdateWithoutOrderTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberUpdateWithWhereUniqueWithoutTrunkInput = {
  data: OrderNumberUpdateWithoutTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberUpdateWithoutOrderInput = {
  blockSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneWithoutOrderNumbersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutOrderNumbersNestedInput>;
  type?: InputMaybe<EnumNumberTypeFieldUpdateOperationsInput>;
};

export type OrderNumberUpdateWithoutOrderTrunkInput = {
  blockSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutOrderNumbersNestedInput>;
  type?: InputMaybe<EnumNumberTypeFieldUpdateOperationsInput>;
};

export type OrderNumberUpdateWithoutTrunkInput = {
  blockSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneWithoutOrderNumbersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNumberTypeFieldUpdateOperationsInput>;
};

export type OrderNumberUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderNumberCreateWithoutOrderInput;
  update: OrderNumberUpdateWithoutOrderInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberUpsertWithWhereUniqueWithoutOrderTrunkInput = {
  create: OrderNumberCreateWithoutOrderTrunkInput;
  update: OrderNumberUpdateWithoutOrderTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberUpsertWithWhereUniqueWithoutTrunkInput = {
  create: OrderNumberCreateWithoutTrunkInput;
  update: OrderNumberUpdateWithoutTrunkInput;
  where: OrderNumberWhereUniqueInput;
};

export type OrderNumberWhereInput = {
  AND?: InputMaybe<Array<OrderNumberWhereInput>>;
  NOT?: InputMaybe<Array<OrderNumberWhereInput>>;
  OR?: InputMaybe<Array<OrderNumberWhereInput>>;
  blockSize?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunk?: InputMaybe<OrderTrunkNullableRelationFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumNumberTypeFilter>;
};

export type OrderNumberWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderNumberWhereInput>>;
  NOT?: InputMaybe<Array<OrderNumberWhereInput>>;
  OR?: InputMaybe<Array<OrderNumberWhereInput>>;
  blockSize?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunk?: InputMaybe<OrderTrunkNullableRelationFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumNumberTypeFilter>;
};

export type OrderOrderByWithRelationInput = {
  accesses?: InputMaybe<OrderAccessOrderByRelationAggregateInput>;
  completedAt?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  ethernets?: InputMaybe<OrderEthernetOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  misc?: InputMaybe<SortOrderInput>;
  numbers?: InputMaybe<OrderNumberOrderByRelationAggregateInput>;
  portings?: InputMaybe<PortingOrderByRelationAggregateInput>;
  signedAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  trunks?: InputMaybe<OrderTrunkOrderByRelationAggregateInput>;
  updates?: InputMaybe<OrderUpdateOrderByRelationAggregateInput>;
};

export type OrderRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export enum OrderScalarFieldEnum {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Misc = 'misc',
  SignedAt = 'signedAt',
  Status = 'status'
}

export enum OrderStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Placed = 'PLACED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export type OrderTrunk = {
  __typename?: 'OrderTrunk';
  _count?: Maybe<OrderTrunkCount>;
  address: Address;
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  channel: Scalars['Int']['output'];
  delivery: Delivery;
  desiredDate?: Maybe<Scalars['DateTimeISO']['output']>;
  flatrateLandline: Scalars['Boolean']['output'];
  flatrateMobil: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  order: Order;
  orderId: Scalars['Int']['output'];
  orderNumbers: Array<OrderNumber>;
  portings: Array<Porting>;
  status: OrderStatus;
  trunk?: Maybe<Trunk>;
  trunkId?: Maybe<Scalars['Int']['output']>;
};


export type OrderTrunkOrderNumbersArgs = {
  cursor?: InputMaybe<OrderNumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type OrderTrunkPortingsArgs = {
  cursor?: InputMaybe<PortingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingWhereInput>;
};


export type OrderTrunkTrunkArgs = {
  where?: InputMaybe<TrunkWhereInput>;
};

export type OrderTrunkCount = {
  __typename?: 'OrderTrunkCount';
  orderNumbers: Scalars['Int']['output'];
  portings: Scalars['Int']['output'];
};


export type OrderTrunkCountOrderNumbersArgs = {
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type OrderTrunkCountPortingsArgs = {
  where?: InputMaybe<PortingWhereInput>;
};

export type OrderTrunkCreateManyOrderInput = {
  addressId: Scalars['Int']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTrunkCreateManyOrderInputEnvelope = {
  data: Array<OrderTrunkCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderTrunkCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderTrunkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderTrunkCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderTrunkCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderTrunkCreateManyOrderInputEnvelope>;
};

export type OrderTrunkCreateNestedOneWithoutOrderNumbersInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutOrderNumbersInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutOrderNumbersInput>;
};

export type OrderTrunkCreateNestedOneWithoutPortingsInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutPortingsInput>;
};

export type OrderTrunkCreateNestedOneWithoutTrunkInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutTrunkInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutTrunkInput>;
};

export type OrderTrunkCreateOrConnectWithoutOrderInput = {
  create: OrderTrunkCreateWithoutOrderInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkCreateOrConnectWithoutOrderNumbersInput = {
  create: OrderTrunkCreateWithoutOrderNumbersInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkCreateOrConnectWithoutPortingsInput = {
  create: OrderTrunkCreateWithoutPortingsInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkCreateOrConnectWithoutTrunkInput = {
  create: OrderTrunkCreateWithoutTrunkInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkCreateWithoutOrderInput = {
  address: AddressCreateNestedOneWithoutOrderTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutOrderTrunkInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutOrderTrunkInput>;
  status?: InputMaybe<OrderStatus>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutOrderTrunkInput>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTrunkCreateWithoutOrderNumbersInput = {
  address: AddressCreateNestedOneWithoutOrderTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutOrderTrunkInput>;
  status?: InputMaybe<OrderStatus>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutOrderTrunkInput>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTrunkCreateWithoutPortingsInput = {
  address: AddressCreateNestedOneWithoutOrderTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutOrderTrunkInput>;
  status?: InputMaybe<OrderStatus>;
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutOrderTrunkInput>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTrunkCreateWithoutTrunkInput = {
  address: AddressCreateNestedOneWithoutOrderTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  delivery: Delivery;
  desiredDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutOrderTrunkInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutOrderTrunkInput>;
  status?: InputMaybe<OrderStatus>;
  trunkId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTrunkListRelationFilter = {
  every?: InputMaybe<OrderTrunkWhereInput>;
  none?: InputMaybe<OrderTrunkWhereInput>;
  some?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkNullableRelationFilter = {
  is?: InputMaybe<OrderTrunkWhereInput>;
  isNot?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderTrunkOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  channel?: InputMaybe<SortOrder>;
  delivery?: InputMaybe<SortOrder>;
  desiredDate?: InputMaybe<SortOrderInput>;
  flatrateLandline?: InputMaybe<SortOrder>;
  flatrateMobil?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  orderNumbers?: InputMaybe<OrderNumberOrderByRelationAggregateInput>;
  portings?: InputMaybe<PortingOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrderInput>;
};

export type OrderTrunkRelationFilter = {
  is?: InputMaybe<OrderTrunkWhereInput>;
  isNot?: InputMaybe<OrderTrunkWhereInput>;
};

export enum OrderTrunkScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  Channel = 'channel',
  Delivery = 'delivery',
  DesiredDate = 'desiredDate',
  FlatrateLandline = 'flatrateLandline',
  FlatrateMobil = 'flatrateMobil',
  Id = 'id',
  OrderId = 'orderId',
  Status = 'status',
  TrunkId = 'trunkId'
}

export type OrderTrunkScalarWhereInput = {
  AND?: InputMaybe<Array<OrderTrunkScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderTrunkScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderTrunkScalarWhereInput>>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  channel?: InputMaybe<IntFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type OrderTrunkUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderTrunkUpdateManyWithWhereWithoutOrderInput = {
  data: OrderTrunkUpdateManyMutationInput;
  where: OrderTrunkScalarWhereInput;
};

export type OrderTrunkUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderTrunkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderTrunkCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderTrunkCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderTrunkCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderTrunkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderTrunkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderTrunkWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderTrunkWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderTrunkUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderTrunkUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderTrunkUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutTrunkInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutTrunkInput>;
  update?: InputMaybe<OrderTrunkUpdateToOneWithWhereWithoutTrunkInput>;
  upsert?: InputMaybe<OrderTrunkUpsertWithoutTrunkInput>;
};

export type OrderTrunkUpdateOneWithoutOrderNumbersNestedInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutOrderNumbersInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutOrderNumbersInput>;
  delete?: InputMaybe<OrderTrunkWhereInput>;
  disconnect?: InputMaybe<OrderTrunkWhereInput>;
  update?: InputMaybe<OrderTrunkUpdateToOneWithWhereWithoutOrderNumbersInput>;
  upsert?: InputMaybe<OrderTrunkUpsertWithoutOrderNumbersInput>;
};

export type OrderTrunkUpdateOneWithoutPortingsNestedInput = {
  connect?: InputMaybe<OrderTrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderTrunkCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<OrderTrunkCreateWithoutPortingsInput>;
  delete?: InputMaybe<OrderTrunkWhereInput>;
  disconnect?: InputMaybe<OrderTrunkWhereInput>;
  update?: InputMaybe<OrderTrunkUpdateToOneWithWhereWithoutPortingsInput>;
  upsert?: InputMaybe<OrderTrunkUpsertWithoutPortingsInput>;
};

export type OrderTrunkUpdateToOneWithWhereWithoutOrderNumbersInput = {
  data: OrderTrunkUpdateWithoutOrderNumbersInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkUpdateToOneWithWhereWithoutPortingsInput = {
  data: OrderTrunkUpdateWithoutPortingsInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkUpdateToOneWithWhereWithoutTrunkInput = {
  data: OrderTrunkUpdateWithoutTrunkInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderTrunkUpdateWithoutOrderInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkUpdateWithoutOrderInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutOrderTrunkNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutOrderTrunkNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutOrderTrunkNestedInput>;
  trunkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderTrunkUpdateWithoutOrderNumbersInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutOrderTrunkNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutOrderTrunkNestedInput>;
  trunkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderTrunkUpdateWithoutPortingsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutOrderTrunkNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutOrderTrunkNestedInput>;
  trunkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderTrunkUpdateWithoutTrunkInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutOrderTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  delivery?: InputMaybe<EnumDeliveryFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutOrderTrunkNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutOrderTrunkNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderTrunkUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderTrunkCreateWithoutOrderInput;
  update: OrderTrunkUpdateWithoutOrderInput;
  where: OrderTrunkWhereUniqueInput;
};

export type OrderTrunkUpsertWithoutOrderNumbersInput = {
  create: OrderTrunkCreateWithoutOrderNumbersInput;
  update: OrderTrunkUpdateWithoutOrderNumbersInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkUpsertWithoutPortingsInput = {
  create: OrderTrunkCreateWithoutPortingsInput;
  update: OrderTrunkUpdateWithoutPortingsInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkUpsertWithoutTrunkInput = {
  create: OrderTrunkCreateWithoutTrunkInput;
  update: OrderTrunkUpdateWithoutTrunkInput;
  where?: InputMaybe<OrderTrunkWhereInput>;
};

export type OrderTrunkWhereInput = {
  AND?: InputMaybe<Array<OrderTrunkWhereInput>>;
  NOT?: InputMaybe<Array<OrderTrunkWhereInput>>;
  OR?: InputMaybe<Array<OrderTrunkWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  channel?: InputMaybe<IntFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderNumbers?: InputMaybe<OrderNumberListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type OrderTrunkWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderTrunkWhereInput>>;
  NOT?: InputMaybe<Array<OrderTrunkWhereInput>>;
  OR?: InputMaybe<Array<OrderTrunkWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  channel?: InputMaybe<IntFilter>;
  delivery?: InputMaybe<EnumDeliveryFilter>;
  desiredDate?: InputMaybe<DateTimeNullableFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  orderNumbers?: InputMaybe<OrderNumberListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
};

export type OrderUpdate = {
  __typename?: 'OrderUpdate';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
};

export type OrderUpdateCreateManyOrderInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
};

export type OrderUpdateCreateManyOrderInputEnvelope = {
  data: Array<OrderUpdateCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderUpdateCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderUpdateCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderUpdateCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderUpdateCreateManyOrderInputEnvelope>;
};

export type OrderUpdateCreateOrConnectWithoutOrderInput = {
  create: OrderUpdateCreateWithoutOrderInput;
  where: OrderUpdateWhereUniqueInput;
};

export type OrderUpdateCreateWithoutOrderInput = {
  message: Scalars['String']['input'];
};

export type OrderUpdateInput = {
  accesses?: InputMaybe<OrderAccessUpdateManyWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  ethernets?: InputMaybe<OrderEthernetUpdateManyWithoutOrderNestedInput>;
  misc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  numbers?: InputMaybe<OrderNumberUpdateManyWithoutOrderNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutOrderNestedInput>;
  signedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  trunks?: InputMaybe<OrderTrunkUpdateManyWithoutOrderNestedInput>;
  updates?: InputMaybe<OrderUpdateUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateListRelationFilter = {
  every?: InputMaybe<OrderUpdateWhereInput>;
  none?: InputMaybe<OrderUpdateWhereInput>;
  some?: InputMaybe<OrderUpdateWhereInput>;
};

export type OrderUpdateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderUpdateOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
};

export enum OrderUpdateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  OrderId = 'orderId'
}

export type OrderUpdateScalarWhereInput = {
  AND?: InputMaybe<Array<OrderUpdateScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderUpdateScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderUpdateScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntFilter>;
};

export type OrderUpdateUpdateManyMutationInput = {
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderUpdateUpdateManyWithWhereWithoutOrderInput = {
  data: OrderUpdateUpdateManyMutationInput;
  where: OrderUpdateScalarWhereInput;
};

export type OrderUpdateUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderUpdateCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderUpdateCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderUpdateCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderUpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderUpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderUpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderUpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderUpdateUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderUpdateUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderUpdateUpdateWithoutOrderInput;
  where: OrderUpdateWhereUniqueInput;
};

export type OrderUpdateUpdateWithoutOrderInput = {
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderUpdateUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderUpdateCreateWithoutOrderInput;
  update: OrderUpdateUpdateWithoutOrderInput;
  where: OrderUpdateWhereUniqueInput;
};

export type OrderUpdateWhereInput = {
  AND?: InputMaybe<Array<OrderUpdateWhereInput>>;
  NOT?: InputMaybe<Array<OrderUpdateWhereInput>>;
  OR?: InputMaybe<Array<OrderUpdateWhereInput>>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<IntFilter>;
};

export type OrderUpdateWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderUpdateWhereInput>>;
  NOT?: InputMaybe<Array<OrderUpdateWhereInput>>;
  OR?: InputMaybe<Array<OrderUpdateWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<IntFilter>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  accesses?: InputMaybe<OrderAccessListRelationFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  ethernets?: InputMaybe<OrderEthernetListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  misc?: InputMaybe<StringNullableFilter>;
  numbers?: InputMaybe<OrderNumberListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunks?: InputMaybe<OrderTrunkListRelationFilter>;
  updates?: InputMaybe<OrderUpdateListRelationFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  accesses?: InputMaybe<OrderAccessListRelationFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  ethernets?: InputMaybe<OrderEthernetListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  misc?: InputMaybe<StringNullableFilter>;
  numbers?: InputMaybe<OrderNumberListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  trunks?: InputMaybe<OrderTrunkListRelationFilter>;
  updates?: InputMaybe<OrderUpdateListRelationFilter>;
};

export type Partner = {
  __typename?: 'Partner';
  _count?: Maybe<PartnerCount>;
  email: Scalars['String']['output'];
  hasRecruitedPartners: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isReseller: Scalars['Boolean']['output'];
  newsClosed: Scalars['Boolean']['output'];
  recruitedById?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export type PartnerCount = {
  __typename?: 'PartnerCount';
  availabilities: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  provisions: Scalars['Int']['output'];
  recruitedPartners: Scalars['Int']['output'];
};


export type PartnerCountAvailabilitiesArgs = {
  where?: InputMaybe<AvailabilityWhereInput>;
};


export type PartnerCountCustomersArgs = {
  where?: InputMaybe<CustomerWhereInput>;
};


export type PartnerCountProvisionsArgs = {
  where?: InputMaybe<ProvisionWhereInput>;
};


export type PartnerCountRecruitedPartnersArgs = {
  where?: InputMaybe<PartnerWhereInput>;
};

export type PartnerListRelationFilter = {
  every?: InputMaybe<PartnerWhereInput>;
  none?: InputMaybe<PartnerWhereInput>;
  some?: InputMaybe<PartnerWhereInput>;
};

export type PartnerNullableRelationFilter = {
  is?: InputMaybe<PartnerWhereInput>;
  isNot?: InputMaybe<PartnerWhereInput>;
};

export type PartnerWhereInput = {
  AND?: InputMaybe<Array<PartnerWhereInput>>;
  NOT?: InputMaybe<Array<PartnerWhereInput>>;
  OR?: InputMaybe<Array<PartnerWhereInput>>;
  availabilities?: InputMaybe<AvailabilityListRelationFilter>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isReseller?: InputMaybe<BoolFilter>;
  newsClosed?: InputMaybe<BoolFilter>;
  provisions?: InputMaybe<ProvisionListRelationFilter>;
  recruitedBy?: InputMaybe<PartnerNullableRelationFilter>;
  recruitedById?: InputMaybe<IntNullableFilter>;
  recruitedPartners?: InputMaybe<PartnerListRelationFilter>;
  username?: InputMaybe<StringFilter>;
};

/** PDF */
export type Pdf = {
  __typename?: 'Pdf';
  base64EncodedPdf: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type PdfInput = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  portingId?: InputMaybe<Scalars['Int']['input']>;
  type: PdfType;
};

export type PdfToImageInput = {
  file: Scalars['Upload']['input'];
};

export enum PdfType {
  Porting = 'PORTING',
  Quote = 'QUOTE',
  Sepa = 'SEPA'
}

export type PdfsInput = {
  orderId: Scalars['Int']['input'];
  type?: InputMaybe<PdfType>;
};

/** Place */
export type PlaceType = {
  __typename?: 'PlaceType';
  city: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  noAdditional: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type Porting = {
  __typename?: 'Porting';
  _count?: Maybe<PortingCount>;
  accessProduct?: Maybe<Product>;
  accessProductId?: Maybe<Scalars['Int']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  allNumbers: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  desiredDate: Scalars['DateTimeISO']['output'];
  ekpAbg: Ekp;
  ekpAbgId: Scalars['Int']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  hno: Scalars['Int']['output'];
  hnoSuffix?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numbers: Array<PortingNumber>;
  onkz: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['Int']['output'];
  orderTrunk?: Maybe<OrderTrunk>;
  orderTrunkId?: Maybe<Scalars['Int']['output']>;
  portingForm?: Maybe<File>;
  portingFormId?: Maybe<Scalars['Int']['output']>;
  ressourceId?: Maybe<Scalars['String']['output']>;
  status: PortingStatus;
  street: Scalars['String']['output'];
  switchingDate?: Maybe<Scalars['DateTimeISO']['output']>;
  terminate: Scalars['Boolean']['output'];
  trunk?: Maybe<Trunk>;
  trunkId?: Maybe<Scalars['Int']['output']>;
  updates: Array<PortingUpdate>;
  wbciGf: WbciGf;
  wbciTransactions: Array<WbciTransaction>;
  zip: Scalars['String']['output'];
};


export type PortingAccessProductArgs = {
  where?: InputMaybe<ProductWhereInput>;
};


export type PortingNumbersArgs = {
  cursor?: InputMaybe<PortingNumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingNumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingNumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingNumberWhereInput>;
};


export type PortingOrderTrunkArgs = {
  where?: InputMaybe<OrderTrunkWhereInput>;
};


export type PortingPortingFormArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type PortingTrunkArgs = {
  where?: InputMaybe<TrunkWhereInput>;
};


export type PortingUpdatesArgs = {
  cursor?: InputMaybe<PortingUpdateWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingUpdateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingUpdateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingUpdateWhereInput>;
};


export type PortingWbciTransactionsArgs = {
  cursor?: InputMaybe<WbciTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<WbciTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WbciTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WbciTransactionWhereInput>;
};

export type PortingCount = {
  __typename?: 'PortingCount';
  numbers: Scalars['Int']['output'];
  updates: Scalars['Int']['output'];
  wbciTransactions: Scalars['Int']['output'];
};


export type PortingCountNumbersArgs = {
  where?: InputMaybe<PortingNumberWhereInput>;
};


export type PortingCountUpdatesArgs = {
  where?: InputMaybe<PortingUpdateWhereInput>;
};


export type PortingCountWbciTransactionsArgs = {
  where?: InputMaybe<WbciTransactionWhereInput>;
};

export type PortingCreateManyAccessProductInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbgId: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  onkz: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  portingFormId?: InputMaybe<Scalars['Int']['input']>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunkId?: InputMaybe<Scalars['Int']['input']>;
  zip: Scalars['String']['input'];
};

export type PortingCreateManyAccessProductInputEnvelope = {
  data: Array<PortingCreateManyAccessProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingCreateManyOrderInput = {
  accessProductId?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbgId: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  onkz: Scalars['String']['input'];
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  portingFormId?: InputMaybe<Scalars['Int']['input']>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunkId?: InputMaybe<Scalars['Int']['input']>;
  zip: Scalars['String']['input'];
};

export type PortingCreateManyOrderInputEnvelope = {
  data: Array<PortingCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingCreateManyOrderTrunkInput = {
  accessProductId?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbgId: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  onkz: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  portingFormId?: InputMaybe<Scalars['Int']['input']>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunkId?: InputMaybe<Scalars['Int']['input']>;
  zip: Scalars['String']['input'];
};

export type PortingCreateManyOrderTrunkInputEnvelope = {
  data: Array<PortingCreateManyOrderTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingCreateManyTrunkInput = {
  accessProductId?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbgId: Scalars['Int']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  onkz: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  portingFormId?: InputMaybe<Scalars['Int']['input']>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  zip: Scalars['String']['input'];
};

export type PortingCreateManyTrunkInputEnvelope = {
  data: Array<PortingCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingCreateNestedManyWithoutAccessProductInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutAccessProductInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutAccessProductInput>>;
  createMany?: InputMaybe<PortingCreateManyAccessProductInputEnvelope>;
};

export type PortingCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PortingCreateManyOrderInputEnvelope>;
};

export type PortingCreateNestedManyWithoutOrderTrunkInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutOrderTrunkInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutOrderTrunkInput>>;
  createMany?: InputMaybe<PortingCreateManyOrderTrunkInputEnvelope>;
};

export type PortingCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<PortingCreateManyTrunkInputEnvelope>;
};

export type PortingCreateOrConnectWithoutAccessProductInput = {
  create: PortingCreateWithoutAccessProductInput;
  where: PortingWhereUniqueInput;
};

export type PortingCreateOrConnectWithoutOrderInput = {
  create: PortingCreateWithoutOrderInput;
  where: PortingWhereUniqueInput;
};

export type PortingCreateOrConnectWithoutOrderTrunkInput = {
  create: PortingCreateWithoutOrderTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingCreateOrConnectWithoutTrunkInput = {
  create: PortingCreateWithoutTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingCreateWithoutAccessProductInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbg: EkpCreateNestedOneWithoutPortingAbgInput;
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numbers?: InputMaybe<PortingNumberCreateNestedManyWithoutPortingInput>;
  onkz: Scalars['String']['input'];
  orderTrunk?: InputMaybe<OrderTrunkCreateNestedOneWithoutPortingsInput>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutPortingsInput>;
  updates?: InputMaybe<PortingUpdateCreateNestedManyWithoutPortingInput>;
  wbciTransactions?: InputMaybe<WbciTransactionCreateNestedManyWithoutPortingInput>;
  zip: Scalars['String']['input'];
};

export type PortingCreateWithoutOrderInput = {
  accessProduct?: InputMaybe<ProductCreateNestedOneWithoutPortingsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbg: EkpCreateNestedOneWithoutPortingAbgInput;
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numbers?: InputMaybe<PortingNumberCreateNestedManyWithoutPortingInput>;
  onkz: Scalars['String']['input'];
  orderTrunk?: InputMaybe<OrderTrunkCreateNestedOneWithoutPortingsInput>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutPortingsInput>;
  updates?: InputMaybe<PortingUpdateCreateNestedManyWithoutPortingInput>;
  wbciTransactions?: InputMaybe<WbciTransactionCreateNestedManyWithoutPortingInput>;
  zip: Scalars['String']['input'];
};

export type PortingCreateWithoutOrderTrunkInput = {
  accessProduct?: InputMaybe<ProductCreateNestedOneWithoutPortingsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbg: EkpCreateNestedOneWithoutPortingAbgInput;
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numbers?: InputMaybe<PortingNumberCreateNestedManyWithoutPortingInput>;
  onkz: Scalars['String']['input'];
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  trunk?: InputMaybe<TrunkCreateNestedOneWithoutPortingsInput>;
  updates?: InputMaybe<PortingUpdateCreateNestedManyWithoutPortingInput>;
  wbciTransactions?: InputMaybe<WbciTransactionCreateNestedManyWithoutPortingInput>;
  zip: Scalars['String']['input'];
};

export type PortingCreateWithoutTrunkInput = {
  accessProduct?: InputMaybe<ProductCreateNestedOneWithoutPortingsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  allNumbers: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  ekpAbg: EkpCreateNestedOneWithoutPortingAbgInput;
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numbers?: InputMaybe<PortingNumberCreateNestedManyWithoutPortingInput>;
  onkz: Scalars['String']['input'];
  orderTrunk?: InputMaybe<OrderTrunkCreateNestedOneWithoutPortingsInput>;
  ressourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortingStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  terminate: Scalars['Boolean']['input'];
  updates?: InputMaybe<PortingUpdateCreateNestedManyWithoutPortingInput>;
  wbciTransactions?: InputMaybe<WbciTransactionCreateNestedManyWithoutPortingInput>;
  zip: Scalars['String']['input'];
};

export type PortingListRelationFilter = {
  every?: InputMaybe<PortingWhereInput>;
  none?: InputMaybe<PortingWhereInput>;
  some?: InputMaybe<PortingWhereInput>;
};

export type PortingNumber = {
  __typename?: 'PortingNumber';
  ddi?: Maybe<Scalars['String']['output']>;
  ddiFrom?: Maybe<Scalars['String']['output']>;
  ddiTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  pkiAbg?: Maybe<Scalars['String']['output']>;
  portingId: Scalars['Int']['output'];
};

export type PortingNumberCreateManyPortingInput = {
  ddi?: InputMaybe<Scalars['String']['input']>;
  ddiFrom?: InputMaybe<Scalars['String']['input']>;
  ddiTo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
  pkiAbg?: InputMaybe<Scalars['String']['input']>;
};

export type PortingNumberCreateManyPortingInputEnvelope = {
  data: Array<PortingNumberCreateManyPortingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingNumberCreateNestedManyWithoutPortingInput = {
  connect?: InputMaybe<Array<PortingNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingNumberCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<PortingNumberCreateWithoutPortingInput>>;
  createMany?: InputMaybe<PortingNumberCreateManyPortingInputEnvelope>;
};

export type PortingNumberCreateOrConnectWithoutPortingInput = {
  create: PortingNumberCreateWithoutPortingInput;
  where: PortingNumberWhereUniqueInput;
};

export type PortingNumberCreateWithoutPortingInput = {
  ddi?: InputMaybe<Scalars['String']['input']>;
  ddiFrom?: InputMaybe<Scalars['String']['input']>;
  ddiTo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pkiAbg?: InputMaybe<Scalars['String']['input']>;
};

export type PortingNumberListRelationFilter = {
  every?: InputMaybe<PortingNumberWhereInput>;
  none?: InputMaybe<PortingNumberWhereInput>;
  some?: InputMaybe<PortingNumberWhereInput>;
};

export type PortingNumberOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PortingNumberOrderByWithRelationInput = {
  ddi?: InputMaybe<SortOrderInput>;
  ddiFrom?: InputMaybe<SortOrderInput>;
  ddiTo?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  pkiAbg?: InputMaybe<SortOrderInput>;
  porting?: InputMaybe<PortingOrderByWithRelationInput>;
  portingId?: InputMaybe<SortOrder>;
};

export enum PortingNumberScalarFieldEnum {
  Ddi = 'ddi',
  DdiFrom = 'ddiFrom',
  DdiTo = 'ddiTo',
  Id = 'id',
  Number = 'number',
  PkiAbg = 'pkiAbg',
  PortingId = 'portingId'
}

export type PortingNumberScalarWhereInput = {
  AND?: InputMaybe<Array<PortingNumberScalarWhereInput>>;
  NOT?: InputMaybe<Array<PortingNumberScalarWhereInput>>;
  OR?: InputMaybe<Array<PortingNumberScalarWhereInput>>;
  ddi?: InputMaybe<StringNullableFilter>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  pkiAbg?: InputMaybe<StringNullableFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingNumberUpdateManyMutationInput = {
  ddi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  pkiAbg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PortingNumberUpdateManyWithWhereWithoutPortingInput = {
  data: PortingNumberUpdateManyMutationInput;
  where: PortingNumberScalarWhereInput;
};

export type PortingNumberUpdateManyWithoutPortingNestedInput = {
  connect?: InputMaybe<Array<PortingNumberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingNumberCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<PortingNumberCreateWithoutPortingInput>>;
  createMany?: InputMaybe<PortingNumberCreateManyPortingInputEnvelope>;
  delete?: InputMaybe<Array<PortingNumberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingNumberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingNumberWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingNumberWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingNumberUpdateWithWhereUniqueWithoutPortingInput>>;
  updateMany?: InputMaybe<Array<PortingNumberUpdateManyWithWhereWithoutPortingInput>>;
  upsert?: InputMaybe<Array<PortingNumberUpsertWithWhereUniqueWithoutPortingInput>>;
};

export type PortingNumberUpdateWithWhereUniqueWithoutPortingInput = {
  data: PortingNumberUpdateWithoutPortingInput;
  where: PortingNumberWhereUniqueInput;
};

export type PortingNumberUpdateWithoutPortingInput = {
  ddi?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ddiTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  pkiAbg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PortingNumberUpsertWithWhereUniqueWithoutPortingInput = {
  create: PortingNumberCreateWithoutPortingInput;
  update: PortingNumberUpdateWithoutPortingInput;
  where: PortingNumberWhereUniqueInput;
};

export type PortingNumberWhereInput = {
  AND?: InputMaybe<Array<PortingNumberWhereInput>>;
  NOT?: InputMaybe<Array<PortingNumberWhereInput>>;
  OR?: InputMaybe<Array<PortingNumberWhereInput>>;
  ddi?: InputMaybe<StringNullableFilter>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  pkiAbg?: InputMaybe<StringNullableFilter>;
  porting?: InputMaybe<PortingRelationFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingNumberWhereUniqueInput = {
  AND?: InputMaybe<Array<PortingNumberWhereInput>>;
  NOT?: InputMaybe<Array<PortingNumberWhereInput>>;
  OR?: InputMaybe<Array<PortingNumberWhereInput>>;
  ddi?: InputMaybe<StringNullableFilter>;
  ddiFrom?: InputMaybe<StringNullableFilter>;
  ddiTo?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<StringFilter>;
  pkiAbg?: InputMaybe<StringNullableFilter>;
  porting?: InputMaybe<PortingRelationFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PortingOrderByWithRelationInput = {
  accessProduct?: InputMaybe<ProductOrderByWithRelationInput>;
  accessProductId?: InputMaybe<SortOrderInput>;
  alias?: InputMaybe<SortOrderInput>;
  allNumbers?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  desiredDate?: InputMaybe<SortOrder>;
  ekpAbg?: InputMaybe<EkpOrderByWithRelationInput>;
  ekpAbgId?: InputMaybe<SortOrder>;
  firstname?: InputMaybe<SortOrderInput>;
  hno?: InputMaybe<SortOrder>;
  hnoSuffix?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  numbers?: InputMaybe<PortingNumberOrderByRelationAggregateInput>;
  onkz?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  orderTrunk?: InputMaybe<OrderTrunkOrderByWithRelationInput>;
  orderTrunkId?: InputMaybe<SortOrderInput>;
  portingForm?: InputMaybe<FileOrderByWithRelationInput>;
  portingFormId?: InputMaybe<SortOrderInput>;
  ressourceId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  switchingDate?: InputMaybe<SortOrderInput>;
  terminate?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrderInput>;
  updates?: InputMaybe<PortingUpdateOrderByRelationAggregateInput>;
  wbciTransactions?: InputMaybe<WbciTransactionOrderByRelationAggregateInput>;
  zip?: InputMaybe<SortOrder>;
};

export type PortingOrderCompleteType = {
  document: Scalars['Upload']['input'];
  portingId: Scalars['Float']['input'];
  signature: Scalars['Upload']['input'];
};

export type PortingRelationFilter = {
  is?: InputMaybe<PortingWhereInput>;
  isNot?: InputMaybe<PortingWhereInput>;
};

export enum PortingScalarFieldEnum {
  AccessProductId = 'accessProductId',
  Alias = 'alias',
  AllNumbers = 'allNumbers',
  City = 'city',
  DesiredDate = 'desiredDate',
  EkpAbgId = 'ekpAbgId',
  Firstname = 'firstname',
  Hno = 'hno',
  HnoSuffix = 'hnoSuffix',
  Id = 'id',
  Name = 'name',
  Onkz = 'onkz',
  OrderId = 'orderId',
  OrderTrunkId = 'orderTrunkId',
  PortingFormId = 'portingFormId',
  RessourceId = 'ressourceId',
  Status = 'status',
  Street = 'street',
  SwitchingDate = 'switchingDate',
  Terminate = 'terminate',
  TrunkId = 'trunkId',
  Zip = 'zip'
}

export type PortingScalarWhereInput = {
  AND?: InputMaybe<Array<PortingScalarWhereInput>>;
  NOT?: InputMaybe<Array<PortingScalarWhereInput>>;
  OR?: InputMaybe<Array<PortingScalarWhereInput>>;
  accessProductId?: InputMaybe<IntNullableFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  allNumbers?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  ekpAbgId?: InputMaybe<IntFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  onkz?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  portingFormId?: InputMaybe<IntNullableFilter>;
  ressourceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPortingStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  terminate?: InputMaybe<BoolFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export enum PortingStatus {
  Archived = 'ARCHIVED',
  Attention = 'ATTENTION',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Draft = 'DRAFT',
  Placed = 'PLACED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export type PortingUpdate = {
  __typename?: 'PortingUpdate';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  portingId: Scalars['Int']['output'];
};

export type PortingUpdateCreateManyPortingInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
};

export type PortingUpdateCreateManyPortingInputEnvelope = {
  data: Array<PortingUpdateCreateManyPortingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortingUpdateCreateNestedManyWithoutPortingInput = {
  connect?: InputMaybe<Array<PortingUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingUpdateCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<PortingUpdateCreateWithoutPortingInput>>;
  createMany?: InputMaybe<PortingUpdateCreateManyPortingInputEnvelope>;
};

export type PortingUpdateCreateOrConnectWithoutPortingInput = {
  create: PortingUpdateCreateWithoutPortingInput;
  where: PortingUpdateWhereUniqueInput;
};

export type PortingUpdateCreateWithoutPortingInput = {
  message: Scalars['String']['input'];
};

export type PortingUpdateListRelationFilter = {
  every?: InputMaybe<PortingUpdateWhereInput>;
  none?: InputMaybe<PortingUpdateWhereInput>;
  some?: InputMaybe<PortingUpdateWhereInput>;
};

export type PortingUpdateManyMutationInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  allNumbers?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onkz?: InputMaybe<StringFieldUpdateOperationsInput>;
  ressourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPortingStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  terminate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateManyWithWhereWithoutAccessProductInput = {
  data: PortingUpdateManyMutationInput;
  where: PortingScalarWhereInput;
};

export type PortingUpdateManyWithWhereWithoutOrderInput = {
  data: PortingUpdateManyMutationInput;
  where: PortingScalarWhereInput;
};

export type PortingUpdateManyWithWhereWithoutOrderTrunkInput = {
  data: PortingUpdateManyMutationInput;
  where: PortingScalarWhereInput;
};

export type PortingUpdateManyWithWhereWithoutTrunkInput = {
  data: PortingUpdateManyMutationInput;
  where: PortingScalarWhereInput;
};

export type PortingUpdateManyWithoutAccessProductNestedInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutAccessProductInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutAccessProductInput>>;
  createMany?: InputMaybe<PortingCreateManyAccessProductInputEnvelope>;
  delete?: InputMaybe<Array<PortingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingUpdateWithWhereUniqueWithoutAccessProductInput>>;
  updateMany?: InputMaybe<Array<PortingUpdateManyWithWhereWithoutAccessProductInput>>;
  upsert?: InputMaybe<Array<PortingUpsertWithWhereUniqueWithoutAccessProductInput>>;
};

export type PortingUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PortingCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<PortingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<PortingUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<PortingUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type PortingUpdateManyWithoutOrderTrunkNestedInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutOrderTrunkInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutOrderTrunkInput>>;
  createMany?: InputMaybe<PortingCreateManyOrderTrunkInputEnvelope>;
  delete?: InputMaybe<Array<PortingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingUpdateWithWhereUniqueWithoutOrderTrunkInput>>;
  updateMany?: InputMaybe<Array<PortingUpdateManyWithWhereWithoutOrderTrunkInput>>;
  upsert?: InputMaybe<Array<PortingUpsertWithWhereUniqueWithoutOrderTrunkInput>>;
};

export type PortingUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<PortingCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<PortingCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<PortingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<PortingUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<PortingUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type PortingUpdateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PortingUpdateOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  porting?: InputMaybe<PortingOrderByWithRelationInput>;
  portingId?: InputMaybe<SortOrder>;
};

export enum PortingUpdateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  PortingId = 'portingId'
}

export type PortingUpdateScalarWhereInput = {
  AND?: InputMaybe<Array<PortingUpdateScalarWhereInput>>;
  NOT?: InputMaybe<Array<PortingUpdateScalarWhereInput>>;
  OR?: InputMaybe<Array<PortingUpdateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingUpdateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateUpdateManyWithWhereWithoutPortingInput = {
  data: PortingUpdateUpdateManyMutationInput;
  where: PortingUpdateScalarWhereInput;
};

export type PortingUpdateUpdateManyWithoutPortingNestedInput = {
  connect?: InputMaybe<Array<PortingUpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PortingUpdateCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<PortingUpdateCreateWithoutPortingInput>>;
  createMany?: InputMaybe<PortingUpdateCreateManyPortingInputEnvelope>;
  delete?: InputMaybe<Array<PortingUpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PortingUpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PortingUpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<PortingUpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<PortingUpdateUpdateWithWhereUniqueWithoutPortingInput>>;
  updateMany?: InputMaybe<Array<PortingUpdateUpdateManyWithWhereWithoutPortingInput>>;
  upsert?: InputMaybe<Array<PortingUpdateUpsertWithWhereUniqueWithoutPortingInput>>;
};

export type PortingUpdateUpdateWithWhereUniqueWithoutPortingInput = {
  data: PortingUpdateUpdateWithoutPortingInput;
  where: PortingUpdateWhereUniqueInput;
};

export type PortingUpdateUpdateWithoutPortingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateUpsertWithWhereUniqueWithoutPortingInput = {
  create: PortingUpdateCreateWithoutPortingInput;
  update: PortingUpdateUpdateWithoutPortingInput;
  where: PortingUpdateWhereUniqueInput;
};

export type PortingUpdateWhereInput = {
  AND?: InputMaybe<Array<PortingUpdateWhereInput>>;
  NOT?: InputMaybe<Array<PortingUpdateWhereInput>>;
  OR?: InputMaybe<Array<PortingUpdateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  porting?: InputMaybe<PortingRelationFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingUpdateWhereUniqueInput = {
  AND?: InputMaybe<Array<PortingUpdateWhereInput>>;
  NOT?: InputMaybe<Array<PortingUpdateWhereInput>>;
  OR?: InputMaybe<Array<PortingUpdateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringFilter>;
  porting?: InputMaybe<PortingRelationFilter>;
  portingId?: InputMaybe<IntFilter>;
};

export type PortingUpdateWithWhereUniqueWithoutAccessProductInput = {
  data: PortingUpdateWithoutAccessProductInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpdateWithWhereUniqueWithoutOrderInput = {
  data: PortingUpdateWithoutOrderInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpdateWithWhereUniqueWithoutOrderTrunkInput = {
  data: PortingUpdateWithoutOrderTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpdateWithWhereUniqueWithoutTrunkInput = {
  data: PortingUpdateWithoutTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpdateWithoutAccessProductInput = {
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  allNumbers?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ekpAbg?: InputMaybe<EkpUpdateOneRequiredWithoutPortingAbgNestedInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  numbers?: InputMaybe<PortingNumberUpdateManyWithoutPortingNestedInput>;
  onkz?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneWithoutPortingsNestedInput>;
  ressourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPortingStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  terminate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutPortingsNestedInput>;
  updates?: InputMaybe<PortingUpdateUpdateManyWithoutPortingNestedInput>;
  wbciTransactions?: InputMaybe<WbciTransactionUpdateManyWithoutPortingNestedInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateWithoutOrderInput = {
  accessProduct?: InputMaybe<ProductUpdateOneWithoutPortingsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  allNumbers?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ekpAbg?: InputMaybe<EkpUpdateOneRequiredWithoutPortingAbgNestedInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  numbers?: InputMaybe<PortingNumberUpdateManyWithoutPortingNestedInput>;
  onkz?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneWithoutPortingsNestedInput>;
  ressourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPortingStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  terminate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutPortingsNestedInput>;
  updates?: InputMaybe<PortingUpdateUpdateManyWithoutPortingNestedInput>;
  wbciTransactions?: InputMaybe<WbciTransactionUpdateManyWithoutPortingNestedInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateWithoutOrderTrunkInput = {
  accessProduct?: InputMaybe<ProductUpdateOneWithoutPortingsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  allNumbers?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ekpAbg?: InputMaybe<EkpUpdateOneRequiredWithoutPortingAbgNestedInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  numbers?: InputMaybe<PortingNumberUpdateManyWithoutPortingNestedInput>;
  onkz?: InputMaybe<StringFieldUpdateOperationsInput>;
  ressourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPortingStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  terminate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trunk?: InputMaybe<TrunkUpdateOneWithoutPortingsNestedInput>;
  updates?: InputMaybe<PortingUpdateUpdateManyWithoutPortingNestedInput>;
  wbciTransactions?: InputMaybe<WbciTransactionUpdateManyWithoutPortingNestedInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpdateWithoutTrunkInput = {
  accessProduct?: InputMaybe<ProductUpdateOneWithoutPortingsNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  allNumbers?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ekpAbg?: InputMaybe<EkpUpdateOneRequiredWithoutPortingAbgNestedInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  numbers?: InputMaybe<PortingNumberUpdateManyWithoutPortingNestedInput>;
  onkz?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneWithoutPortingsNestedInput>;
  ressourceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPortingStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  terminate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updates?: InputMaybe<PortingUpdateUpdateManyWithoutPortingNestedInput>;
  wbciTransactions?: InputMaybe<WbciTransactionUpdateManyWithoutPortingNestedInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PortingUpsertWithWhereUniqueWithoutAccessProductInput = {
  create: PortingCreateWithoutAccessProductInput;
  update: PortingUpdateWithoutAccessProductInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpsertWithWhereUniqueWithoutOrderInput = {
  create: PortingCreateWithoutOrderInput;
  update: PortingUpdateWithoutOrderInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpsertWithWhereUniqueWithoutOrderTrunkInput = {
  create: PortingCreateWithoutOrderTrunkInput;
  update: PortingUpdateWithoutOrderTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingUpsertWithWhereUniqueWithoutTrunkInput = {
  create: PortingCreateWithoutTrunkInput;
  update: PortingUpdateWithoutTrunkInput;
  where: PortingWhereUniqueInput;
};

export type PortingWhereInput = {
  AND?: InputMaybe<Array<PortingWhereInput>>;
  NOT?: InputMaybe<Array<PortingWhereInput>>;
  OR?: InputMaybe<Array<PortingWhereInput>>;
  accessProduct?: InputMaybe<ProductNullableRelationFilter>;
  accessProductId?: InputMaybe<IntNullableFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  allNumbers?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  ekpAbg?: InputMaybe<EkpRelationFilter>;
  ekpAbgId?: InputMaybe<IntFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  numbers?: InputMaybe<PortingNumberListRelationFilter>;
  onkz?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunk?: InputMaybe<OrderTrunkNullableRelationFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  portingForm?: InputMaybe<FileNullableRelationFilter>;
  portingFormId?: InputMaybe<IntNullableFilter>;
  ressourceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPortingStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  terminate?: InputMaybe<BoolFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  updates?: InputMaybe<PortingUpdateListRelationFilter>;
  wbciTransactions?: InputMaybe<WbciTransactionListRelationFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type PortingWhereUniqueInput = {
  AND?: InputMaybe<Array<PortingWhereInput>>;
  NOT?: InputMaybe<Array<PortingWhereInput>>;
  OR?: InputMaybe<Array<PortingWhereInput>>;
  accessProduct?: InputMaybe<ProductNullableRelationFilter>;
  accessProductId?: InputMaybe<IntNullableFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  allNumbers?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  ekpAbg?: InputMaybe<EkpRelationFilter>;
  ekpAbgId?: InputMaybe<IntFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  numbers?: InputMaybe<PortingNumberListRelationFilter>;
  onkz?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderTrunk?: InputMaybe<OrderTrunkNullableRelationFilter>;
  orderTrunkId?: InputMaybe<IntNullableFilter>;
  portingForm?: InputMaybe<FileNullableRelationFilter>;
  portingFormId?: InputMaybe<IntNullableFilter>;
  ressourceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPortingStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  terminate?: InputMaybe<BoolFilter>;
  trunk?: InputMaybe<TrunkNullableRelationFilter>;
  trunkId?: InputMaybe<IntNullableFilter>;
  updates?: InputMaybe<PortingUpdateListRelationFilter>;
  wbciTransactions?: InputMaybe<WbciTransactionListRelationFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type Product = {
  __typename?: 'Product';
  _count?: Maybe<ProductCount>;
  bookable: Scalars['Boolean']['output'];
  carrierProducts: Array<CarrierProduct>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderAccesses: Array<OrderAccess>;
  orderEthernets: Array<OrderEthernet>;
  portings: Array<Porting>;
  priceMonth: Scalars['Float']['output'];
  priceSetup: Scalars['Float']['output'];
  productCategory: ProductCategory;
  productCategoryId: Scalars['Int']['output'];
};


export type ProductCarrierProductsArgs = {
  cursor?: InputMaybe<CarrierProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<CarrierProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CarrierProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarrierProductWhereInput>;
};


export type ProductOrderAccessesArgs = {
  cursor?: InputMaybe<OrderAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type ProductOrderEthernetsArgs = {
  cursor?: InputMaybe<OrderEthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderEthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderEthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type ProductPortingsArgs = {
  cursor?: InputMaybe<PortingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingWhereInput>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  _count?: Maybe<ProductCategoryCount>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ProductCategoryCount = {
  __typename?: 'ProductCategoryCount';
  products: Scalars['Int']['output'];
};


export type ProductCategoryCountProductsArgs = {
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductCategoryCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCategoryCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<ProductCategoryCreateWithoutProductsInput>;
};

export type ProductCategoryCreateOrConnectWithoutProductsInput = {
  create: ProductCategoryCreateWithoutProductsInput;
  where: ProductCategoryWhereUniqueInput;
};

export type ProductCategoryCreateWithoutProductsInput = {
  name: Scalars['String']['input'];
};

export type ProductCategoryOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
};

export type ProductCategoryRelationFilter = {
  is?: InputMaybe<ProductCategoryWhereInput>;
  isNot?: InputMaybe<ProductCategoryWhereInput>;
};

export enum ProductCategoryScalarFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type ProductCategoryUpdateOneRequiredWithoutProductsNestedInput = {
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCategoryCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<ProductCategoryCreateWithoutProductsInput>;
  update?: InputMaybe<ProductCategoryUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<ProductCategoryUpsertWithoutProductsInput>;
};

export type ProductCategoryUpdateToOneWithWhereWithoutProductsInput = {
  data: ProductCategoryUpdateWithoutProductsInput;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

export type ProductCategoryUpdateWithoutProductsInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductCategoryUpsertWithoutProductsInput = {
  create: ProductCategoryCreateWithoutProductsInput;
  update: ProductCategoryUpdateWithoutProductsInput;
  where?: InputMaybe<ProductCategoryWhereInput>;
};

export type ProductCategoryWhereInput = {
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
};

export type ProductCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  carrierProducts: Scalars['Int']['output'];
  orderAccesses: Scalars['Int']['output'];
  orderEthernets: Scalars['Int']['output'];
  portings: Scalars['Int']['output'];
};


export type ProductCountCarrierProductsArgs = {
  where?: InputMaybe<CarrierProductWhereInput>;
};


export type ProductCountOrderAccessesArgs = {
  where?: InputMaybe<OrderAccessWhereInput>;
};


export type ProductCountOrderEthernetsArgs = {
  where?: InputMaybe<OrderEthernetWhereInput>;
};


export type ProductCountPortingsArgs = {
  where?: InputMaybe<PortingWhereInput>;
};

export type ProductCreateNestedOneWithoutCarrierProductsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutCarrierProductsInput>;
  create?: InputMaybe<ProductCreateWithoutCarrierProductsInput>;
};

export type ProductCreateNestedOneWithoutOrderAccessesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutOrderAccessesInput>;
  create?: InputMaybe<ProductCreateWithoutOrderAccessesInput>;
};

export type ProductCreateNestedOneWithoutOrderEthernetsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutOrderEthernetsInput>;
  create?: InputMaybe<ProductCreateWithoutOrderEthernetsInput>;
};

export type ProductCreateNestedOneWithoutPortingsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<ProductCreateWithoutPortingsInput>;
};

export type ProductCreateOrConnectWithoutCarrierProductsInput = {
  create: ProductCreateWithoutCarrierProductsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutOrderAccessesInput = {
  create: ProductCreateWithoutOrderAccessesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutOrderEthernetsInput = {
  create: ProductCreateWithoutOrderEthernetsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPortingsInput = {
  create: ProductCreateWithoutPortingsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutCarrierProductsInput = {
  bookable: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderAccesses?: InputMaybe<OrderAccessCreateNestedManyWithoutProductInput>;
  orderEthernets?: InputMaybe<OrderEthernetCreateNestedManyWithoutProductInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutAccessProductInput>;
  priceMonth: Scalars['Float']['input'];
  priceSetup: Scalars['Float']['input'];
  productCategory: ProductCategoryCreateNestedOneWithoutProductsInput;
};

export type ProductCreateWithoutOrderAccessesInput = {
  bookable: Scalars['Boolean']['input'];
  carrierProducts?: InputMaybe<CarrierProductCreateNestedManyWithoutProductInput>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderEthernets?: InputMaybe<OrderEthernetCreateNestedManyWithoutProductInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutAccessProductInput>;
  priceMonth: Scalars['Float']['input'];
  priceSetup: Scalars['Float']['input'];
  productCategory: ProductCategoryCreateNestedOneWithoutProductsInput;
};

export type ProductCreateWithoutOrderEthernetsInput = {
  bookable: Scalars['Boolean']['input'];
  carrierProducts?: InputMaybe<CarrierProductCreateNestedManyWithoutProductInput>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderAccesses?: InputMaybe<OrderAccessCreateNestedManyWithoutProductInput>;
  portings?: InputMaybe<PortingCreateNestedManyWithoutAccessProductInput>;
  priceMonth: Scalars['Float']['input'];
  priceSetup: Scalars['Float']['input'];
  productCategory: ProductCategoryCreateNestedOneWithoutProductsInput;
};

export type ProductCreateWithoutPortingsInput = {
  bookable: Scalars['Boolean']['input'];
  carrierProducts?: InputMaybe<CarrierProductCreateNestedManyWithoutProductInput>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderAccesses?: InputMaybe<OrderAccessCreateNestedManyWithoutProductInput>;
  orderEthernets?: InputMaybe<OrderEthernetCreateNestedManyWithoutProductInput>;
  priceMonth: Scalars['Float']['input'];
  priceSetup: Scalars['Float']['input'];
  productCategory: ProductCategoryCreateNestedOneWithoutProductsInput;
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductNullableRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  bookable?: InputMaybe<SortOrder>;
  carrierProducts?: InputMaybe<CarrierProductOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderAccesses?: InputMaybe<OrderAccessOrderByRelationAggregateInput>;
  orderEthernets?: InputMaybe<OrderEthernetOrderByRelationAggregateInput>;
  portings?: InputMaybe<PortingOrderByRelationAggregateInput>;
  priceMonth?: InputMaybe<SortOrder>;
  priceSetup?: InputMaybe<SortOrder>;
  productCategory?: InputMaybe<ProductCategoryOrderByWithRelationInput>;
  productCategoryId?: InputMaybe<SortOrder>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export enum ProductScalarFieldEnum {
  Bookable = 'bookable',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  PriceMonth = 'priceMonth',
  PriceSetup = 'priceSetup',
  ProductCategoryId = 'productCategoryId'
}

export type ProductUpdateOneRequiredWithoutCarrierProductsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutCarrierProductsInput>;
  create?: InputMaybe<ProductCreateWithoutCarrierProductsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutCarrierProductsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutCarrierProductsInput>;
};

export type ProductUpdateOneRequiredWithoutOrderAccessesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutOrderAccessesInput>;
  create?: InputMaybe<ProductCreateWithoutOrderAccessesInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutOrderAccessesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutOrderAccessesInput>;
};

export type ProductUpdateOneRequiredWithoutOrderEthernetsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutOrderEthernetsInput>;
  create?: InputMaybe<ProductCreateWithoutOrderEthernetsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutOrderEthernetsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutOrderEthernetsInput>;
};

export type ProductUpdateOneWithoutPortingsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<ProductCreateWithoutPortingsInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutPortingsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutPortingsInput>;
};

export type ProductUpdateToOneWithWhereWithoutCarrierProductsInput = {
  data: ProductUpdateWithoutCarrierProductsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutOrderAccessesInput = {
  data: ProductUpdateWithoutOrderAccessesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutOrderEthernetsInput = {
  data: ProductUpdateWithoutOrderEthernetsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutPortingsInput = {
  data: ProductUpdateWithoutPortingsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithoutCarrierProductsInput = {
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderAccesses?: InputMaybe<OrderAccessUpdateManyWithoutProductNestedInput>;
  orderEthernets?: InputMaybe<OrderEthernetUpdateManyWithoutProductNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutAccessProductNestedInput>;
  priceMonth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  priceSetup?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateOneRequiredWithoutProductsNestedInput>;
};

export type ProductUpdateWithoutOrderAccessesInput = {
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carrierProducts?: InputMaybe<CarrierProductUpdateManyWithoutProductNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderEthernets?: InputMaybe<OrderEthernetUpdateManyWithoutProductNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutAccessProductNestedInput>;
  priceMonth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  priceSetup?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateOneRequiredWithoutProductsNestedInput>;
};

export type ProductUpdateWithoutOrderEthernetsInput = {
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carrierProducts?: InputMaybe<CarrierProductUpdateManyWithoutProductNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderAccesses?: InputMaybe<OrderAccessUpdateManyWithoutProductNestedInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutAccessProductNestedInput>;
  priceMonth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  priceSetup?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateOneRequiredWithoutProductsNestedInput>;
};

export type ProductUpdateWithoutPortingsInput = {
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carrierProducts?: InputMaybe<CarrierProductUpdateManyWithoutProductNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderAccesses?: InputMaybe<OrderAccessUpdateManyWithoutProductNestedInput>;
  orderEthernets?: InputMaybe<OrderEthernetUpdateManyWithoutProductNestedInput>;
  priceMonth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  priceSetup?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateOneRequiredWithoutProductsNestedInput>;
};

export type ProductUpsertWithoutCarrierProductsInput = {
  create: ProductCreateWithoutCarrierProductsInput;
  update: ProductUpdateWithoutCarrierProductsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutOrderAccessesInput = {
  create: ProductCreateWithoutOrderAccessesInput;
  update: ProductUpdateWithoutOrderAccessesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutOrderEthernetsInput = {
  create: ProductCreateWithoutOrderEthernetsInput;
  update: ProductUpdateWithoutOrderEthernetsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutPortingsInput = {
  create: ProductCreateWithoutPortingsInput;
  update: ProductUpdateWithoutPortingsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  bookable?: InputMaybe<BoolFilter>;
  carrierProducts?: InputMaybe<CarrierProductListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderAccesses?: InputMaybe<OrderAccessListRelationFilter>;
  orderEthernets?: InputMaybe<OrderEthernetListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  priceMonth?: InputMaybe<FloatFilter>;
  priceSetup?: InputMaybe<FloatFilter>;
  productCategory?: InputMaybe<ProductCategoryRelationFilter>;
  productCategoryId?: InputMaybe<IntFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  bookable?: InputMaybe<BoolFilter>;
  carrierProducts?: InputMaybe<CarrierProductListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  orderAccesses?: InputMaybe<OrderAccessListRelationFilter>;
  orderEthernets?: InputMaybe<OrderEthernetListRelationFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  priceMonth?: InputMaybe<FloatFilter>;
  priceSetup?: InputMaybe<FloatFilter>;
  productCategory?: InputMaybe<ProductCategoryRelationFilter>;
  productCategoryId?: InputMaybe<IntFilter>;
};

export type Provision = {
  __typename?: 'Provision';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
};

export type ProvisionListRelationFilter = {
  every?: InputMaybe<ProvisionWhereInput>;
  none?: InputMaybe<ProvisionWhereInput>;
  some?: InputMaybe<ProvisionWhereInput>;
};

export type ProvisionOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum ProvisionScalarFieldEnum {
  Amount = 'amount',
  Date = 'date',
  Id = 'id',
  PartnerId = 'partnerId'
}

export type ProvisionWhereInput = {
  AND?: InputMaybe<Array<ProvisionWhereInput>>;
  NOT?: InputMaybe<Array<ProvisionWhereInput>>;
  OR?: InputMaybe<Array<ProvisionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
};

export type ProvisionWhereUniqueInput = {
  AND?: InputMaybe<Array<ProvisionWhereInput>>;
  NOT?: InputMaybe<Array<ProvisionWhereInput>>;
  OR?: InputMaybe<Array<ProvisionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  access?: Maybe<Access>;
  accesses: Array<Access>;
  addresses: Array<Address>;
  availabilities: Array<Availability>;
  cdrs: Array<Cdr>;
  cdrsByDestination: Array<CdrByDestination>;
  customer?: Maybe<Customer>;
  customers: Array<Customer>;
  downloadFile: Pdf;
  ekps: Array<Ekp>;
  ethernets: Array<Ethernet>;
  incident?: Maybe<Incident>;
  incidents: Array<Incident>;
  lineDiagnoses: Array<LineDiagnosis>;
  lineDiagnosis?: Maybe<LineDiagnosis>;
  lineResets: Array<LineReset>;
  number?: Maybe<Number>;
  numbers: Array<Number>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  /** Partner account information */
  partner: Partner;
  pdf: Pdf;
  pdfs: Array<Pdf>;
  placeAutocomplete: Array<AutocompleteType>;
  placeDetails: PlaceType;
  porting?: Maybe<Porting>;
  portings: Array<Porting>;
  productCategories: Array<ProductCategory>;
  products: Array<Product>;
  provisions: Array<Provision>;
  recruitedPartners: Array<Partner>;
  trunk?: Maybe<Trunk>;
  trunks: Array<Trunk>;
};


export type QueryAccessArgs = {
  where: AccessWhereUniqueInput;
};


export type QueryAccessesArgs = {
  cursor?: InputMaybe<AccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccessWhereInput>;
};


export type QueryAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryAvailabilitiesArgs = {
  cursor?: InputMaybe<AvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AvailabilityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AvailabilityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AvailabilityWhereInput>;
};


export type QueryCdrsArgs = {
  cursor?: InputMaybe<CdrWhereUniqueInput>;
  distinct?: InputMaybe<Array<CdrScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CdrOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CdrWhereInput>;
};


export type QueryCdrsByDestinationArgs = {
  where?: InputMaybe<CdrWhereInput>;
};


export type QueryCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryDownloadFileArgs = {
  fileId: Scalars['Int']['input'];
};


export type QueryEkpsArgs = {
  cursor?: InputMaybe<EkpWhereUniqueInput>;
  distinct?: InputMaybe<Array<EkpScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EkpOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EkpWhereInput>;
};


export type QueryEthernetsArgs = {
  cursor?: InputMaybe<EthernetWhereUniqueInput>;
  distinct?: InputMaybe<Array<EthernetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EthernetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EthernetWhereInput>;
};


export type QueryIncidentArgs = {
  where: IncidentWhereUniqueInput;
};


export type QueryIncidentsArgs = {
  cursor?: InputMaybe<IncidentWhereUniqueInput>;
  distinct?: InputMaybe<Array<IncidentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IncidentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IncidentWhereInput>;
};


export type QueryLineDiagnosesArgs = {
  cursor?: InputMaybe<LineDiagnosisWhereUniqueInput>;
  distinct?: InputMaybe<Array<LineDiagnosisScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LineDiagnosisOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LineDiagnosisWhereInput>;
};


export type QueryLineDiagnosisArgs = {
  where: LineDiagnosisWhereUniqueInput;
};


export type QueryLineResetsArgs = {
  cursor?: InputMaybe<LineResetWhereUniqueInput>;
  distinct?: InputMaybe<Array<LineResetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LineResetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LineResetWhereInput>;
};


export type QueryNumberArgs = {
  where: NumberWhereUniqueInput;
};


export type QueryNumbersArgs = {
  cursor?: InputMaybe<NumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<NumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NumberWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryPdfArgs = {
  pdfInput: PdfInput;
};


export type QueryPdfsArgs = {
  pdfsInput: PdfsInput;
};


export type QueryPlaceAutocompleteArgs = {
  input: Scalars['String']['input'];
};


export type QueryPlaceDetailsArgs = {
  placeId: Scalars['String']['input'];
};


export type QueryPortingArgs = {
  where: PortingWhereUniqueInput;
};


export type QueryPortingsArgs = {
  cursor?: InputMaybe<PortingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingWhereInput>;
};


export type QueryProductCategoriesArgs = {
  cursor?: InputMaybe<ProductCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type QueryProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryProvisionsArgs = {
  cursor?: InputMaybe<ProvisionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProvisionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProvisionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProvisionWhereInput>;
};


export type QueryTrunkArgs = {
  where: TrunkWhereUniqueInput;
};


export type QueryTrunksArgs = {
  cursor?: InputMaybe<TrunkWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrunkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrunkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrunkWhereInput>;
};

export type ResultOrderComplete = {
  __typename?: 'ResultOrderComplete';
  success: Scalars['Boolean']['output'];
};

export type Sepa = {
  __typename?: 'Sepa';
  active: Scalars['Boolean']['output'];
  bic?: Maybe<Scalars['String']['output']>;
  business: Scalars['Boolean']['output'];
  creditInstitute: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  mandateRef: Scalars['String']['output'];
};

export type SepaCreateNestedOneWithoutCustomerInput = {
  connect?: InputMaybe<SepaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SepaCreateOrConnectWithoutCustomerInput>;
  create?: InputMaybe<SepaCreateWithoutCustomerInput>;
};

export type SepaCreateOrConnectWithoutCustomerInput = {
  create: SepaCreateWithoutCustomerInput;
  where: SepaWhereUniqueInput;
};

export type SepaCreateWithoutCustomerInput = {
  active: Scalars['Boolean']['input'];
  bic?: InputMaybe<Scalars['String']['input']>;
  business: Scalars['Boolean']['input'];
  creditInstitute: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  mandateRef: Scalars['String']['input'];
};

export type SepaNullableRelationFilter = {
  is?: InputMaybe<SepaWhereInput>;
  isNot?: InputMaybe<SepaWhereInput>;
};

export type SepaOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  bic?: InputMaybe<SortOrderInput>;
  business?: InputMaybe<SortOrder>;
  creditInstitute?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mandateRef?: InputMaybe<SortOrder>;
};

export type SepaUpdateOneWithoutCustomerNestedInput = {
  connect?: InputMaybe<SepaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SepaCreateOrConnectWithoutCustomerInput>;
  create?: InputMaybe<SepaCreateWithoutCustomerInput>;
  delete?: InputMaybe<SepaWhereInput>;
  disconnect?: InputMaybe<SepaWhereInput>;
  update?: InputMaybe<SepaUpdateToOneWithWhereWithoutCustomerInput>;
  upsert?: InputMaybe<SepaUpsertWithoutCustomerInput>;
};

export type SepaUpdateToOneWithWhereWithoutCustomerInput = {
  data: SepaUpdateWithoutCustomerInput;
  where?: InputMaybe<SepaWhereInput>;
};

export type SepaUpdateWithoutCustomerInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  business?: InputMaybe<BoolFieldUpdateOperationsInput>;
  creditInstitute?: InputMaybe<StringFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
  mandateRef?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SepaUpsertWithoutCustomerInput = {
  create: SepaCreateWithoutCustomerInput;
  update: SepaUpdateWithoutCustomerInput;
  where?: InputMaybe<SepaWhereInput>;
};

export type SepaWhereInput = {
  AND?: InputMaybe<Array<SepaWhereInput>>;
  NOT?: InputMaybe<Array<SepaWhereInput>>;
  OR?: InputMaybe<Array<SepaWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  bic?: InputMaybe<StringNullableFilter>;
  business?: InputMaybe<BoolFilter>;
  creditInstitute?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  iban?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  mandateRef?: InputMaybe<StringFilter>;
};

export type SepaWhereUniqueInput = {
  AND?: InputMaybe<Array<SepaWhereInput>>;
  NOT?: InputMaybe<Array<SepaWhereInput>>;
  OR?: InputMaybe<Array<SepaWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  bic?: InputMaybe<StringNullableFilter>;
  business?: InputMaybe<BoolFilter>;
  creditInstitute?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  iban?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mandateRef?: InputMaybe<StringFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Trunk = {
  __typename?: 'Trunk';
  _count?: Maybe<TrunkCount>;
  address: Address;
  addressId: Scalars['Int']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  cdrs: Array<Cdr>;
  channel: Scalars['Int']['output'];
  channelLoads: Array<TrunkChannelLoad>;
  clipNs: Scalars['Boolean']['output'];
  contacts?: Maybe<Scalars['String']['output']>;
  fallbackClip: Scalars['String']['output'];
  flatrateLandline: Scalars['Boolean']['output'];
  flatrateMobil: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  incidents: Array<Incident>;
  ip: Scalars['String']['output'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['output'];
  numbers: Array<Number>;
  online: Scalars['Boolean']['output'];
  orderNumbers: Array<OrderNumber>;
  orderTrunk: OrderTrunk;
  orderTrunkId: Scalars['Int']['output'];
  password: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  portings: Array<Porting>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  username: Scalars['String']['output'];
};


export type TrunkCdrsArgs = {
  cursor?: InputMaybe<CdrWhereUniqueInput>;
  distinct?: InputMaybe<Array<CdrScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CdrOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CdrWhereInput>;
};


export type TrunkChannelLoadsArgs = {
  cursor?: InputMaybe<TrunkChannelLoadWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrunkChannelLoadScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrunkChannelLoadOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrunkChannelLoadWhereInput>;
};


export type TrunkIncidentsArgs = {
  cursor?: InputMaybe<IncidentWhereUniqueInput>;
  distinct?: InputMaybe<Array<IncidentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IncidentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IncidentWhereInput>;
};


export type TrunkNumbersArgs = {
  cursor?: InputMaybe<NumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<NumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NumberWhereInput>;
};


export type TrunkOrderNumbersArgs = {
  cursor?: InputMaybe<OrderNumberWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNumberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNumberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type TrunkPortingsArgs = {
  cursor?: InputMaybe<PortingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PortingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PortingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortingWhereInput>;
};

export type TrunkChannelLoad = {
  __typename?: 'TrunkChannelLoad';
  date: Scalars['DateTimeISO']['output'];
  in: Scalars['Int']['output'];
  out: Scalars['Int']['output'];
  trunkId: Scalars['Int']['output'];
};

export type TrunkChannelLoadCreateManyTrunkInput = {
  date: Scalars['DateTimeISO']['input'];
  in: Scalars['Int']['input'];
  out: Scalars['Int']['input'];
};

export type TrunkChannelLoadCreateManyTrunkInputEnvelope = {
  data: Array<TrunkChannelLoadCreateManyTrunkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrunkChannelLoadCreateNestedManyWithoutTrunkInput = {
  connect?: InputMaybe<Array<TrunkChannelLoadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TrunkChannelLoadCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<TrunkChannelLoadCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<TrunkChannelLoadCreateManyTrunkInputEnvelope>;
};

export type TrunkChannelLoadCreateOrConnectWithoutTrunkInput = {
  create: TrunkChannelLoadCreateWithoutTrunkInput;
  where: TrunkChannelLoadWhereUniqueInput;
};

export type TrunkChannelLoadCreateWithoutTrunkInput = {
  date: Scalars['DateTimeISO']['input'];
  in: Scalars['Int']['input'];
  out: Scalars['Int']['input'];
};

export type TrunkChannelLoadListRelationFilter = {
  every?: InputMaybe<TrunkChannelLoadWhereInput>;
  none?: InputMaybe<TrunkChannelLoadWhereInput>;
  some?: InputMaybe<TrunkChannelLoadWhereInput>;
};

export type TrunkChannelLoadOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrunkChannelLoadOrderByWithRelationInput = {
  date?: InputMaybe<SortOrder>;
  in?: InputMaybe<SortOrder>;
  out?: InputMaybe<SortOrder>;
  trunk?: InputMaybe<TrunkOrderByWithRelationInput>;
  trunkId?: InputMaybe<SortOrder>;
};

export enum TrunkChannelLoadScalarFieldEnum {
  Date = 'date',
  In = 'in',
  Out = 'out',
  TrunkId = 'trunkId'
}

export type TrunkChannelLoadScalarWhereInput = {
  AND?: InputMaybe<Array<TrunkChannelLoadScalarWhereInput>>;
  NOT?: InputMaybe<Array<TrunkChannelLoadScalarWhereInput>>;
  OR?: InputMaybe<Array<TrunkChannelLoadScalarWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  in?: InputMaybe<IntFilter>;
  out?: InputMaybe<IntFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type TrunkChannelLoadTrunkIdDateCompoundUniqueInput = {
  date: Scalars['DateTimeISO']['input'];
  trunkId: Scalars['Int']['input'];
};

export type TrunkChannelLoadUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  in?: InputMaybe<IntFieldUpdateOperationsInput>;
  out?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrunkChannelLoadUpdateManyWithWhereWithoutTrunkInput = {
  data: TrunkChannelLoadUpdateManyMutationInput;
  where: TrunkChannelLoadScalarWhereInput;
};

export type TrunkChannelLoadUpdateManyWithoutTrunkNestedInput = {
  connect?: InputMaybe<Array<TrunkChannelLoadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TrunkChannelLoadCreateOrConnectWithoutTrunkInput>>;
  create?: InputMaybe<Array<TrunkChannelLoadCreateWithoutTrunkInput>>;
  createMany?: InputMaybe<TrunkChannelLoadCreateManyTrunkInputEnvelope>;
  delete?: InputMaybe<Array<TrunkChannelLoadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TrunkChannelLoadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TrunkChannelLoadWhereUniqueInput>>;
  set?: InputMaybe<Array<TrunkChannelLoadWhereUniqueInput>>;
  update?: InputMaybe<Array<TrunkChannelLoadUpdateWithWhereUniqueWithoutTrunkInput>>;
  updateMany?: InputMaybe<Array<TrunkChannelLoadUpdateManyWithWhereWithoutTrunkInput>>;
  upsert?: InputMaybe<Array<TrunkChannelLoadUpsertWithWhereUniqueWithoutTrunkInput>>;
};

export type TrunkChannelLoadUpdateWithWhereUniqueWithoutTrunkInput = {
  data: TrunkChannelLoadUpdateWithoutTrunkInput;
  where: TrunkChannelLoadWhereUniqueInput;
};

export type TrunkChannelLoadUpdateWithoutTrunkInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  in?: InputMaybe<IntFieldUpdateOperationsInput>;
  out?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrunkChannelLoadUpsertWithWhereUniqueWithoutTrunkInput = {
  create: TrunkChannelLoadCreateWithoutTrunkInput;
  update: TrunkChannelLoadUpdateWithoutTrunkInput;
  where: TrunkChannelLoadWhereUniqueInput;
};

export type TrunkChannelLoadWhereInput = {
  AND?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  NOT?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  OR?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  in?: InputMaybe<IntFilter>;
  out?: InputMaybe<IntFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
};

export type TrunkChannelLoadWhereUniqueInput = {
  AND?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  NOT?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  OR?: InputMaybe<Array<TrunkChannelLoadWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  in?: InputMaybe<IntFilter>;
  out?: InputMaybe<IntFilter>;
  trunk?: InputMaybe<TrunkRelationFilter>;
  trunkId?: InputMaybe<IntFilter>;
  trunkId_date?: InputMaybe<TrunkChannelLoadTrunkIdDateCompoundUniqueInput>;
};

export type TrunkCount = {
  __typename?: 'TrunkCount';
  cdrs: Scalars['Int']['output'];
  channelLoads: Scalars['Int']['output'];
  incidents: Scalars['Int']['output'];
  numbers: Scalars['Int']['output'];
  orderNumbers: Scalars['Int']['output'];
  portings: Scalars['Int']['output'];
};


export type TrunkCountCdrsArgs = {
  where?: InputMaybe<CdrWhereInput>;
};


export type TrunkCountChannelLoadsArgs = {
  where?: InputMaybe<TrunkChannelLoadWhereInput>;
};


export type TrunkCountIncidentsArgs = {
  where?: InputMaybe<IncidentWhereInput>;
};


export type TrunkCountNumbersArgs = {
  where?: InputMaybe<NumberWhereInput>;
};


export type TrunkCountOrderNumbersArgs = {
  where?: InputMaybe<OrderNumberWhereInput>;
};


export type TrunkCountPortingsArgs = {
  where?: InputMaybe<PortingWhereInput>;
};

export type TrunkCreateNestedOneWithoutCdrsInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<TrunkCreateWithoutCdrsInput>;
};

export type TrunkCreateNestedOneWithoutIncidentsInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<TrunkCreateWithoutIncidentsInput>;
};

export type TrunkCreateNestedOneWithoutNumbersInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutNumbersInput>;
  create?: InputMaybe<TrunkCreateWithoutNumbersInput>;
};

export type TrunkCreateNestedOneWithoutOrderNumbersInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutOrderNumbersInput>;
  create?: InputMaybe<TrunkCreateWithoutOrderNumbersInput>;
};

export type TrunkCreateNestedOneWithoutOrderTrunkInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutOrderTrunkInput>;
  create?: InputMaybe<TrunkCreateWithoutOrderTrunkInput>;
};

export type TrunkCreateNestedOneWithoutPortingsInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<TrunkCreateWithoutPortingsInput>;
};

export type TrunkCreateOrConnectWithoutCdrsInput = {
  create: TrunkCreateWithoutCdrsInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateOrConnectWithoutIncidentsInput = {
  create: TrunkCreateWithoutIncidentsInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateOrConnectWithoutNumbersInput = {
  create: TrunkCreateWithoutNumbersInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateOrConnectWithoutOrderNumbersInput = {
  create: TrunkCreateWithoutOrderNumbersInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateOrConnectWithoutOrderTrunkInput = {
  create: TrunkCreateWithoutOrderTrunkInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateOrConnectWithoutPortingsInput = {
  create: TrunkCreateWithoutPortingsInput;
  where: TrunkWhereUniqueInput;
};

export type TrunkCreateWithoutCdrsInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutTrunkInput>;
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  numbers?: InputMaybe<NumberCreateNestedManyWithoutTrunkInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutTrunkInput>;
  orderTrunk: OrderTrunkCreateNestedOneWithoutTrunkInput;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutTrunkInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkCreateWithoutIncidentsInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutTrunkInput>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  numbers?: InputMaybe<NumberCreateNestedManyWithoutTrunkInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutTrunkInput>;
  orderTrunk: OrderTrunkCreateNestedOneWithoutTrunkInput;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutTrunkInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkCreateWithoutNumbersInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutTrunkInput>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutTrunkInput>;
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutTrunkInput>;
  orderTrunk: OrderTrunkCreateNestedOneWithoutTrunkInput;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutTrunkInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkCreateWithoutOrderNumbersInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutTrunkInput>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutTrunkInput>;
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  numbers?: InputMaybe<NumberCreateNestedManyWithoutTrunkInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderTrunk: OrderTrunkCreateNestedOneWithoutTrunkInput;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutTrunkInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkCreateWithoutOrderTrunkInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutTrunkInput>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutTrunkInput>;
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  numbers?: InputMaybe<NumberCreateNestedManyWithoutTrunkInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutTrunkInput>;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  portings?: InputMaybe<PortingCreateNestedManyWithoutTrunkInput>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkCreateWithoutPortingsInput = {
  address: AddressCreateNestedOneWithoutTrunksInput;
  alias?: InputMaybe<Scalars['String']['input']>;
  cdrs?: InputMaybe<CdrCreateNestedManyWithoutTrunkInput>;
  channel: Scalars['Int']['input'];
  channelLoads?: InputMaybe<TrunkChannelLoadCreateNestedManyWithoutTrunkInput>;
  clipNs: Scalars['Boolean']['input'];
  contacts?: InputMaybe<Scalars['String']['input']>;
  fallbackClip: Scalars['String']['input'];
  flatrateLandline: Scalars['Boolean']['input'];
  flatrateMobil: Scalars['Boolean']['input'];
  incidents?: InputMaybe<IncidentCreateNestedManyWithoutTrunkInput>;
  ip: Scalars['String']['input'];
  mediaEncryption: MediaEncryption;
  numberExtension: Scalars['Int']['input'];
  numbers?: InputMaybe<NumberCreateNestedManyWithoutTrunkInput>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumbers?: InputMaybe<OrderNumberCreateNestedManyWithoutTrunkInput>;
  orderTrunk: OrderTrunkCreateNestedOneWithoutTrunkInput;
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username: Scalars['String']['input'];
};

export type TrunkNullableRelationFilter = {
  is?: InputMaybe<TrunkWhereInput>;
  isNot?: InputMaybe<TrunkWhereInput>;
};

export type TrunkOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrderInput>;
  cdrs?: InputMaybe<CdrOrderByRelationAggregateInput>;
  channel?: InputMaybe<SortOrder>;
  channelLoads?: InputMaybe<TrunkChannelLoadOrderByRelationAggregateInput>;
  clipNs?: InputMaybe<SortOrder>;
  contacts?: InputMaybe<SortOrderInput>;
  fallbackClip?: InputMaybe<SortOrder>;
  flatrateLandline?: InputMaybe<SortOrder>;
  flatrateMobil?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incidents?: InputMaybe<IncidentOrderByRelationAggregateInput>;
  ip?: InputMaybe<SortOrder>;
  mediaEncryption?: InputMaybe<SortOrder>;
  numberExtension?: InputMaybe<SortOrder>;
  numbers?: InputMaybe<NumberOrderByRelationAggregateInput>;
  online?: InputMaybe<SortOrder>;
  orderNumbers?: InputMaybe<OrderNumberOrderByRelationAggregateInput>;
  orderTrunk?: InputMaybe<OrderTrunkOrderByWithRelationInput>;
  orderTrunkId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  port?: InputMaybe<SortOrder>;
  portings?: InputMaybe<PortingOrderByRelationAggregateInput>;
  startDate?: InputMaybe<SortOrderInput>;
  username?: InputMaybe<SortOrder>;
};

export type TrunkRelationFilter = {
  is?: InputMaybe<TrunkWhereInput>;
  isNot?: InputMaybe<TrunkWhereInput>;
};

export enum TrunkScalarFieldEnum {
  AddressId = 'addressId',
  Alias = 'alias',
  Channel = 'channel',
  ClipNs = 'clipNs',
  Contacts = 'contacts',
  FallbackClip = 'fallbackClip',
  FlatrateLandline = 'flatrateLandline',
  FlatrateMobil = 'flatrateMobil',
  Id = 'id',
  Ip = 'ip',
  MediaEncryption = 'mediaEncryption',
  NumberExtension = 'numberExtension',
  Online = 'online',
  OrderTrunkId = 'orderTrunkId',
  Password = 'password',
  Port = 'port',
  StartDate = 'startDate',
  Username = 'username'
}

export type TrunkUpdateInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateOneRequiredWithoutCdrsNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutCdrsInput>;
  create?: InputMaybe<TrunkCreateWithoutCdrsInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutCdrsInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutCdrsInput>;
};

export type TrunkUpdateOneRequiredWithoutNumbersNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutNumbersInput>;
  create?: InputMaybe<TrunkCreateWithoutNumbersInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutNumbersInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutNumbersInput>;
};

export type TrunkUpdateOneWithoutIncidentsNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutIncidentsInput>;
  create?: InputMaybe<TrunkCreateWithoutIncidentsInput>;
  delete?: InputMaybe<TrunkWhereInput>;
  disconnect?: InputMaybe<TrunkWhereInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutIncidentsInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutIncidentsInput>;
};

export type TrunkUpdateOneWithoutOrderNumbersNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutOrderNumbersInput>;
  create?: InputMaybe<TrunkCreateWithoutOrderNumbersInput>;
  delete?: InputMaybe<TrunkWhereInput>;
  disconnect?: InputMaybe<TrunkWhereInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutOrderNumbersInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutOrderNumbersInput>;
};

export type TrunkUpdateOneWithoutOrderTrunkNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutOrderTrunkInput>;
  create?: InputMaybe<TrunkCreateWithoutOrderTrunkInput>;
  delete?: InputMaybe<TrunkWhereInput>;
  disconnect?: InputMaybe<TrunkWhereInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutOrderTrunkInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutOrderTrunkInput>;
};

export type TrunkUpdateOneWithoutPortingsNestedInput = {
  connect?: InputMaybe<TrunkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrunkCreateOrConnectWithoutPortingsInput>;
  create?: InputMaybe<TrunkCreateWithoutPortingsInput>;
  delete?: InputMaybe<TrunkWhereInput>;
  disconnect?: InputMaybe<TrunkWhereInput>;
  update?: InputMaybe<TrunkUpdateToOneWithWhereWithoutPortingsInput>;
  upsert?: InputMaybe<TrunkUpsertWithoutPortingsInput>;
};

export type TrunkUpdateToOneWithWhereWithoutCdrsInput = {
  data: TrunkUpdateWithoutCdrsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateToOneWithWhereWithoutIncidentsInput = {
  data: TrunkUpdateWithoutIncidentsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateToOneWithWhereWithoutNumbersInput = {
  data: TrunkUpdateWithoutNumbersInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateToOneWithWhereWithoutOrderNumbersInput = {
  data: TrunkUpdateWithoutOrderNumbersInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateToOneWithWhereWithoutOrderTrunkInput = {
  data: TrunkUpdateWithoutOrderTrunkInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateToOneWithWhereWithoutPortingsInput = {
  data: TrunkUpdateWithoutPortingsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpdateWithoutCdrsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateWithoutIncidentsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateWithoutNumbersInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateWithoutOrderNumbersInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateWithoutOrderTrunkInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  portings?: InputMaybe<PortingUpdateManyWithoutTrunkNestedInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpdateWithoutPortingsInput = {
  address?: InputMaybe<AddressUpdateOneRequiredWithoutTrunksNestedInput>;
  alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cdrs?: InputMaybe<CdrUpdateManyWithoutTrunkNestedInput>;
  channel?: InputMaybe<IntFieldUpdateOperationsInput>;
  channelLoads?: InputMaybe<TrunkChannelLoadUpdateManyWithoutTrunkNestedInput>;
  clipNs?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contacts?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackClip?: InputMaybe<StringFieldUpdateOperationsInput>;
  flatrateLandline?: InputMaybe<BoolFieldUpdateOperationsInput>;
  flatrateMobil?: InputMaybe<BoolFieldUpdateOperationsInput>;
  incidents?: InputMaybe<IncidentUpdateManyWithoutTrunkNestedInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFieldUpdateOperationsInput>;
  numberExtension?: InputMaybe<IntFieldUpdateOperationsInput>;
  numbers?: InputMaybe<NumberUpdateManyWithoutTrunkNestedInput>;
  online?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderNumbers?: InputMaybe<OrderNumberUpdateManyWithoutTrunkNestedInput>;
  orderTrunk?: InputMaybe<OrderTrunkUpdateOneRequiredWithoutTrunkNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrunkUpsertWithoutCdrsInput = {
  create: TrunkCreateWithoutCdrsInput;
  update: TrunkUpdateWithoutCdrsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpsertWithoutIncidentsInput = {
  create: TrunkCreateWithoutIncidentsInput;
  update: TrunkUpdateWithoutIncidentsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpsertWithoutNumbersInput = {
  create: TrunkCreateWithoutNumbersInput;
  update: TrunkUpdateWithoutNumbersInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpsertWithoutOrderNumbersInput = {
  create: TrunkCreateWithoutOrderNumbersInput;
  update: TrunkUpdateWithoutOrderNumbersInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpsertWithoutOrderTrunkInput = {
  create: TrunkCreateWithoutOrderTrunkInput;
  update: TrunkUpdateWithoutOrderTrunkInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkUpsertWithoutPortingsInput = {
  create: TrunkCreateWithoutPortingsInput;
  update: TrunkUpdateWithoutPortingsInput;
  where?: InputMaybe<TrunkWhereInput>;
};

export type TrunkWhereInput = {
  AND?: InputMaybe<Array<TrunkWhereInput>>;
  NOT?: InputMaybe<Array<TrunkWhereInput>>;
  OR?: InputMaybe<Array<TrunkWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  channel?: InputMaybe<IntFilter>;
  channelLoads?: InputMaybe<TrunkChannelLoadListRelationFilter>;
  clipNs?: InputMaybe<BoolFilter>;
  contacts?: InputMaybe<StringNullableFilter>;
  fallbackClip?: InputMaybe<StringFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  ip?: InputMaybe<StringFilter>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFilter>;
  numberExtension?: InputMaybe<IntFilter>;
  numbers?: InputMaybe<NumberListRelationFilter>;
  online?: InputMaybe<BoolFilter>;
  orderNumbers?: InputMaybe<OrderNumberListRelationFilter>;
  orderTrunk?: InputMaybe<OrderTrunkRelationFilter>;
  orderTrunkId?: InputMaybe<IntFilter>;
  password?: InputMaybe<StringFilter>;
  port?: InputMaybe<IntFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  username?: InputMaybe<StringFilter>;
};

export type TrunkWhereUniqueInput = {
  AND?: InputMaybe<Array<TrunkWhereInput>>;
  NOT?: InputMaybe<Array<TrunkWhereInput>>;
  OR?: InputMaybe<Array<TrunkWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  addressId?: InputMaybe<IntFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  cdrs?: InputMaybe<CdrListRelationFilter>;
  channel?: InputMaybe<IntFilter>;
  channelLoads?: InputMaybe<TrunkChannelLoadListRelationFilter>;
  clipNs?: InputMaybe<BoolFilter>;
  contacts?: InputMaybe<StringNullableFilter>;
  fallbackClip?: InputMaybe<StringFilter>;
  flatrateLandline?: InputMaybe<BoolFilter>;
  flatrateMobil?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidents?: InputMaybe<IncidentListRelationFilter>;
  ip?: InputMaybe<StringFilter>;
  mediaEncryption?: InputMaybe<EnumMediaEncryptionFilter>;
  numberExtension?: InputMaybe<IntFilter>;
  numbers?: InputMaybe<NumberListRelationFilter>;
  online?: InputMaybe<BoolFilter>;
  orderNumbers?: InputMaybe<OrderNumberListRelationFilter>;
  orderTrunk?: InputMaybe<OrderTrunkRelationFilter>;
  orderTrunkId?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<StringFilter>;
  port?: InputMaybe<IntFilter>;
  portings?: InputMaybe<PortingListRelationFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  username?: InputMaybe<StringFilter>;
};

export enum WbciGf {
  VaKueMrn = 'VA_KUE_MRN',
  VaKueOrn = 'VA_KUE_ORN',
  VaRrnp = 'VA_RRNP'
}

export enum WbciResult {
  Adf = 'ADF',
  Aif = 'AIF',
  Kni = 'KNI',
  Nat = 'NAT',
  Rng = 'RNG',
  Son = 'SON',
  Vae = 'VAE',
  Wai = 'WAI',
  Zwa = 'ZWA'
}

export enum WbciStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Draft = 'DRAFT',
  Placed = 'PLACED',
  Rejected = 'REJECTED',
  Tr = 'TR',
  VaSent = 'VA_SENT'
}

export type WbciTransaction = {
  __typename?: 'WbciTransaction';
  ada: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  desiredDate: Scalars['DateTimeISO']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  hno: Scalars['Int']['output'];
  hnoSuffix?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  portingId: Scalars['Int']['output'];
  status: WbciStatus;
  street: Scalars['String']['output'];
  switchingDate?: Maybe<Scalars['DateTimeISO']['output']>;
  wbciId: Scalars['String']['output'];
  wbciResultCode?: Maybe<WbciResult>;
  wbciResultDescription?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type WbciTransactionCreateManyPortingInput = {
  ada?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<WbciStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  wbciId: Scalars['String']['input'];
  wbciResultCode?: InputMaybe<WbciResult>;
  wbciResultDescription?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type WbciTransactionCreateManyPortingInputEnvelope = {
  data: Array<WbciTransactionCreateManyPortingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WbciTransactionCreateNestedManyWithoutPortingInput = {
  connect?: InputMaybe<Array<WbciTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WbciTransactionCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<WbciTransactionCreateWithoutPortingInput>>;
  createMany?: InputMaybe<WbciTransactionCreateManyPortingInputEnvelope>;
};

export type WbciTransactionCreateOrConnectWithoutPortingInput = {
  create: WbciTransactionCreateWithoutPortingInput;
  where: WbciTransactionWhereUniqueInput;
};

export type WbciTransactionCreateWithoutPortingInput = {
  ada?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  desiredDate: Scalars['DateTimeISO']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  hno: Scalars['Int']['input'];
  hnoSuffix?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<WbciStatus>;
  street: Scalars['String']['input'];
  switchingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  wbciId: Scalars['String']['input'];
  wbciResultCode?: InputMaybe<WbciResult>;
  wbciResultDescription?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type WbciTransactionListRelationFilter = {
  every?: InputMaybe<WbciTransactionWhereInput>;
  none?: InputMaybe<WbciTransactionWhereInput>;
  some?: InputMaybe<WbciTransactionWhereInput>;
};

export type WbciTransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WbciTransactionOrderByWithRelationInput = {
  ada?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  desiredDate?: InputMaybe<SortOrder>;
  firstname?: InputMaybe<SortOrderInput>;
  hno?: InputMaybe<SortOrder>;
  hnoSuffix?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  portingId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  switchingDate?: InputMaybe<SortOrderInput>;
  wbciId?: InputMaybe<SortOrder>;
  wbciResultCode?: InputMaybe<SortOrderInput>;
  wbciResultDescription?: InputMaybe<SortOrderInput>;
  zip?: InputMaybe<SortOrder>;
};

export enum WbciTransactionScalarFieldEnum {
  Ada = 'ada',
  City = 'city',
  CreatedAt = 'createdAt',
  DesiredDate = 'desiredDate',
  Firstname = 'firstname',
  Hno = 'hno',
  HnoSuffix = 'hnoSuffix',
  Id = 'id',
  Name = 'name',
  PortingId = 'portingId',
  Status = 'status',
  Street = 'street',
  SwitchingDate = 'switchingDate',
  WbciId = 'wbciId',
  WbciResultCode = 'wbciResultCode',
  WbciResultDescription = 'wbciResultDescription',
  Zip = 'zip'
}

export type WbciTransactionScalarWhereInput = {
  AND?: InputMaybe<Array<WbciTransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<WbciTransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<WbciTransactionScalarWhereInput>>;
  ada?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  portingId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumWbciStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  wbciId?: InputMaybe<StringFilter>;
  wbciResultCode?: InputMaybe<EnumWbciResultNullableFilter>;
  wbciResultDescription?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type WbciTransactionUpdateManyMutationInput = {
  ada?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumWbciStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  wbciId?: InputMaybe<StringFieldUpdateOperationsInput>;
  wbciResultCode?: InputMaybe<NullableEnumWbciResultFieldUpdateOperationsInput>;
  wbciResultDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WbciTransactionUpdateManyWithWhereWithoutPortingInput = {
  data: WbciTransactionUpdateManyMutationInput;
  where: WbciTransactionScalarWhereInput;
};

export type WbciTransactionUpdateManyWithoutPortingNestedInput = {
  connect?: InputMaybe<Array<WbciTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WbciTransactionCreateOrConnectWithoutPortingInput>>;
  create?: InputMaybe<Array<WbciTransactionCreateWithoutPortingInput>>;
  createMany?: InputMaybe<WbciTransactionCreateManyPortingInputEnvelope>;
  delete?: InputMaybe<Array<WbciTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WbciTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WbciTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<WbciTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<WbciTransactionUpdateWithWhereUniqueWithoutPortingInput>>;
  updateMany?: InputMaybe<Array<WbciTransactionUpdateManyWithWhereWithoutPortingInput>>;
  upsert?: InputMaybe<Array<WbciTransactionUpsertWithWhereUniqueWithoutPortingInput>>;
};

export type WbciTransactionUpdateWithWhereUniqueWithoutPortingInput = {
  data: WbciTransactionUpdateWithoutPortingInput;
  where: WbciTransactionWhereUniqueInput;
};

export type WbciTransactionUpdateWithoutPortingInput = {
  ada?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  desiredDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hno?: InputMaybe<IntFieldUpdateOperationsInput>;
  hnoSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumWbciStatusFieldUpdateOperationsInput>;
  street?: InputMaybe<StringFieldUpdateOperationsInput>;
  switchingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  wbciId?: InputMaybe<StringFieldUpdateOperationsInput>;
  wbciResultCode?: InputMaybe<NullableEnumWbciResultFieldUpdateOperationsInput>;
  wbciResultDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WbciTransactionUpsertWithWhereUniqueWithoutPortingInput = {
  create: WbciTransactionCreateWithoutPortingInput;
  update: WbciTransactionUpdateWithoutPortingInput;
  where: WbciTransactionWhereUniqueInput;
};

export type WbciTransactionWhereInput = {
  AND?: InputMaybe<Array<WbciTransactionWhereInput>>;
  NOT?: InputMaybe<Array<WbciTransactionWhereInput>>;
  OR?: InputMaybe<Array<WbciTransactionWhereInput>>;
  ada?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  portingId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumWbciStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  wbciId?: InputMaybe<StringFilter>;
  wbciResultCode?: InputMaybe<EnumWbciResultNullableFilter>;
  wbciResultDescription?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type WbciTransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<WbciTransactionWhereInput>>;
  NOT?: InputMaybe<Array<WbciTransactionWhereInput>>;
  OR?: InputMaybe<Array<WbciTransactionWhereInput>>;
  ada?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  desiredDate?: InputMaybe<DateTimeFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  hno?: InputMaybe<IntFilter>;
  hnoSuffix?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  portingId?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumWbciStatusFilter>;
  street?: InputMaybe<StringFilter>;
  switchingDate?: InputMaybe<DateTimeNullableFilter>;
  wbciId?: InputMaybe<Scalars['String']['input']>;
  wbciResultCode?: InputMaybe<EnumWbciResultNullableFilter>;
  wbciResultDescription?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type CreateOneIncidentMutationVariables = Exact<{
  data: IncidentCreateInput;
}>;


export type CreateOneIncidentMutation = { __typename?: 'Mutation', createOneIncident: { __typename?: 'Incident', id: number } };

export type CreateOneAddressMutationVariables = Exact<{
  data: AddressCreateInput;
}>;


export type CreateOneAddressMutation = { __typename?: 'Mutation', createOneAddress: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string } };

export type AddressesQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddressesQuery = { __typename?: 'Query', addresses: Array<{ __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string }> };

export type ChangePwMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
}>;


export type ChangePwMutation = { __typename?: 'Mutation', changePW: { __typename?: 'ChangePWResponse', success: boolean } };

export type EkPsQueryVariables = Exact<{ [key: string]: never; }>;


export type EkPsQuery = { __typename?: 'Query', ekps: Array<{ __typename?: 'Ekp', id: number, name: string, favorite: boolean }> };

export type UploadFilesMutationVariables = Exact<{
  fileInput: FileInput;
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', uploadFiles: Array<{ __typename?: 'File', name: string }> };

export type DownloadFileQueryVariables = Exact<{
  fileId: Scalars['Int']['input'];
}>;


export type DownloadFileQuery = { __typename?: 'Query', downloadFile: { __typename?: 'Pdf', fileName: string, base64EncodedPdf: string } };

export type AuthenticateMutationVariables = Exact<{
  data: AuthenticationInput;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticationResponse', jwt?: string | null, success: boolean } };

export type AuthenticateAsPartnerMutationVariables = Exact<{
  partnerId: Scalars['Int']['input'];
}>;


export type AuthenticateAsPartnerMutation = { __typename?: 'Mutation', authenticateAsPartner: { __typename?: 'AuthenticationResponse', success: boolean, jwt?: string | null } };

export type PdfQueryVariables = Exact<{
  pdfInput: PdfInput;
}>;


export type PdfQuery = { __typename?: 'Query', pdf: { __typename?: 'Pdf', base64EncodedPdf: string, fileName: string } };

export type PdfsQueryVariables = Exact<{
  pdfsInput: PdfsInput;
}>;


export type PdfsQuery = { __typename?: 'Query', pdfs: Array<{ __typename?: 'Pdf', base64EncodedPdf: string, fileName: string }> };

export type PdfToImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type PdfToImageMutation = { __typename?: 'Mutation', PdfToImage: { __typename?: 'Image', base64EncodedImage: string } };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: number, name: string, priceSetup: number, priceMonth: number, productCategoryId: number }> };

export type TrunkSelectQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrunkSelectQuery = { __typename?: 'Query', trunks: Array<{ __typename?: 'Trunk', id: number, alias?: string | null, address: { __typename?: 'Address', street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', name: string } } }> };

export type AccessQueryVariables = Exact<{
  accessId: Scalars['Int']['input'];
}>;


export type AccessQuery = { __typename?: 'Query', access?: { __typename?: 'Access', startDate?: string | Date | null, id: number, alias?: string | null, username: string, password: string, vlan?: number | null, ip: string, route?: string | null, online: boolean, incidents: Array<{ __typename?: 'Incident', id: number, createdAt: string | Date, closed?: string | Date | null }>, dialups: Array<{ __typename?: 'AccessDialup', date: string | Date, lns: number, success: boolean }>, traffics: Array<{ __typename?: 'AccessTraffic', date: string | Date, kbytesIn: any, kbytesOut: any }>, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', id: number, usernamePrefix?: string | null, usernameSuffix?: string | null, supportLineDiagnose: boolean, supportLineReset: boolean, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, product: { __typename?: 'Product', id: number, name: string, priceMonth: number, description: string } }, orderAccess: { __typename?: 'OrderAccess', id: number, status: OrderAccessStatus } } | null };

export type AccessCommonFragment = { __typename?: 'Access', id: number, alias?: string | null, username: string, password: string, vlan?: number | null, ip: string, route?: string | null, online: boolean, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', id: number, usernamePrefix?: string | null, usernameSuffix?: string | null, supportLineDiagnose: boolean, supportLineReset: boolean, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, product: { __typename?: 'Product', id: number, name: string, priceMonth: number, description: string } }, orderAccess: { __typename?: 'OrderAccess', id: number, status: OrderAccessStatus } };

export type AccessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessesQuery = { __typename?: 'Query', accesses: Array<{ __typename?: 'Access', id: number, alias?: string | null, username: string, password: string, vlan?: number | null, ip: string, route?: string | null, online: boolean, openIncidents: Array<{ __typename?: 'Incident', id: number }>, openLineResets: Array<{ __typename?: 'LineReset', id: number }>, openLineDiagnoses: Array<{ __typename?: 'LineDiagnosis', id: number }>, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', id: number, usernamePrefix?: string | null, usernameSuffix?: string | null, supportLineDiagnose: boolean, supportLineReset: boolean, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, product: { __typename?: 'Product', id: number, name: string, priceMonth: number, description: string } }, orderAccess: { __typename?: 'OrderAccess', id: number, status: OrderAccessStatus } }> };

export type CreateOneLineResetMutationVariables = Exact<{
  data: LineResetCreateInput;
}>;


export type CreateOneLineResetMutation = { __typename?: 'Mutation', createOneLineReset: { __typename?: 'LineReset', id: number } };

export type CreateOneLineDiagnosisMutationVariables = Exact<{
  data: LineDiagnosisCreateInput;
}>;


export type CreateOneLineDiagnosisMutation = { __typename?: 'Mutation', createOneLineDiagnosis: { __typename?: 'LineDiagnosis', id: number } };

export type CustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomersQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: number, no?: number | null, name: string, status: CustomerStatus, addresses: Array<{ __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, city: string, postalCode: string, contactPerson: string, email: string, phone: string, isBilling: boolean }> }> };

export type CustomerQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: number, name: string, no?: number | null, status: CustomerStatus, addresses: Array<{ __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, city: string, postalCode: string, isBilling: boolean }>, contacts: Array<{ __typename?: 'Contact', id: number, firstname: string, lastname: string, email: string, phone: string }> } | null, orders: Array<{ __typename?: 'Order', id: number, createdAt: string | Date, signedAt?: string | Date | null, status: OrderStatus, accesses: Array<{ __typename?: 'OrderAccess', id: number, product: { __typename?: 'Product', priceMonth: number } }>, trunks: Array<{ __typename?: 'OrderTrunk', id: number }>, portings: Array<{ __typename?: 'Porting', id: number }> }>, accesses: Array<{ __typename?: 'Access', id: number, alias?: string | null, online: boolean, carrierProduct: { __typename?: 'CarrierProduct', carrier: { __typename?: 'Carrier', name: string, itu: string }, product: { __typename?: 'Product', name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, city: string, postalCode: string } }>, trunks: Array<{ __typename?: 'Trunk', id: number, alias?: string | null, online: boolean, channel: number, flatrateLandline: boolean, flatrateMobil: boolean, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, city: string, postalCode: string } }>, ethernets: Array<{ __typename?: 'Ethernet', id: number, vlanId: number, carrierProduct: { __typename?: 'CarrierProduct', carrier: { __typename?: 'Carrier', name: string, itu: string }, product: { __typename?: 'Product', name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, city: string, postalCode: string } }> };

export type CreateOneCustomerMutationVariables = Exact<{
  data: CustomerCreateInput;
}>;


export type CreateOneCustomerMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'Customer', id: number } };

export type UpdateOneCustomerMutationVariables = Exact<{
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
}>;


export type UpdateOneCustomerMutation = { __typename?: 'Mutation', updateOneCustomer?: { __typename?: 'Customer', id: number } | null };

export type DeleteOneCustomerMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type DeleteOneCustomerMutation = { __typename?: 'Mutation', deleteOneCustomer?: { __typename?: 'Customer', id: number } | null };

export type DashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardDataQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', createdAt: string | Date, customer: { __typename?: 'Customer', id: number, name: string }, accesses: Array<{ __typename?: 'OrderAccess', id: number, product: { __typename?: 'Product', priceMonth: number } }>, trunks: Array<{ __typename?: 'OrderTrunk', id: number }>, numbers: Array<{ __typename?: 'OrderNumber', id: number }>, portings: Array<{ __typename?: 'Porting', id: number, name: string, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, switchingDate?: string | Date | null, numbers: Array<{ __typename?: 'PortingNumber', number: string }>, ekpAbg: { __typename?: 'Ekp', name: string } }> }>, incidents: Array<{ __typename?: 'Incident', id: number }>, accesses: Array<{ __typename?: 'Access', online: boolean, startDate?: string | Date | null, orderAccess: { __typename?: 'OrderAccess', status: OrderAccessStatus } }>, trunks: Array<{ __typename?: 'Trunk', online: boolean, startDate?: string | Date | null, orderTrunk: { __typename?: 'OrderTrunk', status: OrderStatus } }>, provisions: Array<{ __typename?: 'Provision', date: string | Date, amount: number }> };

export type PartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerQuery = { __typename?: 'Query', partner: { __typename?: 'Partner', id: number, newsClosed: boolean, hasRecruitedPartners: boolean } };

export type NewsClosedMutationVariables = Exact<{ [key: string]: never; }>;


export type NewsClosedMutation = { __typename?: 'Mutation', newsShown: { __typename?: 'Partner', id: number } };

export type AvailabilityFragment = { __typename?: 'Availability', id: number, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, createdAt: string | Date, completed: boolean, availabilityCarrier: Array<{ __typename?: 'AvailabilityCarrier', connectionType: ConnectionType, setupDuration?: number | null, maxDownstream?: number | null, maxUpstream?: number | null, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, availabilityProducts: Array<{ __typename?: 'AvailabilityProduct', id: number, available: boolean, carrierProduct: { __typename?: 'CarrierProduct', id: number, name: string, product: { __typename?: 'Product', id: number, name: string, description: string, priceMonth: number, priceSetup: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string } } } }>, availabilityReplicate?: { __typename?: 'AvailabilityReplicate', bauHcStart?: string | Date | null, bauHcEnd?: string | Date | null, constructionStatus: ConstructionStatus, householdCount?: number | null, companyCount?: number | null, localExchangeSize?: LocalExchangeSize | null, onkz?: number | null, asb?: number | null, technology?: ConstructionTechnology | null, landlordApproval?: LandlordApproval | null } | null }> };

export type AvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityQuery = { __typename?: 'Query', availabilities: Array<{ __typename?: 'Availability', id: number, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, createdAt: string | Date, completed: boolean, availabilityCarrier: Array<{ __typename?: 'AvailabilityCarrier', connectionType: ConnectionType, setupDuration?: number | null, maxDownstream?: number | null, maxUpstream?: number | null, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, availabilityProducts: Array<{ __typename?: 'AvailabilityProduct', id: number, available: boolean, carrierProduct: { __typename?: 'CarrierProduct', id: number, name: string, product: { __typename?: 'Product', id: number, name: string, description: string, priceMonth: number, priceSetup: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string } } } }>, availabilityReplicate?: { __typename?: 'AvailabilityReplicate', bauHcStart?: string | Date | null, bauHcEnd?: string | Date | null, constructionStatus: ConstructionStatus, householdCount?: number | null, companyCount?: number | null, localExchangeSize?: LocalExchangeSize | null, onkz?: number | null, asb?: number | null, technology?: ConstructionTechnology | null, landlordApproval?: LandlordApproval | null } | null }> }> };

export type ResearchAvailabilityMutationVariables = Exact<{
  location: LocationInput;
}>;


export type ResearchAvailabilityMutation = { __typename?: 'Mutation', researchAvailability: { __typename?: 'Availability', id: number, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, createdAt: string | Date, completed: boolean, availabilityCarrier: Array<{ __typename?: 'AvailabilityCarrier', connectionType: ConnectionType, setupDuration?: number | null, maxDownstream?: number | null, maxUpstream?: number | null, carrier: { __typename?: 'Carrier', id: number, itu: string, name: string }, availabilityProducts: Array<{ __typename?: 'AvailabilityProduct', id: number, available: boolean, carrierProduct: { __typename?: 'CarrierProduct', id: number, name: string, product: { __typename?: 'Product', id: number, name: string, description: string, priceMonth: number, priceSetup: number, productCategory: { __typename?: 'ProductCategory', id: number, name: string } } } }>, availabilityReplicate?: { __typename?: 'AvailabilityReplicate', bauHcStart?: string | Date | null, bauHcEnd?: string | Date | null, constructionStatus: ConstructionStatus, householdCount?: number | null, companyCount?: number | null, localExchangeSize?: LocalExchangeSize | null, onkz?: number | null, asb?: number | null, technology?: ConstructionTechnology | null, landlordApproval?: LandlordApproval | null } | null }> } };

export type PlacesAutocompleteQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type PlacesAutocompleteQuery = { __typename?: 'Query', placeAutocomplete: Array<{ __typename?: 'AutocompleteType', placeId: string, description: string }> };

export type PlaceDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type PlaceDetailsQuery = { __typename?: 'Query', placeDetails: { __typename?: 'PlaceType', placeId: string, street: string, no: number, noAdditional: string, zip: string, city: string } };

export type OrderCompleteMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  accesses: Array<AccessOrderCompleteType> | AccessOrderCompleteType;
  portings: Array<PortingOrderCompleteType> | PortingOrderCompleteType;
}>;


export type OrderCompleteMutation = { __typename?: 'Mutation', completeOrder: { __typename?: 'ResultOrderComplete', success: boolean } };

export type CreateOneOrderMutationVariables = Exact<{
  data: OrderCreateInput;
}>;


export type CreateOneOrderMutation = { __typename?: 'Mutation', createOneOrder: { __typename?: 'Order', id: number } };

export type PortingDetailsQueryVariables = Exact<{
  portingId: Scalars['Int']['input'];
}>;


export type PortingDetailsQuery = { __typename?: 'Query', porting?: { __typename?: 'Porting', id: number, alias?: string | null, firstname?: string | null, name: string, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, desiredDate: string | Date, switchingDate?: string | Date | null, onkz: string, status: PortingStatus, wbciGf: WbciGf, order: { __typename?: 'Order', id: number, createdAt: string | Date, customer: { __typename?: 'Customer', id: number, name: string } }, ekpAbg: { __typename?: 'Ekp', id: number, name: string, itu?: string | null }, accessProduct?: { __typename?: 'Product', id: number, name: string, productCategory: { __typename?: 'ProductCategory', id: number, name: string } } | null, singleNumbers: Array<{ __typename?: 'PortingNumber', id: number, number: string }>, blockNumbers: Array<{ __typename?: 'PortingNumber', id: number, number: string, ddi?: string | null, ddiFrom?: string | null, ddiTo?: string | null }>, updates: Array<{ __typename?: 'PortingUpdate', id: number, message: string, createdAt: string | Date }>, wbciTransactions: Array<{ __typename?: 'WbciTransaction', id: number, wbciId: string, wbciResultCode?: WbciResult | null, wbciResultDescription?: string | null, ada: boolean, desiredDate: string | Date, status: WbciStatus }> } | null };

export type PortingsQueryVariables = Exact<{
  where?: InputMaybe<PortingWhereInput>;
}>;


export type PortingsQuery = { __typename?: 'Query', portings: Array<{ __typename?: 'Porting', id: number, firstname?: string | null, name: string, street: string, hno: number, hnoSuffix?: string | null, city: string, switchingDate?: string | Date | null, onkz: string, status: PortingStatus, order: { __typename?: 'Order', id: number, createdAt: string | Date, customer: { __typename?: 'Customer', id: number, name: string } }, numbers: Array<{ __typename?: 'PortingNumber', number: string, ddiFrom?: string | null, ddiTo?: string | null }> }> };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: number, createdAt: string | Date, signedAt?: string | Date | null, status: OrderStatus, customer: { __typename?: 'Customer', id: number, name: string, sepa?: { __typename?: 'Sepa', id: number } | null }, accesses: Array<{ __typename?: 'OrderAccess', id: number }>, trunks: Array<{ __typename?: 'OrderTrunk', id: number }>, numbers: Array<{ __typename?: 'OrderNumber', id: number }>, portings: Array<{ __typename?: 'Porting', id: number }>, files: Array<{ __typename?: 'File', id: number, name: string }> }> };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, createdAt: string | Date, signedAt?: string | Date | null, completedAt?: string | Date | null, status: OrderStatus, misc?: string | null, customer: { __typename?: 'Customer', id: number, name: string }, updates: Array<{ __typename?: 'OrderUpdate', createdAt: string | Date, message: string }>, accesses: Array<{ __typename?: 'OrderAccess', id: number, status: OrderAccessStatus, alias?: string | null, product: { __typename?: 'Product', name: string, priceMonth: number, priceSetup: number, description: string, productCategoryId: number }, address: { __typename?: 'Address', street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string } }>, numbers: Array<{ __typename?: 'OrderNumber', id: number, blockSize?: number | null, status: OrderStatus, type: NumberType, trunk?: { __typename?: 'Trunk', address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string } } | null, orderTrunk?: { __typename?: 'OrderTrunk', address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string } } | null }>, trunks: Array<{ __typename?: 'OrderTrunk', id: number, alias?: string | null, channel: number, desiredDate?: string | Date | null, flatrateLandline: boolean, flatrateMobil: boolean, status: OrderStatus, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string } }>, portings: Array<{ __typename?: 'Porting', id: number, alias?: string | null, allNumbers: boolean, firstname?: string | null, name: string, street: string, hno: number, hnoSuffix?: string | null, zip: string, city: string, onkz: string, status: PortingStatus, switchingDate?: string | Date | null, terminate: boolean, ekpAbg: { __typename?: 'Ekp', itu?: string | null, name: string }, numbers: Array<{ __typename?: 'PortingNumber', id: number, ddiTo?: string | null, ddiFrom?: string | null, ddi?: string | null, number: string, pkiAbg?: string | null }> }> } | null };

export type UpdateOneOrderMutationVariables = Exact<{
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
}>;


export type UpdateOneOrderMutation = { __typename?: 'Mutation', updateOneOrder: { __typename?: 'Order', id: number, status: OrderStatus } };

export type RecruitedPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type RecruitedPartnersQuery = { __typename?: 'Query', recruitedPartners: Array<{ __typename?: 'Partner', id: number, username: string, email: string }> };

export type AddressBasicFragment = { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string };

export type AddressWithCustomerFragment = { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } };

export type ProductNameFragment = { __typename?: 'Product', id: number, name: string };

export type IncidentFragment = { __typename?: 'Incident', id: number, createdAt: string | Date, closed?: string | Date | null, access?: { __typename?: 'Access', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, ethernet?: { __typename?: 'Ethernet', id: number, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, trunk?: { __typename?: 'Trunk', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } | null };

export type IncidentsQueryVariables = Exact<{
  where?: InputMaybe<IncidentWhereInput>;
}>;


export type IncidentsQuery = { __typename?: 'Query', incidents: Array<{ __typename?: 'Incident', id: number, createdAt: string | Date, closed?: string | Date | null, access?: { __typename?: 'Access', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, ethernet?: { __typename?: 'Ethernet', id: number, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, trunk?: { __typename?: 'Trunk', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } | null }> };

export type IncidentQueryVariables = Exact<{
  where: IncidentWhereUniqueInput;
}>;


export type IncidentQuery = { __typename?: 'Query', incident?: { __typename?: 'Incident', comment: string, technicianDate?: string | Date | null, id: number, createdAt: string | Date, closed?: string | Date | null, lineReset?: { __typename?: 'LineReset', id: number, createdAt: string | Date } | null, lineDiagnosis?: { __typename?: 'LineDiagnosis', id: number, createdAt: string | Date } | null, updates: Array<{ __typename?: 'IncidentUpdate', id: number, createdAt: string | Date, message: string }>, access?: { __typename?: 'Access', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, ethernet?: { __typename?: 'Ethernet', id: number, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, carrierProduct: { __typename?: 'CarrierProduct', product: { __typename?: 'Product', id: number, name: string } } } | null, trunk?: { __typename?: 'Trunk', id: number, username: string, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } | null } | null };

export type LineDiagnosisQueryVariables = Exact<{
  where: LineDiagnosisWhereUniqueInput;
}>;


export type LineDiagnosisQuery = { __typename?: 'Query', lineDiagnosis?: { __typename?: 'LineDiagnosis', result?: string | null, deviceIdentification?: string | null, wireLength?: number | null, lineTermination?: string | null, bitrateUp?: number | null, bitRateDown?: number | null, synced?: boolean | null, resistBE?: number | null, resistAE?: number | null, resistBA?: number | null, resistAB?: number | null, snrUp?: number | null, snrDown?: number | null, attenuationUp?: number | null, attenuationDown?: number | null, id: number, createdAt: string | Date, status: LineDiagnosisStatus, access: { __typename?: 'Access', id: number, username: string, carrierProduct: { __typename?: 'CarrierProduct', id: number, product: { __typename?: 'Product', id: number, name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } } | null };

export type LineDiagnosisCommonFragment = { __typename?: 'LineDiagnosis', id: number, createdAt: string | Date, status: LineDiagnosisStatus, access: { __typename?: 'Access', id: number, username: string, carrierProduct: { __typename?: 'CarrierProduct', id: number, product: { __typename?: 'Product', id: number, name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } };

export type LineDiagnosesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineDiagnosesQuery = { __typename?: 'Query', lineDiagnoses: Array<{ __typename?: 'LineDiagnosis', id: number, createdAt: string | Date, status: LineDiagnosisStatus, incident?: { __typename?: 'Incident', id: number } | null, access: { __typename?: 'Access', id: number, username: string, carrierProduct: { __typename?: 'CarrierProduct', id: number, product: { __typename?: 'Product', id: number, name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } } }> };

export type LineResetsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineResetsQuery = { __typename?: 'Query', lineResets: Array<{ __typename?: 'LineReset', id: number, createdAt: string | Date, completed: boolean, access: { __typename?: 'Access', id: number, username: string, carrierProduct: { __typename?: 'CarrierProduct', id: number, product: { __typename?: 'Product', id: number, name: string } }, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } } }, incident?: { __typename?: 'Incident', id: number } | null }> };

export type CdrsQueryVariables = Exact<{ [key: string]: never; }>;


export type CdrsQuery = { __typename?: 'Query', cdrs: Array<{ __typename?: 'Cdr', id: number, calldate: string | Date, direction: CdrDirection, localId: string, remoteId: string, duration: number, disposition: CdrDisposition, trunk: { __typename?: 'Trunk', id: number, alias?: string | null, address: { __typename?: 'Address', id: number, customer: { __typename?: 'Customer', id: number, name: string } } } }> };

export type NumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type NumbersQuery = { __typename?: 'Query', numbers: Array<{ __typename?: 'Number', id: number, number: string, ddiFrom?: string | null, ddiTo?: string | null, trunk: { __typename?: 'Trunk', id: number, address: { __typename?: 'Address', id: number, customer: { __typename?: 'Customer', id: number, name: string } } } }> };

export type NumberQueryVariables = Exact<{
  numberId: Scalars['Int']['input'];
}>;


export type NumberQuery = { __typename?: 'Query', number?: { __typename?: 'Number', id: number, number: string, ddiFrom?: string | null, ddiTo?: string | null, trunk: { __typename?: 'Trunk', id: number, address: { __typename?: 'Address', id: number, customer: { __typename?: 'Customer', id: number, name: string } } }, cdrs: Array<{ __typename?: 'Cdr', calldate: string | Date, direction: CdrDirection, localId: string, remoteId: string, duration: number, disposition: CdrDisposition }> } | null };

export type TrunkDetailsQueryVariables = Exact<{
  trunkId: Scalars['Int']['input'];
  cdrsWhere?: InputMaybe<CdrWhereInput>;
}>;


export type TrunkDetailsQuery = { __typename?: 'Query', trunk?: { __typename?: 'Trunk', id: number, alias?: string | null, online: boolean, username: string, password: string, ip: string, port: number, channel: number, flatrateLandline: boolean, flatrateMobil: boolean, contacts?: string | null, numbers: Array<{ __typename?: 'Number', id: number, number: string, ddiFrom?: string | null, ddiTo?: string | null }>, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, channelLoads: Array<{ __typename?: 'TrunkChannelLoad', date: string | Date, in: number, out: number }> } | null, cdrsByDestination: Array<{ __typename?: 'CdrByDestination', destination: string, minutes: number, rate: number }> };

export type UpdateOneTrunkMutationVariables = Exact<{
  data: TrunkUpdateInput;
  where: TrunkWhereUniqueInput;
}>;


export type UpdateOneTrunkMutation = { __typename?: 'Mutation', updateOneTrunk?: { __typename?: 'Trunk', id: number } | null };

export type TrunksQueryVariables = Exact<{ [key: string]: never; }>;


export type TrunksQuery = { __typename?: 'Query', trunks: Array<{ __typename?: 'Trunk', id: number, alias?: string | null, channel: number, flatrateLandline: boolean, flatrateMobil: boolean, online: boolean, address: { __typename?: 'Address', id: number, street: string, houseNumber: number, addressSuffix?: string | null, postalCode: string, city: string, customer: { __typename?: 'Customer', id: number, name: string } }, openIncidents: Array<{ __typename?: 'Incident', id: number }> }> };

export const AccessCommonFragmentDoc = gql`
    fragment AccessCommon on Access {
  id
  alias
  username
  password
  vlan
  ip
  route
  online
  address {
    id
    street
    houseNumber
    postalCode
    city
    customer {
      id
      name
    }
  }
  carrierProduct {
    id
    carrier {
      id
      itu
      name
    }
    product {
      id
      name
      priceMonth
      description
    }
    usernamePrefix
    usernameSuffix
    supportLineDiagnose
    supportLineReset
  }
  orderAccess {
    id
    status
  }
}
    `;
export const AvailabilityFragmentDoc = gql`
    fragment Availability on Availability {
  id
  street
  hno
  hnoSuffix
  zip
  city
  createdAt
  completed
  availabilityCarrier {
    carrier {
      id
      itu
      name
    }
    availabilityProducts(
      orderBy: [{carrierProduct: {product: {productCategoryId: asc}}}, {carrierProduct: {productId: asc}}]
    ) {
      id
      carrierProduct {
        id
        name
        product {
          id
          name
          description
          productCategory {
            id
            name
          }
          priceMonth
          priceSetup
        }
      }
      available
    }
    availabilityReplicate {
      bauHcStart
      bauHcEnd
      constructionStatus
      householdCount
      companyCount
      localExchangeSize
      onkz
      asb
      technology
      landlordApproval
    }
    connectionType
    setupDuration
    maxDownstream
    maxUpstream
  }
}
    `;
export const AddressBasicFragmentDoc = gql`
    fragment AddressBasic on Address {
  id
  street
  houseNumber
  addressSuffix
  postalCode
  city
}
    `;
export const AddressWithCustomerFragmentDoc = gql`
    fragment AddressWithCustomer on Address {
  ...AddressBasic
  customer {
    id
    name
  }
}
    ${AddressBasicFragmentDoc}`;
export const ProductNameFragmentDoc = gql`
    fragment ProductName on Product {
  id
  name
}
    `;
export const IncidentFragmentDoc = gql`
    fragment Incident on Incident {
  id
  createdAt
  closed
  access {
    id
    username
    address {
      ...AddressWithCustomer
    }
    carrierProduct {
      product {
        ...ProductName
      }
    }
  }
  ethernet {
    id
    address {
      ...AddressWithCustomer
    }
    carrierProduct {
      product {
        ...ProductName
      }
    }
  }
  trunk {
    id
    username
    address {
      ...AddressWithCustomer
    }
  }
}
    ${AddressWithCustomerFragmentDoc}
${ProductNameFragmentDoc}`;
export const LineDiagnosisCommonFragmentDoc = gql`
    fragment LineDiagnosisCommon on LineDiagnosis {
  id
  createdAt
  status
  access {
    id
    username
    carrierProduct {
      id
      product {
        id
        name
      }
    }
    address {
      ...AddressWithCustomer
    }
  }
}
    ${AddressWithCustomerFragmentDoc}`;
export const CreateOneIncidentDocument = gql`
    mutation CreateOneIncident($data: IncidentCreateInput!) {
  createOneIncident(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneIncidentGQL extends Apollo.Mutation<CreateOneIncidentMutation, CreateOneIncidentMutationVariables> {
    override document = CreateOneIncidentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneAddressDocument = gql`
    mutation CreateOneAddress($data: AddressCreateInput!) {
  createOneAddress(data: $data) {
    ...AddressBasic
  }
}
    ${AddressBasicFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneAddressGQL extends Apollo.Mutation<CreateOneAddressMutation, CreateOneAddressMutationVariables> {
    override document = CreateOneAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddressesDocument = gql`
    query addresses($customerId: Int) {
  addresses(where: {customerId: {equals: $customerId}}) {
    ...AddressBasic
  }
}
    ${AddressBasicFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddressesGQL extends Apollo.Query<AddressesQuery, AddressesQueryVariables> {
    override document = AddressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePwDocument = gql`
    mutation ChangePW($newPassword: String!) {
  changePW(data: {password: $newPassword}) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePwGQL extends Apollo.Mutation<ChangePwMutation, ChangePwMutationVariables> {
    override document = ChangePwDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EkPsDocument = gql`
    query EKPs {
  ekps {
    id
    name
    favorite
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EkPsGQL extends Apollo.Query<EkPsQuery, EkPsQueryVariables> {
    override document = EkPsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadFilesDocument = gql`
    mutation UploadFiles($fileInput: FileInput!) {
  uploadFiles(fileInput: $fileInput) {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFilesGQL extends Apollo.Mutation<UploadFilesMutation, UploadFilesMutationVariables> {
    override document = UploadFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadFileDocument = gql`
    query DownloadFile($fileId: Int!) {
  downloadFile(fileId: $fileId) {
    fileName
    base64EncodedPdf
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadFileGQL extends Apollo.Query<DownloadFileQuery, DownloadFileQueryVariables> {
    override document = DownloadFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthenticateDocument = gql`
    mutation Authenticate($data: AuthenticationInput!) {
  authenticate(data: $data) {
    jwt
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthenticateGQL extends Apollo.Mutation<AuthenticateMutation, AuthenticateMutationVariables> {
    override document = AuthenticateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthenticateAsPartnerDocument = gql`
    mutation AuthenticateAsPartner($partnerId: Int!) {
  authenticateAsPartner(partnerId: $partnerId) {
    success
    jwt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthenticateAsPartnerGQL extends Apollo.Mutation<AuthenticateAsPartnerMutation, AuthenticateAsPartnerMutationVariables> {
    override document = AuthenticateAsPartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PdfDocument = gql`
    query Pdf($pdfInput: PdfInput!) {
  pdf(pdfInput: $pdfInput) {
    base64EncodedPdf
    fileName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PdfGQL extends Apollo.Query<PdfQuery, PdfQueryVariables> {
    override document = PdfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PdfsDocument = gql`
    query Pdfs($pdfsInput: PdfsInput!) {
  pdfs(pdfsInput: $pdfsInput) {
    base64EncodedPdf
    fileName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PdfsGQL extends Apollo.Query<PdfsQuery, PdfsQueryVariables> {
    override document = PdfsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PdfToImageDocument = gql`
    mutation PdfToImage($file: Upload!) {
  PdfToImage(pdfToImageInput: {file: $file}) {
    base64EncodedImage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PdfToImageGQL extends Apollo.Mutation<PdfToImageMutation, PdfToImageMutationVariables> {
    override document = PdfToImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsDocument = gql`
    query Products {
  products(where: {bookable: {equals: true}}) {
    id
    name
    priceSetup
    priceMonth
    productCategoryId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsGQL extends Apollo.Query<ProductsQuery, ProductsQueryVariables> {
    override document = ProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrunkSelectDocument = gql`
    query TrunkSelect($customerId: Int) {
  trunks(where: {address: {is: {customerId: {equals: $customerId}}}}) {
    id
    alias
    address {
      street
      houseNumber
      addressSuffix
      postalCode
      city
      customer {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrunkSelectGQL extends Apollo.Query<TrunkSelectQuery, TrunkSelectQueryVariables> {
    override document = TrunkSelectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccessDocument = gql`
    query Access($accessId: Int!) {
  access(where: {id: $accessId}) {
    ...AccessCommon
    startDate
    incidents {
      id
      createdAt
      closed
    }
    dialups(take: 10, orderBy: {date: desc}) {
      date
      lns
      success
    }
    traffics(take: 720, orderBy: {date: desc}) {
      date
      kbytesIn
      kbytesOut
    }
  }
}
    ${AccessCommonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccessGQL extends Apollo.Query<AccessQuery, AccessQueryVariables> {
    override document = AccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccessesDocument = gql`
    query Accesses {
  accesses {
    ...AccessCommon
    openIncidents: incidents(where: {closed: null}) {
      id
    }
    openLineResets: lineResets(where: {completed: {equals: false}}) {
      id
    }
    openLineDiagnoses: lineDiagnoses(where: {result: null}) {
      id
    }
  }
}
    ${AccessCommonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccessesGQL extends Apollo.Query<AccessesQuery, AccessesQueryVariables> {
    override document = AccessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneLineResetDocument = gql`
    mutation CreateOneLineReset($data: LineResetCreateInput!) {
  createOneLineReset(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneLineResetGQL extends Apollo.Mutation<CreateOneLineResetMutation, CreateOneLineResetMutationVariables> {
    override document = CreateOneLineResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneLineDiagnosisDocument = gql`
    mutation CreateOneLineDiagnosis($data: LineDiagnosisCreateInput!) {
  createOneLineDiagnosis(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneLineDiagnosisGQL extends Apollo.Mutation<CreateOneLineDiagnosisMutation, CreateOneLineDiagnosisMutationVariables> {
    override document = CreateOneLineDiagnosisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomersDocument = gql`
    query Customers {
  customers {
    id
    no
    name
    status
    addresses(where: {isBilling: {equals: true}}) {
      id
      street
      houseNumber
      addressSuffix
      city
      postalCode
      contactPerson
      email
      phone
      isBilling
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomersGQL extends Apollo.Query<CustomersQuery, CustomersQueryVariables> {
    override document = CustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerDocument = gql`
    query Customer($customerId: Int!) {
  customer(where: {id: $customerId}) {
    id
    name
    no
    status
    addresses {
      id
      street
      houseNumber
      addressSuffix
      city
      postalCode
      isBilling
    }
    contacts {
      id
      firstname
      lastname
      email
      phone
    }
  }
  orders(where: {customer: {is: {id: {equals: $customerId}}}}) {
    id
    createdAt
    signedAt
    status
    accesses {
      id
      product {
        priceMonth
      }
    }
    trunks {
      id
    }
    portings {
      id
    }
  }
  accesses(where: {address: {is: {customer: {is: {id: {equals: $customerId}}}}}}) {
    id
    alias
    online
    carrierProduct {
      carrier {
        name
        itu
      }
      product {
        name
      }
    }
    address {
      id
      street
      houseNumber
      addressSuffix
      city
      postalCode
    }
  }
  trunks(where: {address: {is: {customer: {is: {id: {equals: $customerId}}}}}}) {
    id
    alias
    online
    channel
    flatrateLandline
    flatrateMobil
    address {
      id
      street
      houseNumber
      addressSuffix
      city
      postalCode
    }
  }
  ethernets(where: {address: {is: {customer: {is: {id: {equals: $customerId}}}}}}) {
    id
    vlanId
    carrierProduct {
      carrier {
        name
        itu
      }
      product {
        name
      }
    }
    address {
      id
      street
      houseNumber
      addressSuffix
      city
      postalCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerGQL extends Apollo.Query<CustomerQuery, CustomerQueryVariables> {
    override document = CustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneCustomerDocument = gql`
    mutation CreateOneCustomer($data: CustomerCreateInput!) {
  createOneCustomer(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneCustomerGQL extends Apollo.Mutation<CreateOneCustomerMutation, CreateOneCustomerMutationVariables> {
    override document = CreateOneCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOneCustomerDocument = gql`
    mutation UpdateOneCustomer($data: CustomerUpdateInput!, $where: CustomerWhereUniqueInput!) {
  updateOneCustomer(data: $data, where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOneCustomerGQL extends Apollo.Mutation<UpdateOneCustomerMutation, UpdateOneCustomerMutationVariables> {
    override document = UpdateOneCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOneCustomerDocument = gql`
    mutation DeleteOneCustomer($customerId: Int!) {
  deleteOneCustomer(where: {id: $customerId}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOneCustomerGQL extends Apollo.Mutation<DeleteOneCustomerMutation, DeleteOneCustomerMutationVariables> {
    override document = DeleteOneCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardDataDocument = gql`
    query DashboardData {
  orders(where: {status: {equals: DRAFT}}) {
    createdAt
    customer {
      id
      name
    }
    accesses {
      id
      product {
        priceMonth
      }
    }
    trunks {
      id
    }
    numbers {
      id
    }
    portings {
      id
      name
      street
      hno
      hnoSuffix
      zip
      city
      numbers {
        number
      }
      switchingDate
      ekpAbg {
        name
      }
    }
  }
  incidents(where: {closed: null}) {
    id
  }
  accesses {
    online
    startDate
    orderAccess {
      status
    }
  }
  trunks {
    online
    startDate
    orderTrunk {
      status
    }
  }
  provisions(take: 12, orderBy: {date: desc}) {
    date
    amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardDataGQL extends Apollo.Query<DashboardDataQuery, DashboardDataQueryVariables> {
    override document = DashboardDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnerDocument = gql`
    query Partner {
  partner {
    id
    newsClosed
    hasRecruitedPartners
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnerGQL extends Apollo.Query<PartnerQuery, PartnerQueryVariables> {
    override document = PartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewsClosedDocument = gql`
    mutation NewsClosed {
  newsShown {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewsClosedGQL extends Apollo.Mutation<NewsClosedMutation, NewsClosedMutationVariables> {
    override document = NewsClosedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityDocument = gql`
    query Availability {
  availabilities(orderBy: {createdAt: desc}, take: 5) {
    ...Availability
  }
}
    ${AvailabilityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityGQL extends Apollo.Query<AvailabilityQuery, AvailabilityQueryVariables> {
    override document = AvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResearchAvailabilityDocument = gql`
    mutation ResearchAvailability($location: LocationInput!) {
  researchAvailability(location: $location) {
    ...Availability
  }
}
    ${AvailabilityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResearchAvailabilityGQL extends Apollo.Mutation<ResearchAvailabilityMutation, ResearchAvailabilityMutationVariables> {
    override document = ResearchAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlacesAutocompleteDocument = gql`
    query PlacesAutocomplete($input: String!) {
  placeAutocomplete(input: $input) {
    placeId
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlacesAutocompleteGQL extends Apollo.Query<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables> {
    override document = PlacesAutocompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlaceDetailsDocument = gql`
    query PlaceDetails($placeId: String!) {
  placeDetails(placeId: $placeId) {
    placeId
    street
    no
    noAdditional
    zip
    city
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlaceDetailsGQL extends Apollo.Query<PlaceDetailsQuery, PlaceDetailsQueryVariables> {
    override document = PlaceDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderCompleteDocument = gql`
    mutation OrderComplete($orderId: Float!, $accesses: [AccessOrderCompleteType!]!, $portings: [PortingOrderCompleteType!]!) {
  completeOrder(orderId: $orderId, accesses: $accesses, portings: $portings) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderCompleteGQL extends Apollo.Mutation<OrderCompleteMutation, OrderCompleteMutationVariables> {
    override document = OrderCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOneOrderDocument = gql`
    mutation CreateOneOrder($data: OrderCreateInput!) {
  createOneOrder(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOneOrderGQL extends Apollo.Mutation<CreateOneOrderMutation, CreateOneOrderMutationVariables> {
    override document = CreateOneOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortingDetailsDocument = gql`
    query PortingDetails($portingId: Int!) {
  porting(where: {id: $portingId}) {
    id
    alias
    order {
      id
      createdAt
      customer {
        id
        name
      }
    }
    firstname
    name
    street
    hno
    hnoSuffix
    zip
    city
    ekpAbg {
      id
      name
      itu
    }
    accessProduct {
      id
      name
      productCategory {
        id
        name
      }
    }
    desiredDate
    switchingDate
    onkz
    singleNumbers: numbers(where: {ddi: {equals: null}}) {
      id
      number
    }
    blockNumbers: numbers(where: {ddi: {not: {equals: null}}}) {
      id
      number
      ddi
      ddiFrom
      ddiTo
    }
    status
    wbciGf
    updates {
      id
      message
      createdAt
    }
    wbciTransactions {
      id
      wbciId
      wbciResultCode
      wbciResultDescription
      ada
      desiredDate
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortingDetailsGQL extends Apollo.Query<PortingDetailsQuery, PortingDetailsQueryVariables> {
    override document = PortingDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortingsDocument = gql`
    query Portings($where: PortingWhereInput) {
  portings(where: $where) {
    id
    firstname
    name
    street
    hno
    hnoSuffix
    city
    switchingDate
    order {
      id
      createdAt
      customer {
        id
        name
      }
    }
    onkz
    numbers {
      number
      ddiFrom
      ddiTo
    }
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortingsGQL extends Apollo.Query<PortingsQuery, PortingsQueryVariables> {
    override document = PortingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersDocument = gql`
    query Orders($where: OrderWhereInput) {
  orders(where: $where) {
    id
    createdAt
    signedAt
    customer {
      id
      name
      sepa {
        id
      }
    }
    accesses {
      id
    }
    trunks {
      id
    }
    numbers {
      id
    }
    portings {
      id
    }
    status
    files {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersGQL extends Apollo.Query<OrdersQuery, OrdersQueryVariables> {
    override document = OrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDocument = gql`
    query Order($orderId: Int!) {
  order(where: {id: $orderId}) {
    id
    customer {
      id
      name
    }
    createdAt
    signedAt
    completedAt
    status
    updates {
      createdAt
      message
    }
    accesses {
      id
      status
      alias
      product {
        name
        priceMonth
        priceSetup
        description
        productCategoryId
      }
      address {
        street
        houseNumber
        addressSuffix
        postalCode
        city
      }
    }
    misc
    numbers {
      id
      blockSize
      status
      type
      trunk {
        address {
          id
          street
          houseNumber
          addressSuffix
          postalCode
          city
        }
      }
      orderTrunk {
        address {
          id
          street
          houseNumber
          addressSuffix
          postalCode
          city
        }
      }
    }
    trunks {
      id
      alias
      address {
        id
        street
        houseNumber
        addressSuffix
        postalCode
        city
      }
      channel
      desiredDate
      flatrateLandline
      flatrateMobil
      status
    }
    portings {
      id
      alias
      allNumbers
      ekpAbg {
        itu
        name
      }
      firstname
      name
      street
      hno
      hnoSuffix
      zip
      city
      numbers {
        id
        ddiTo
        ddiFrom
        ddi
        number
        pkiAbg
      }
      onkz
      status
      switchingDate
      terminate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
    override document = OrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOneOrderDocument = gql`
    mutation UpdateOneOrder($data: OrderUpdateInput!, $where: OrderWhereUniqueInput!) {
  updateOneOrder(data: $data, where: $where) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOneOrderGQL extends Apollo.Mutation<UpdateOneOrderMutation, UpdateOneOrderMutationVariables> {
    override document = UpdateOneOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecruitedPartnersDocument = gql`
    query RecruitedPartners {
  recruitedPartners {
    id
    username
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RecruitedPartnersGQL extends Apollo.Query<RecruitedPartnersQuery, RecruitedPartnersQueryVariables> {
    override document = RecruitedPartnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncidentsDocument = gql`
    query Incidents($where: IncidentWhereInput) {
  incidents(where: $where) {
    ...Incident
  }
}
    ${IncidentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IncidentsGQL extends Apollo.Query<IncidentsQuery, IncidentsQueryVariables> {
    override document = IncidentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncidentDocument = gql`
    query Incident($where: IncidentWhereUniqueInput!) {
  incident(where: $where) {
    ...Incident
    comment
    technicianDate
    lineReset {
      id
      createdAt
    }
    lineDiagnosis {
      id
      createdAt
    }
    updates {
      id
      createdAt
      message
    }
  }
}
    ${IncidentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IncidentGQL extends Apollo.Query<IncidentQuery, IncidentQueryVariables> {
    override document = IncidentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineDiagnosisDocument = gql`
    query LineDiagnosis($where: LineDiagnosisWhereUniqueInput!) {
  lineDiagnosis(where: $where) {
    ...LineDiagnosisCommon
    result
    deviceIdentification
    wireLength
    lineTermination
    bitrateUp
    bitRateDown
    synced
    resistBE
    resistAE
    resistBA
    resistAB
    snrUp
    snrDown
    attenuationUp
    attenuationDown
  }
}
    ${LineDiagnosisCommonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LineDiagnosisGQL extends Apollo.Query<LineDiagnosisQuery, LineDiagnosisQueryVariables> {
    override document = LineDiagnosisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineDiagnosesDocument = gql`
    query LineDiagnoses {
  lineDiagnoses(orderBy: {createdAt: desc}) {
    ...LineDiagnosisCommon
    incident {
      id
    }
  }
}
    ${LineDiagnosisCommonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LineDiagnosesGQL extends Apollo.Query<LineDiagnosesQuery, LineDiagnosesQueryVariables> {
    override document = LineDiagnosesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineResetsDocument = gql`
    query LineResets {
  lineResets(orderBy: {createdAt: desc}) {
    id
    createdAt
    access {
      id
      username
      carrierProduct {
        id
        product {
          id
          name
        }
      }
      address {
        ...AddressWithCustomer
      }
    }
    incident {
      id
    }
    completed
  }
}
    ${AddressWithCustomerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LineResetsGQL extends Apollo.Query<LineResetsQuery, LineResetsQueryVariables> {
    override document = LineResetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CdrsDocument = gql`
    query Cdrs {
  cdrs(take: 1000, orderBy: {calldate: desc}) {
    id
    calldate
    direction
    localId
    remoteId
    duration
    disposition
    trunk {
      id
      alias
      address {
        id
        customer {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CdrsGQL extends Apollo.Query<CdrsQuery, CdrsQueryVariables> {
    override document = CdrsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NumbersDocument = gql`
    query Numbers {
  numbers {
    id
    number
    ddiFrom
    ddiTo
    trunk {
      id
      address {
        id
        customer {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NumbersGQL extends Apollo.Query<NumbersQuery, NumbersQueryVariables> {
    override document = NumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NumberDocument = gql`
    query Number($numberId: Int!) {
  number(where: {id: $numberId}) {
    id
    number
    ddiFrom
    ddiTo
    trunk {
      id
      address {
        id
        customer {
          id
          name
        }
      }
    }
    cdrs {
      calldate
      direction
      localId
      remoteId
      duration
      disposition
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NumberGQL extends Apollo.Query<NumberQuery, NumberQueryVariables> {
    override document = NumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrunkDetailsDocument = gql`
    query TrunkDetails($trunkId: Int!, $cdrsWhere: CdrWhereInput) {
  trunk(where: {id: $trunkId}) {
    id
    alias
    online
    username
    password
    ip
    port
    channel
    flatrateLandline
    flatrateMobil
    contacts
    numbers {
      id
      number
      ddiFrom
      ddiTo
    }
    address {
      ...AddressWithCustomer
    }
    channelLoads(orderBy: {date: desc}, take: 720) {
      date
      in
      out
    }
  }
  cdrsByDestination(where: $cdrsWhere) {
    destination
    minutes
    rate
  }
}
    ${AddressWithCustomerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TrunkDetailsGQL extends Apollo.Query<TrunkDetailsQuery, TrunkDetailsQueryVariables> {
    override document = TrunkDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOneTrunkDocument = gql`
    mutation UpdateOneTrunk($data: TrunkUpdateInput!, $where: TrunkWhereUniqueInput!) {
  updateOneTrunk(data: $data, where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOneTrunkGQL extends Apollo.Mutation<UpdateOneTrunkMutation, UpdateOneTrunkMutationVariables> {
    override document = UpdateOneTrunkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrunksDocument = gql`
    query Trunks {
  trunks {
    id
    alias
    channel
    flatrateLandline
    flatrateMobil
    online
    address {
      ...AddressWithCustomer
    }
    openIncidents: incidents(where: {closed: null}) {
      id
    }
  }
}
    ${AddressWithCustomerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TrunksGQL extends Apollo.Query<TrunksQuery, TrunksQueryVariables> {
    override document = TrunksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }